// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusManagementModal.css';

// const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);
//   // Cancellation Time State
// const [cancellationTime, setCancellationTime] = useState({
//   hours: 1,
//   minutes: 0
// });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Existing Images/Video
//   const [existingImages, setExistingImages] = useState([]);
//   const [existingVideo, setExistingVideo] = useState(null);
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // Initialize form with existing bus data
//   useEffect(() => {
//     if (bus) {
//       console.log('Loading bus data for edit:', bus);

//       // Basic Info
//       setForm({
//         busNumber: bus.busNumber || '',
//         busName: bus.busName || '',
//         busType: bus.busType || 'AC',
//         busCategory: bus.busCategory || 'Seater',
//         amenities: bus.amenities || []
//       });

//       // Trip Type
//       setTripType(bus.tripType || 'oneWay');

//       // Booking Closed Before
//       if (bus.bookingClosedBefore) {
//         setBookingClosedBefore(bus.bookingClosedBefore);
//       }

//       // Booking Closed Before
// if (bus.bookingClosedBefore) {
//   setBookingClosedBefore(bus.bookingClosedBefore);
// }

// // Cancellation Time - ADD THIS SECTION
// if (bus.cancellationTime) {
//   setCancellationTime(bus.cancellationTime);
//   console.log("Loaded cancellationTime:", bus.cancellationTime);
// } else {
//   // Default if not present
//   setCancellationTime({ hours: 1, minutes: 0 });
// }

// const handleCancellationTimeChange = (field, value) => {
//   setCancellationTime(prev => ({ 
//     ...prev, 
//     [field]: parseInt(value) || 0 
//   }));
// };

//       // Operating Days
//       if (bus.operatingDays && bus.operatingDays.length > 0) {
//         setOperatingDays(bus.operatingDays);
//       }

//       // Pricing
//       if (bus.fareDetails) {
//         setPricing({
//           basePrice: bus.fareDetails.basePrice || '',
//           baseDistance: bus.fareDetails.baseDistance || '',
//           costPerKm: bus.fareDetails.costPerKm || ''
//         });
//       }

//       // Images and Video
//       if (bus.images && bus.images.length > 0) {
//         setExistingImages(bus.images);
//       }
//       if (bus.video && bus.video.length > 0) {
//         setExistingVideo(bus.video[0]);
//       }

//       // Seat Configuration
//       if (bus.seatConfiguration) {
//         setSelectedConfiguration(bus.seatConfiguration.busType || '2*2');
//       }

//       // Seats - Convert existing seats to active seats and labels
//       if (bus.seats && bus.seats.length > 0) {
//         const activeSeatNumbers = bus.seats.filter(seat => seat.isAvailable !== false).map(seat => seat.seatNumber);
//         setActiveSeats(activeSeatNumbers);

//         const blockedSeatNumbers = bus.seats.filter(seat => seat.isBlocked === true).map(seat => seat.seatNumber);
//         setBlockedSeats(blockedSeatNumbers);

//         const seatLabels = {};
//         bus.seats.forEach(seat => {
//           seatLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
//         });
//         setCustomSeatLabels(seatLabels);
//       }

//       // Route and Fare Matrices
//       if (bus.routeSchedules && bus.routeSchedules.length > 0) {
//         const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//         const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//         if (upSchedule) {
//           setFareMatrixUp(upSchedule.fareMatrix || []);
//         }
//         if (downSchedule) {
//           setFareMatrixDown(downSchedule.fareMatrix || []);
//         }

//         // Set source and destination from first schedule
//         if (upSchedule && upSchedule.origin && upSchedule.destination) {
//           setSourceCity(upSchedule.origin.city || '');
//           setDestinationCity(upSchedule.destination.city || '');
//           setSelectedRoute({
//             _id: upSchedule.routeId,
//             routeName: upSchedule.routeName,
//             origin: upSchedule.origin,
//             destination: upSchedule.destination,
//             intermediateStops: upSchedule.intermediateStops || [],
//             returnJourney: downSchedule ? {
//               origin: downSchedule.origin,
//               destination: downSchedule.destination,
//               intermediateStops: downSchedule.intermediateStops || []
//             } : null
//           });
//         }
//       }
//     }
//   }, [bus]);

//   // Fetch routes based on source and destination
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }

//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         50,
//         '',
//         '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );

//       if (response && response.success && response.routes) {
//         setAvailableRoutes(response.routes);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity && !selectedRoute) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   useEffect(() => {
//     if (selectedConfiguration && form.busCategory) {
//       fetchLayouts(selectedConfiguration);
//     }
//   }, [selectedConfiguration, form.busCategory]);

//   // Replace your two useEffects that handle bus data loading with this single one:

//   useEffect(() => {
//     if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) return;

//     const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//     const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//     // Load fare matrices
//     if (upSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixUp(upSchedule.fareMatrix);
//     }
//     if (downSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixDown(downSchedule.fareMatrix);
//     }

//     // Reconstruct source/destination from fareMatrix rows
//     // UP matrix: first row fromName = origin, last toCells toName = destination
//     if (upSchedule?.fareMatrix?.length > 0) {
//       const upMatrix = upSchedule.fareMatrix;
//       const originName = upMatrix[0]?.fromName || '';

//       // Find the destination: the last non-null toCell in the first row
//       const firstRowCells = upMatrix[0]?.toCells || [];
//       const lastCell = [...firstRowCells].filter(Boolean).pop();
//       const destinationName = lastCell?.toName || '';

//       setSourceCity(originName);
//       setDestinationCity(destinationName);

//       // Build a synthetic selectedRoute so the UI shows as "selected"
//       // and fare matrices are preserved on submit
//       setSelectedRoute({
//         _id: upSchedule.routeId,
//         routeName: `${originName} → ${destinationName}`,
//         origin: { city: originName },
//         destination: { city: destinationName },
//         intermediateStops: upMatrix.slice(1, -1).map(row => ({ city: row.fromName })),
//         returnJourney: downSchedule ? (() => {
//           const downMatrix = downSchedule.fareMatrix;
//           const downOrigin = downMatrix[0]?.fromName || '';
//           const downLastCell = [...(downMatrix[0]?.toCells || [])].filter(Boolean).pop();
//           const downDest = downLastCell?.toName || '';
//           return {
//             origin: { city: downOrigin },
//             destination: { city: downDest },
//             intermediateStops: downMatrix.slice(1, -1).map(row => ({ city: row.fromName }))
//           };
//         })() : null
//       });
//     }
//   }, [bus]);

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//             setSelectedConfiguration(configs[0]);
//           }
//         } else {
//           setAvailableConfigurations([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;
//       setLoadingLayouts(true);
//       let bustype = config.replace('x', '*');
//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success && response.data && Array.isArray(response.data)) {
//         let filteredLayouts = response.data;
//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seat' || layout.seatType === 'seater'
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'sleeper'
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//           );
//         }
//         setLayoutTemplates(filteredLayouts);
//       } else {
//         setLayoutTemplates([]);
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleSelectRoute = (route) => {
//     setSelectedRoute(route);
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setSourceCity(route.origin?.city || '');
//     setDestinationCity(route.destination?.city || '');
//   };

//   const getCategoryMultiplier = () => {
//     const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
//     );
//   };

//   const handleAmenityToggle = (amenity) => {
//     setForm(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenity)
//         ? prev.amenities.filter(a => a !== amenity)
//         : [...prev.amenities, amenity]
//     }));
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];
//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({ file: file, preview: e.target.result, name: file.name });
//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeExistingImage = (index) => {
//     setExistingImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const removeNewImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeExistingVideo = () => {
//     setExistingVideo(null);
//   };

//   const removeNewVideo = () => {
//     setSelectedVideo(null);
//   };

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
//       }
//       return { ...row, toCells: newToCells };
//     });
//     if (isUp) setFareMatrixUp(updatedMatrix);
//     else setFareMatrixDown(updatedMatrix);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     if (!selectedTemplate || !selectedTemplate.seats) return;
//     const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });
//     let counter = 1;
//     const newLabels = {};
//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });
//     setCustomSeatLabels(newLabels);
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   const handleUpdateBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       if (!form.busNumber) throw new Error('Bus Number is required');
//       if (!form.busName) throw new Error('Bus Name is required');
//       if (!form.busType) throw new Error('Bus Type is required');
//       if (!form.busCategory) throw new Error('Bus Category is required');
//       if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

//       const amenitiesArray = form.amenities || [];

//       // Prepare seats data
//       let finalSeatsPayload = [];
//       if (selectedTemplate && selectedTemplate.seats) {
//         finalSeatsPayload = selectedTemplate.seats
//           .filter(s => activeSeats.includes(s.seatNumber))
//           .map(s => {
//             const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//             const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//             const isBlocked = blockedSeats.includes(s.seatNumber);
//             return {
//               seatNumber: s.seatNumber,
//               globalSeatIndex: finalGlobalIndex,
//               row: s.row,
//               column: s.column,
//               seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//               position: s.position || getSeatPosition(s.column),
//               isBlocked: isBlocked,
//               isAvailable: !isBlocked,
//             };
//           });
//       } else if (bus.seats) {
//         finalSeatsPayload = bus.seats;
//       }

//       const seatConfigPayload = {
//         busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
//         totalSeats: activeSeats.length || bus.totalSeats
//       };

//       const formData = new FormData();
//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');
//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('operatingDays', JSON.stringify(operatingDays));
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//       formData.append('cancellationTime', JSON.stringify(cancellationTime));
//       formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

//       // Fare Details
//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };
//       formData.append('fareDetails', JSON.stringify(fareDetails));

//       // Route Schedules
//       if (selectedRoute) {
//         const routeSchedules = [{
//           routeId: selectedRoute._id,
//           direction: 'UP',
//           fareMatrix: fareMatrixUp,
//           operatingDays: operatingDays,
//           departureTime: selectedRoute.origin?.departureTime || '08:00',
//           arrivalTime: selectedRoute.destination?.arrivalTime || '20:00'
//         }];
//         if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//           routeSchedules.push({
//             routeId: selectedRoute._id,
//             direction: 'DOWN',
//             fareMatrix: fareMatrixDown,
//             operatingDays: operatingDays,
//             departureTime: selectedRoute.returnJourney.origin?.departureTime || '08:00',
//             arrivalTime: selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//           });
//         }
//         formData.append('routeSchedules', JSON.stringify(routeSchedules));
//       } else if (bus.routeSchedules) {
//         // Keep existing route schedules if no new route selected
//         formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
//       }

//       // Images - keep existing and add new
//       if (existingImages.length > 0) {
//         formData.append('existingImages', JSON.stringify(existingImages));
//       }
//       selectedImages.forEach((img) => {
//         if (img.file) formData.append('images', img.file);
//       });

//       // Video
//       if (existingVideo) {
//         formData.append('existingVideo', existingVideo);
//       }
//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       const response = await updateBus(bus._id, formData, token);

//       if (response && response.success) {
//         toast.success('Bus updated successfully!');
//         if (onUpdate) onUpdate();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to update bus');
//       }
//     } catch (err) {
//       console.error('Error updating bus:', err);
//       setError(err.message || 'Failed to update bus');
//       toast.error(err.message || 'Failed to update bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleCancellationTimeChange = (field, value) => {
//   setCancellationTime(prev => ({ 
//     ...prev, 
//     [field]: parseInt(value) || 0 
//   }));
// };

// //   const renderMatrix = (type) => {
// //     const isUp = type === 'up';
// //     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
// //     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

// //     if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
// //       <div className="matrix-placeholder">
// //         <p>No fare matrix generated yet. Please go back to Route & Pricing tab and generate matrix.</p>
// //       </div>
// //     );

// //     const allStops = currentMatrix.map(row => ({ name: row.fromName, type: row.fromType }));
// // console.log("allStops ;;;;;;;;;;;;;;;: ",allStops)
// //     return (
// //       <div className="matrix-section">
// //         <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
// //         <div className="matrix-container">
// //           <div className="matrix-table-wrapper">
// //             <table className="fare-matrix-table">
// //               <thead>
// //                 <tr><th className="corner-cell">From \ To</th>
// //                   {allStops.map((stop, i) => (
// //                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
// //                       <div className="stop-header">
// //                         <span className="stop-name">{stop.name}</span>
// //                         <span className="stop-type">{stop.type}</span>
// //                       </div>
// //                     </th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {currentMatrix.map((row, rowIndex) => (
// //                   <tr key={rowIndex}>
// //                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
// //                       <div className="from-stop">
// //                         <span className="stop-name">{row.fromName}</span>
// //                         <span className="stop-type">{row.fromType}</span>
// //                       </div>
// //                     </td>
// //                     {row.toCells && row.toCells.map((cell, colIndex) => {
// //                       if (cell && cell.price !== undefined) {
// //                         return (
// //                           <td key={colIndex} className="price-cell">
// //                             <div className="fare-cell">
// //                               <span className="distance">{cell.distanceKm || 0} km</span>
// //                               <div className="price-input-group">
// //                                 <span className="currency">₹</span>
// //                                 <input
// //                                   type="text"
// //                                   className="matrix-input"
// //                                   value={cell.price}
// //                                   onChange={(e) => {
// //                                     // Only allow numbers
// //                                     const value = e.target.value;
// //                                     if (value === '' || /^\d+$/.test(value)) {
// //                                       handlePriceChange(type, rowIndex, colIndex, value);
// //                                     }
// //                                   }}
// //                                   min="0"
// //                                   step="1"
// //                                   pattern="\d*"
// //                                   inputMode="numeric"
// //                                 />
// //                               </div>
// //                             </div>
// //                           </td>
// //                         );
// //                       }
// //                       return <td key={colIndex} className="na-cell">—</td>;
// //                     })}
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// const renderMatrix = (type) => {
//   const isUp = type === 'up';
//   const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//   const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//   if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
//     <div className="matrix-placeholder">
//       <p>No fare matrix generated yet. Please go back to Route & Pricing tab and generate matrix.</p>
//     </div>
//   );

//   // Get all stops including destination from the matrix
//   // The stops are: origin, intermediate stops, and destination
//   const allStops = [];

//   // Add the from stops (all rows)
//   currentMatrix.forEach(row => {
//     if (!allStops.find(s => s.name === row.fromName && s.type === row.fromType)) {
//       allStops.push({ name: row.fromName, type: row.fromType });
//     }
//   });

//   // Add destination from the last toCell of the first row
//   const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
//   if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
//     allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
//   }

//   return (
//     <div className="matrix-section">
//       <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
//       <div className="matrix-container">
//         <div className="matrix-table-wrapper">
//           <table className="fare-matrix-table">
//             <thead>
//               <tr>
//                 <th className="corner-cell">From \ To</th>
//                 {allStops.map((stop, i) => (
//                   <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                     <div className="stop-header">
//                       <span className="stop-name">{stop.name}</span>
//                       {/* <span className="stop-type">{stop.type}</span> */}
//                     </div>
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {currentMatrix.map((row, rowIndex) => (
//                 <tr key={rowIndex}>
//                   <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                     <div className="from-stop">
//                       <span className="stop-name">{row.fromName}</span>
//                       {/* <span className="stop-type">{row.fromType}</span> */}
//                     </div>
//                   </td>
//                   {allStops.map((stop, colIndex) => {
//                     // Find the cell that matches this destination
//                     const matchingCell = row.toCells?.find(cell => 
//                       cell && cell.toName === stop.name
//                     );

//                     if (matchingCell) {
//                       return (
//                         <td key={colIndex} className="price-cell">
//                           <div className="fare-cell">
//                             <span className="distance">{matchingCell.distanceKm || 0} km</span>
//                             <div className="price-input-group">
//                               <span className="currency">₹</span>
//                               <input
//                                 type="text"
//                                 className="matrix-input"
//                                 value={matchingCell.price}
//                                 onChange={(e) => {
//                                   // Only allow numbers
//                                   const value = e.target.value;
//                                   if (value === '' || /^\d+$/.test(value)) {
//                                     // Find the correct column index for this cell
//                                     const actualColIndex = row.toCells.findIndex(cell => 
//                                       cell && cell.toName === stop.name
//                                     );
//                                     handlePriceChange(type, rowIndex, actualColIndex, value);
//                                   }
//                                 }}
//                                 min="0"
//                                 step="1"
//                                 pattern="\d*"
//                                 inputMode="numeric"
//                               />
//                             </div>
//                           </div>
//                         </td>
//                       );
//                     }
//                     return <td key={colIndex} className="na-cell">—</td>;
//                   })}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return (
//       <div className="seat-placeholder">
//         <p>Select a template to configure seats</p>
//         <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Template
//         </button>
//       </div>
//     );

//     if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
//       return <div className="seat-placeholder">No seats available in this template</div>;
//     }

//     const { seats, configuration } = selectedTemplate;
//     let leftCount = 2, rightCount = 2;
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const displayLabel = isSelected ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber) : "";
//       let seatClass = isSelected ? (isBlocked ? 'blocked' : 'selected') : 'inactive';
//       return (
//         <button key={seatObj.seatNumber} className={`seat-btn ${seatClass}`} onClick={() => handleSeatPress(seatObj)} type="button">
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];
//       const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount).sort((a, b) => (a.column || 0) - (b.column || 0));
//       const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount).sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
//         </div>
//       );
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header"><div className="driver-area">Driver</div></div>
//         <div className="bus-body">{rows}</div>
//         <div className="seat-legend">
//           <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
//           <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked</span></div>
//           <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
//         </div>
//         <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>Auto-Number Seats</button>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}><div className="step-icon">1</div><div className="step-label">Basic Info</div></div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''}`}><div className="step-icon">2</div><div className="step-label">Route & Pricing</div></div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}><div className="step-icon">3</div><div className="step-label">Fare Matrix</div></div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}><div className="step-icon">4</div><div className="step-label">Seat Layout</div></div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Edit Bus Information</h3></div>
//       <div className="form-grid">
//         <div className="input-group"><label>Bus Number *</label>
//           <input type="text" value={form.busNumber} onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))} className="modern-input" />
//         </div>
//         <div className="input-group"><label>Bus Name *</label>
//           <input type="text" value={form.busName} onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))} className="modern-input" />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Bus Images</h4>
//         {existingImages.length > 0 && (
//           <div className="existing-images">
//             <label>Current Images</label>
//             <div className="images-grid">
//               {existingImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={`${process.env.REACT_APP_BASE_URL}/uploads/${img}`} alt="bus" />
//                   <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         <input type="file" id="edit-bus-images" multiple accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
//         <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
//         {selectedImages.length > 0 && (
//           <div className="new-images">
//             <div className="images-grid">
//               {selectedImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={img.preview} alt="new" />
//                   <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-row">
//         <div className="form-group"><label>Bus Type *</label>
//           <select value={form.busType} onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))} className="modern-select">
//             {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
//           </select>
//         </div>
//         <div className="form-group"><label>Bus Category *</label>
//           <select value={form.busCategory} onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))} className="modern-select">
//             {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Booking Cut-off Time</h4>
//         <div className="booking-time-container">
//           <input type="number" min="0" max="24" value={bookingClosedBefore.hours} onChange={(e) => handleBookingTimeChange('hours', e.target.value)} placeholder="Hours" />
//           <input type="number" min="0" max="59" value={bookingClosedBefore.minutes} onChange={(e) => handleBookingTimeChange('minutes', e.target.value)} placeholder="Minutes" />
//         </div>
//       </div>

//       <div className="section-card">
//   <h4>Cancellation Time</h4>
//   <div className="booking-time-container">
//     <div className="time-input-group">
//       <label>Hours before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="48"
//           value={cancellationTime.hours}
//           onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">hours</span>
//       </div>
//     </div>
//     <div className="time-input-group">
//       <label>Minutes before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="59"
//           value={cancellationTime.minutes}
//           onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">minutes</span>
//       </div>
//     </div>
//   </div>
//   <small className="helper-text">
//     Cancellation allowed up to this time before departure
//   </small>
// </div>

//       <div className="section-card">
//         <h4>Amenities</h4>
//         <div className="amenities-grid">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-checkbox-label">
//               <input type="checkbox" checked={form.amenities.includes(amenity)} onChange={() => handleAmenityToggle(amenity)} />
//               <span>{amenity}</span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//       <div className="section-card">
//         <h4>Trip Type</h4>
//         <div className="trip-type-container">
//           <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`} onClick={() => setTripType('oneWay')}>One Way</button>
//           <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`} onClick={() => setTripType('roundTrip')}>Round Trip</button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Source & Destination</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Source City</label>
//             <input
//               type="text"
//               value={sourceCity}
//               onChange={(e) => {
//                 setSourceCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter source city"
//               className="modern-input"
//             />
//           </div>
//           <div className="form-group">
//             <label>Destination City</label>
//             <input
//               type="text"
//               value={destinationCity}
//               onChange={(e) => {
//                 setDestinationCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter destination city"
//               className="modern-input"
//             />
//           </div>
//         </div>
//       </div>

//       {sourceCity && destinationCity && (
//         <div className="section-card">
//           <h4>Select Route</h4>
//           <div className="route-selector">
//             <label>Available Routes</label>
//             <div className="route-dropdown-container">
//               <input
//                 type="text"
//                 value={selectedRoute ? selectedRoute.routeName : routeSearchTerm}
//                 onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//                 onChange={(e) => {
//                   setRouteSearchTerm(e.target.value);
//                   setShowRouteDropdown(true);
//                   setSelectedRoute(null);
//                 }}
//                 placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//                 className="modern-input"
//               />
//               {showRouteDropdown && availableRoutes.length > 0 && (
//                 <div className="route-dropdown">
//                   <div className="dropdown-search">
//                     <input
//                       type="text"
//                       value={routeSearchTerm}
//                       onChange={(e) => setRouteSearchTerm(e.target.value)}
//                       placeholder="Search routes..."
//                       className="dropdown-search-input"
//                       autoFocus
//                     />
//                   </div>
//                   <div className="dropdown-list">
//                     {availableRoutes
//                       .filter(route =>
//                         route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//                         route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase())
//                       )
//                       .map(route => (
//                         <div key={route._id} className="dropdown-item" onClick={() => handleSelectRoute(route)}>
//                           <div className="route-number">{route.routeName}</div>
//                           <div className="route-details">
//                             {route.origin?.city} → {route.destination?.city} •
//                             {route.routeDetails?.totalDistance || 0} km
//                           </div>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             {selectedRoute && (
//               <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//                 ✓ Route selected: {selectedRoute.routeName}
//               </small>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4>Operating Days</h4>
//         <div className="days-grid">
//           {DAYS_OF_WEEK.map(day => (
//             <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`} onClick={() => toggleDay(day)}>
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Pricing Configuration</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//         <button
//           className="modern-btn primary"
//           onClick={() => {
//             // Check if route is selected
//             if (!selectedRoute) {
//               toast.error('Please select a route first');
//               return;
//             }
//             // Check if pricing fields are filled
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields');
//               return;
//             }

//             // Generate matrix based on existing bus data or create new
//             if (bus.routeSchedules && bus.routeSchedules.length > 0 && fareMatrixUp.length === 0) {
//               // Use existing matrices from bus data
//               const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//               const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');
//               if (upSchedule && upSchedule.fareMatrix) {
//                 setFareMatrixUp(upSchedule.fareMatrix);
//               }
//               if (downSchedule && downSchedule.fareMatrix) {
//                 setFareMatrixDown(downSchedule.fareMatrix);
//               }
//             }

//             setActiveTab('matrix');
//           }}
//         >
//           Continue to Fare Matrix →
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Fare Matrix Configuration</h3></div>
//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`} onClick={() => setActiveMatrixTab('up')}>Up Route</button>
//           <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`} onClick={() => setActiveMatrixTab('down')}>Down Route</button>
//         </div>
//       )}
//       {activeMatrixTab === 'up' && renderMatrix('up')}
//       {activeMatrixTab === 'down' && renderMatrix('down')}
//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
//         <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Seat Layout Configuration</h3></div>

//       <div className="section-card">
//         <h4>Bus Configuration</h4>
//         <div className="config-buttons">
//           {availableConfigurations.map(config => (
//             <button key={config} className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`} onClick={() => setSelectedConfiguration(config)}>
//               {config}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Select Template</h4>
//         <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>Select Layout Template</button>
//         {selectedTemplate && <div className="selected-template">Selected: {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)</div>}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4>Seat Layout</h4>
//           <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>View / Edit Seats</button>
//           <div className="seat-summary">
//             <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
//         <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
//           {isSubmitting ? 'Updating...' : 'Update Bus'}
//         </button>
//       </div>
//     </div>
//   );

//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header"><h3>Configure Seats</h3><button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button></div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header"><h3>Select Template</h3><button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button></div>
//         <div className="modal-body">
//           <div className="templates-grid">
//             {layoutTemplates.map(template => (
//               <button key={template._id} className="template-card" onClick={() => handleSelectTemplate(template)}>
//                 <h4>{template.name}</h4>
//                 <div>Config: {template.configuration}</div>
//                 <div>Seats: {template.totalSeats}</div>
//                 <div>Type: {template.seatType || 'seat'}</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header"><h3>Set Seat Label</h3></div>
//         <div className="modal-body">
//           <input type="text" value={tempSeatLabel} onChange={(e) => setTempSeatLabel(e.target.value)} placeholder="Seat number" autoFocus />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button onClick={() => { setActiveSeats(activeSeats.filter(s => s !== editingSeat)); setBlockedSeats(blockedSeats.filter(s => s !== editingSeat)); setEditingSeat(null); }}>Disable</button>
//           <button onClick={() => { if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]); if (!blockedSeats.includes(editingSeat)) setBlockedSeats([...blockedSeats, editingSeat]); setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel })); setEditingSeat(null); }}>Block</button>
//           <button onClick={() => { if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]); setBlockedSeats(blockedSeats.filter(s => s !== editingSeat)); setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel })); setEditingSeat(null); }}>Active</button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
//             <p className="modal-subtitle">Update bus configuration</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body modern">
//           <ProgressSteps />
//           {activeTab === 'basic' && renderBasicInfoTab()}
//           {activeTab === 'route' && renderRouteTab()}
//           {activeTab === 'matrix' && renderMatrixTab()}
//           {activeTab === 'seats' && renderSeatLayoutTab()}
//           {error && <div className="error-message modern">{error}</div>}
//         </div>
//       </div>
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// export default EditBusModal;


// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusManagementModal.css';

// const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // Cancellation Time State
//   const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Existing Images/Video
//   const [existingImages, setExistingImages] = useState([]);
//   const [existingVideo, setExistingVideo] = useState(null);
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Store reconstructed route stops with distances (extracted from existing fareMatrix)
//   const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
//   const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ─── KEY FIX: Reconstruct stops with cumulative distances from fareMatrix ───
//   // The fareMatrix stores distanceKm for each pair (from→to).
//   // We reconstruct absolute distanceFromOrigin for each stop by reading
//   // the first row's toCells, which always starts from origin (distanceFromOrigin=0).
//   const reconstructStopsFromMatrix = (fareMatrix) => {
//     if (!fareMatrix || fareMatrix.length === 0) return null;

//     // Build stops array with distanceFromOrigin
//     // First row = origin row; its toCells give distances from origin to each subsequent stop
//     const stops = [];

//     // Origin stop
//     stops.push({
//       id: fareMatrix[0].fromId || 'origin',
//       name: fareMatrix[0].fromName,
//       distanceFromOrigin: 0,
//       type: fareMatrix[0].fromType || 'origin'
//     });

//     // Read the first row's toCells to get distances from origin to all other stops
//     const firstRowCells = fareMatrix[0].toCells || [];
//     firstRowCells.forEach((cell) => {
//       if (cell) {
//         stops.push({
//           id: cell.toId || cell.toName,
//           name: cell.toName,
//           distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
//           type: 'stop' // will be overridden for destination below
//         });
//       }
//     });

//     // Mark the last stop as destination
//     if (stops.length > 1) {
//       stops[stops.length - 1].type = 'destination';
//     }

//     // Also read intermediate stops from subsequent rows
//     // Row 1 = first intermediate stop (index 1 in stops array)
//     // We already have distances from origin for all stops via first row
//     // Now reconstruct intermediate rows using cumulative distances
//     for (let i = 1; i < fareMatrix.length; i++) {
//       const row = fareMatrix[i];
//       if (stops[i]) {
//         stops[i].name = row.fromName;
//         stops[i].type = row.fromType || stops[i].type;
//         // distanceFromOrigin is already set from first row's toCells
//         // But verify/update from this row's toCells if first row had nulls
//         if (stops[i].distanceFromOrigin === 0 && row.toCells) {
//           // Try to reconstruct from previous stop
//           const prevStop = stops[i - 1];
//           const cellToNext = row.toCells.find(c => c !== null);
//           if (cellToNext && prevStop) {
//             // We know distance from prev to next, but not absolute
//             // Use first row data as primary source
//           }
//         }
//       }
//     }

//     return {
//       stops,
//       origin: { city: stops[0]?.name },
//       destination: { city: stops[stops.length - 1]?.name },
//       intermediateStops: stops.slice(1, -1).map((s, idx) => ({
//         city: s.name,
//         distanceFromOrigin: s.distanceFromOrigin,
//         sequence: idx + 1
//       })),
//       routeDetails: {
//         totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
//       }
//     };
//   };

//   // ─── generateMatrixForRoute: uses distanceFromOrigin for correct pricing ───
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     let allStops = [];

//     // If routeData has pre-built stops array (from reconstructed route), use it directly
//     if (routeData.stops && routeData.stops.length > 0) {
//       allStops = routeData.stops.map(s => ({
//         id: s.id || s.name,
//         name: s.name,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: s.type
//       }));
//     } else {
//       // Build from route object (newly selected route from dropdown)
//       const sortedStops = [...(routeData.intermediateStops || [])]
//         .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//       allStops = [
//         {
//           id: 'origin',
//           name: routeData.origin?.city || 'Origin',
//           distanceFromOrigin: 0,
//           type: 'origin'
//         },
//         ...sortedStops.map((s, i) => ({
//           id: s._id || `stop_${i}`,
//           name: s.city || s.name || `Stop ${i + 1}`,
//           distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//           type: 'stop',
//           sequence: s.sequence
//         })),
//         {
//           id: 'destination',
//           name: routeData.destination?.city || 'Destination',
//           distanceFromOrigin:
//             parseFloat(routeData.destination?.distanceFromOrigin) ||
//             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//           type: 'destination'
//         }
//       ];
//     }

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromType !== 'destination');
//   };

//   // Initialize form with existing bus data
//   useEffect(() => {
//     if (bus) {
//       setForm({
//         busNumber: bus.busNumber || '',
//         busName: bus.busName || '',
//         busType: bus.busType || 'AC',
//         busCategory: bus.busCategory || 'Seater',
//         amenities: bus.amenities || []
//       });

//       setTripType(bus.tripType || 'oneWay');

//       if (bus.bookingClosedBefore) {
//         setBookingClosedBefore(bus.bookingClosedBefore);
//       }

//       if (bus.cancellationTime) {
//         setCancellationTime(bus.cancellationTime);
//       } else {
//         setCancellationTime({ hours: 1, minutes: 0 });
//       }

//       if (bus.operatingDays && bus.operatingDays.length > 0) {
//         setOperatingDays(bus.operatingDays);
//       }

//       if (bus.fareDetails) {
//         setPricing({
//           basePrice: bus.fareDetails.basePrice || '',
//           baseDistance: bus.fareDetails.baseDistance || '',
//           costPerKm: bus.fareDetails.costPerKm || ''
//         });
//       }

//       if (bus.images && bus.images.length > 0) {
//         setExistingImages(bus.images);
//       }
//       if (bus.video && bus.video.length > 0) {
//         setExistingVideo(bus.video[0]);
//       }

//       if (bus.seatConfiguration) {
//         setSelectedConfiguration(bus.seatConfiguration.busType || '2*2');
//       }

//       if (bus.seats && bus.seats.length > 0) {
//         const activeSeatNumbers = bus.seats
//           .filter(seat => seat.isAvailable !== false)
//           .map(seat => seat.seatNumber);
//         setActiveSeats(activeSeatNumbers);

//         const blockedSeatNumbers = bus.seats
//           .filter(seat => seat.isBlocked === true)
//           .map(seat => seat.seatNumber);
//         setBlockedSeats(blockedSeatNumbers);

//         const seatLabels = {};
//         bus.seats.forEach(seat => {
//           seatLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
//         });
//         setCustomSeatLabels(seatLabels);
//       }
//     }
//   }, [bus]);

//   // ─── KEY: Load fareMatrix AND reconstruct routes with distances ───
//   useEffect(() => {
//     if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) return;

//     const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//     const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//     if (upSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixUp(upSchedule.fareMatrix);

//       // Reconstruct route with proper distanceFromOrigin from existing matrix
//       const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
//       setReconstructedRouteUp(reconstructed);

//       if (reconstructed) {
//         setSourceCity(reconstructed.origin?.city || '');
//         setDestinationCity(reconstructed.destination?.city || '');

//         setSelectedRoute({
//           _id: upSchedule.routeId,
//           routeName: upSchedule.routeName ||
//             `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
//           origin: reconstructed.origin,
//           destination: reconstructed.destination,
//           intermediateStops: reconstructed.intermediateStops || [],
//           routeDetails: reconstructed.routeDetails,
//           // Store the stops array for generateMatrixForRoute
//           stops: reconstructed.stops,
//           returnJourney: downSchedule ? (() => {
//             const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//             setReconstructedRouteDown(downReconstructed);
//             return downReconstructed;
//           })() : null
//         });
//       }
//     }

//     if (downSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixDown(downSchedule.fareMatrix);
//       if (!upSchedule?.fareMatrix?.length) {
//         const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//         setReconstructedRouteDown(downReconstructed);
//       }
//     }
//   }, [bus]);

//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }
//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token, 1, 50, '', '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
//       if (response && response.success && response.routes) {
//         setAvailableRoutes(response.routes);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity && !selectedRoute) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   useEffect(() => {
//     if (selectedConfiguration && form.busCategory) {
//       fetchLayouts(selectedConfiguration);
//     }
//   }, [selectedConfiguration, form.busCategory]);

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);
//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;
//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') || cat.availableSeatTypes?.includes('seater'));
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper'));
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') || cat.availableSeatTypes?.includes('seat+sleeper'));
//         }
//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];
//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//             setSelectedConfiguration(configs[0]);
//           }
//         } else {
//           setAvailableConfigurations([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;
//       setLoadingLayouts(true);
//       let bustype = config.replace('x', '*');
//       const response = await getSeatLayoutsByBustype(bustype, token);
//       if (response && response.success && response.data && Array.isArray(response.data)) {
//         let filteredLayouts = response.data;
//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seat' || layout.seatType === 'seater');
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
//         }
//         setLayoutTemplates(filteredLayouts);
//       } else {
//         setLayoutTemplates([]);
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const getCategoryMultiplier = () => {
//     const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const handleSelectRoute = (route) => {
//     // When user selects a new route from dropdown, clear the reconstructed stops
//     // so generateMatrixForRoute uses the route's own intermediateStops
//     setSelectedRoute({ ...route, stops: null });
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setSourceCity(route.origin?.city || '');
//     setDestinationCity(route.destination?.city || '');
//     // Clear existing matrices so they get regenerated
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//     setReconstructedRouteUp(null);
//     setReconstructedRouteDown(null);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
//     );
//   };

//   const handleAmenityToggle = (amenity) => {
//     setForm(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenity)
//         ? prev.amenities.filter(a => a !== amenity)
//         : [...prev.amenities, amenity]
//     }));
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];
//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({ file: file, preview: e.target.result, name: file.name });
//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeExistingImage = (index) => {
//     setExistingImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const removeNewImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeExistingVideo = () => setExistingVideo(null);
//   const removeNewVideo = () => setSelectedVideo(null);

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handleCancellationTimeChange = (field, value) => {
//     setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
//       }
//       return { ...row, toCells: newToCells };
//     });
//     if (isUp) setFareMatrixUp(updatedMatrix);
//     else setFareMatrixDown(updatedMatrix);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     if (!selectedTemplate || !selectedTemplate.seats) return;
//     const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });
//     let counter = 1;
//     const newLabels = {};
//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });
//     setCustomSeatLabels(newLabels);
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   const handleUpdateBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       if (!form.busNumber) throw new Error('Bus Number is required');
//       if (!form.busName) throw new Error('Bus Name is required');
//       if (!form.busType) throw new Error('Bus Type is required');
//       if (!form.busCategory) throw new Error('Bus Category is required');
//       if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

//       const amenitiesArray = form.amenities || [];

//       let finalSeatsPayload = [];
//       if (selectedTemplate && selectedTemplate.seats) {
//         finalSeatsPayload = selectedTemplate.seats
//           .filter(s => activeSeats.includes(s.seatNumber))
//           .map(s => {
//             const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//             const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//             const isBlocked = blockedSeats.includes(s.seatNumber);
//             return {
//               seatNumber: s.seatNumber,
//               globalSeatIndex: finalGlobalIndex,
//               row: s.row,
//               column: s.column,
//               seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//               position: s.position || getSeatPosition(s.column),
//               isBlocked: isBlocked,
//               isAvailable: !isBlocked,
//             };
//           });
//       } else if (bus.seats) {
//         finalSeatsPayload = bus.seats;
//       }

//       const seatConfigPayload = {
//         busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
//         totalSeats: activeSeats.length || bus.totalSeats
//       };

//       const formData = new FormData();
//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');
//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('operatingDays', JSON.stringify(operatingDays));
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//       formData.append('cancellationTime', JSON.stringify(cancellationTime));
//       formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };
//       formData.append('fareDetails', JSON.stringify(fareDetails));

//       if (selectedRoute) {
//         const routeSchedules = [{
//           routeId: selectedRoute._id,
//           direction: 'UP',
//           fareMatrix: fareMatrixUp,
//           operatingDays: operatingDays,
//           departureTime: selectedRoute.origin?.departureTime || '08:00',
//           arrivalTime: selectedRoute.destination?.arrivalTime || '20:00'
//         }];
//         if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//           routeSchedules.push({
//             routeId: selectedRoute._id,
//             direction: 'DOWN',
//             fareMatrix: fareMatrixDown,
//             operatingDays: operatingDays,
//             departureTime: selectedRoute.returnJourney.origin?.departureTime || '08:00',
//             arrivalTime: selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//           });
//         }
//         formData.append('routeSchedules', JSON.stringify(routeSchedules));
//       } else if (bus.routeSchedules) {
//         formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
//       }

//       if (existingImages.length > 0) {
//         formData.append('existingImages', JSON.stringify(existingImages));
//       }
//       selectedImages.forEach((img) => {
//         if (img.file) formData.append('images', img.file);
//       });
//       if (existingVideo) {
//         formData.append('existingVideo', existingVideo);
//       }
//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       const response = await updateBus(bus._id, formData, token);

//       if (response && response.success) {
//         toast.success('Bus updated successfully!');
//         if (onUpdate) onUpdate();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to update bus');
//       }
//     } catch (err) {
//       console.error('Error updating bus:', err);
//       setError(err.message || 'Failed to update bus');
//       toast.error(err.message || 'Failed to update bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ─── renderMatrix: same as before ───
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
//       <div className="matrix-placeholder">
//         <p>No fare matrix available. Please go back and generate the matrix.</p>
//       </div>
//     );

//     const allStops = [];
//     currentMatrix.forEach(row => {
//       if (!allStops.find(s => s.name === row.fromName)) {
//         allStops.push({ name: row.fromName, type: row.fromType });
//       }
//     });
//     const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
//     if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
//       allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
//     }

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                       </div>
//                     </td>
//                     {allStops.map((stop, colIndex) => {
//                       const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
//                       if (matchingCell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{matchingCell.distanceKm || 0} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="text"
//                                   className="matrix-input"
//                                   value={matchingCell.price}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (value === '' || /^\d+$/.test(value)) {
//                                       const actualColIndex = row.toCells.findIndex(
//                                         cell => cell && cell.toName === stop.name
//                                       );
//                                       handlePriceChange(type, rowIndex, actualColIndex, value);
//                                     }
//                                   }}
//                                   min="0"
//                                   step="1"
//                                   pattern="\d*"
//                                   inputMode="numeric"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return (
//       <div className="seat-placeholder">
//         <p>Select a template to configure seats</p>
//         <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Template
//         </button>
//       </div>
//     );

//     if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
//       return <div className="seat-placeholder">No seats available in this template</div>;
//     }

//     const { seats, configuration } = selectedTemplate;
//     let leftCount = 2, rightCount = 2;
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";
//       let seatClass = isSelected ? (isBlocked ? 'blocked' : 'selected') : 'inactive';
//       return (
//         <button key={seatObj.seatNumber} className={`seat-btn ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)} type="button">
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];
//       const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
//         </div>
//       );
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header"><div className="driver-area">Driver</div></div>
//         <div className="bus-body">{rows}</div>
//         <div className="seat-legend">
//           <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
//           <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked</span></div>
//           <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
//         </div>
//         <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
//           Auto-Number Seats
//         </button>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
//         <div className="step-icon">1</div><div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
//         <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
//         <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Edit Bus Information</h3></div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label>Bus Number *</label>
//           <input type="text" value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             className="modern-input" />
//         </div>
//         <div className="input-group">
//           <label>Bus Name *</label>
//           <input type="text" value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             className="modern-input" />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Bus Images</h4>
//         {existingImages.length > 0 && (
//           <div className="existing-images">
//             <label>Current Images</label>
//             <div className="images-grid">
//               {existingImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={`${process.env.REACT_APP_BASE_URL}/uploads/${img}`} alt="bus" />
//                   <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         <input type="file" id="edit-bus-images" multiple accept="image/*"
//           onChange={handleImageUpload} style={{ display: 'none' }} />
//         <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
//         {selectedImages.length > 0 && (
//           <div className="new-images">
//             <div className="images-grid">
//               {selectedImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={img.preview} alt="new" />
//                   <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Bus Type *</label>
//           <select value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select">
//             {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
//           </select>
//         </div>
//         <div className="form-group">
//           <label>Bus Category *</label>
//           <select value={form.busCategory}
//             onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
//             className="modern-select">
//             {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Booking Cut-off Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Cancellation Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="48" value={cancellationTime.hours}
//                 onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={cancellationTime.minutes}
//                 onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//         <small className="helper-text">Cancellation allowed up to this time before departure</small>
//       </div>

//       <div className="section-card">
//         <h4>Amenities</h4>
//         <div className="amenities-grid">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-checkbox-label">
//               <input type="checkbox" checked={form.amenities.includes(amenity)}
//                 onChange={() => handleAmenityToggle(amenity)} />
//               <span>{amenity}</span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//       <div className="section-card">
//         <h4>Trip Type</h4>
//         <div className="trip-type-container">
//           <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}>One Way</button>
//           <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}>Round Trip</button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Source & Destination</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Source City</label>
//             <input type="text" value={sourceCity}
//               onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter source city" className="modern-input" />
//           </div>
//           <div className="form-group">
//             <label>Destination City</label>
//             <input type="text" value={destinationCity}
//               onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter destination city" className="modern-input" />
//           </div>
//         </div>
//       </div>

//       {sourceCity && destinationCity && (
//         <div className="section-card">
//           <h4>Select Route</h4>
//           <div className="route-selector">
//             <label>Available Routes</label>
//             <div className="route-dropdown-container">
//               <input
//                 type="text"
//                 value={selectedRoute ? selectedRoute.routeName : routeSearchTerm}
//                 onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//                 onChange={(e) => {
//                   setRouteSearchTerm(e.target.value);
//                   setShowRouteDropdown(true);
//                   setSelectedRoute(null);
//                 }}
//                 placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//                 className="modern-input"
//               />
//               {showRouteDropdown && availableRoutes.length > 0 && (
//                 <div className="route-dropdown">
//                   <div className="dropdown-search">
//                     <input type="text" value={routeSearchTerm}
//                       onChange={(e) => setRouteSearchTerm(e.target.value)}
//                       placeholder="Search routes..." className="dropdown-search-input" autoFocus />
//                   </div>
//                   <div className="dropdown-list">
//                     {availableRoutes
//                       .filter(route =>
//                         route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//                         route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase())
//                       )
//                       .map(route => (
//                         <div key={route._id} className="dropdown-item"
//                           onClick={() => handleSelectRoute(route)}>
//                           <div className="route-number">{route.routeName}</div>
//                           <div className="route-details">
//                             {route.origin?.city} → {route.destination?.city} •
//                             {route.routeDetails?.totalDistance || 0} km
//                           </div>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             {selectedRoute && (
//               <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//                 ✓ Route selected: {selectedRoute.routeName}
//               </small>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4>Operating Days</h4>
//         <div className="days-grid">
//           {DAYS_OF_WEEK.map(day => (
//             <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}>
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Pricing Configuration</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input type="number" value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100" className="modern-input" min="0" step="1" />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input type="number" value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input type="number" value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//         <button
//           className="modern-btn primary"
//           onClick={() => {
//             if (!selectedRoute) {
//               toast.error('Please select a route first');
//               return;
//             }
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields');
//               return;
//             }

//             // ─── KEY: Always regenerate matrix using current pricing ───
//             // Use selectedRoute.stops (reconstructed) or intermediateStops (new route)
//             const newMatrixUp = generateMatrixForRoute(selectedRoute);
//             setFareMatrixUp(newMatrixUp);

//             if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//               const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//               setFareMatrixDown(newMatrixDown);
//             }

//             toast.success('Fare matrix generated with updated pricing!');
//             setActiveTab('matrix');
//           }}
//         >
//           Continue to Fare Matrix →
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Fare Matrix Configuration</h3></div>
//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}>Up Route</button>
//           <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}>Down Route</button>
//         </div>
//       )}
//       {activeMatrixTab === 'up' && renderMatrix('up')}
//       {activeMatrixTab === 'down' && renderMatrix('down')}
//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
//         <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Seat Layout Configuration</h3></div>

//       <div className="section-card">
//         <h4>Bus Configuration</h4>
//         <div className="config-buttons">
//           {availableConfigurations.map(config => (
//             <button key={config}
//               className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//               onClick={() => setSelectedConfiguration(config)}>
//               {config}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Select Template</h4>
//         <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Layout Template
//         </button>
//         {selectedTemplate && (
//           <div className="selected-template">
//             Selected: {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4>Seat Layout</h4>
//           <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
//             View / Edit Seats
//           </button>
//           <div className="seat-summary">
//             <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
//         <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
//           {isSubmitting ? 'Updating...' : 'Update Bus'}
//         </button>
//       </div>
//     </div>
//   );

//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Configure Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="templates-grid">
//             {layoutTemplates.map(template => (
//               <button key={template._id} className="template-card"
//                 onClick={() => handleSelectTemplate(template)}>
//                 <h4>{template.name}</h4>
//                 <div>Config: {template.configuration}</div>
//                 <div>Seats: {template.totalSeats}</div>
//                 <div>Type: {template.seatType || 'seat'}</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header"><h3>Set Seat Label</h3></div>
//         <div className="modal-body">
//           <input type="text" value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="Seat number" autoFocus />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button onClick={() => {
//             setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//             setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//             setEditingSeat(null);
//           }}>Disable</button>
//           <button onClick={() => {
//             if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]);
//             if (!blockedSeats.includes(editingSeat)) setBlockedSeats([...blockedSeats, editingSeat]);
//             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//             setEditingSeat(null);
//           }}>Block</button>
//           <button onClick={() => {
//             if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]);
//             setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//             setEditingSeat(null);
//           }}>Active</button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
//             <p className="modal-subtitle">Update bus configuration</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body modern">
//           <ProgressSteps />
//           {activeTab === 'basic' && renderBasicInfoTab()}
//           {activeTab === 'route' && renderRouteTab()}
//           {activeTab === 'matrix' && renderMatrixTab()}
//           {activeTab === 'seats' && renderSeatLayoutTab()}
//           {error && <div className="error-message modern">{error}</div>}
//         </div>
//       </div>
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// export default EditBusModal;


// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes,getRouteById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusManagementModal.css';

// // Platform Fee Configuration Component
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
//       <h4 className="card-title" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//         <span className="title-icon" style={{ fontSize: '20px' }}>💰</span>
//         Platform Fee Configuration
//       </h4>

//       <div className="platform-fee-container">
//         <div className="form-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               {platformFee.type === 'fixed' 
//                 ? 'Charge a fixed amount per booking' 
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

// <div className="form-group">
//   <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
//     {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//   </label>
//   <input
//     type="number"
//     min="0"
//     step={platformFee.type === 'fixed' ? "1" : "0.1"}
//     value={platformFee.value === 0 ? '' : platformFee.value}
//     onChange={(e) => {
//       const rawValue = e.target.value;
//       const value = rawValue === '' ? 0 : parseFloat(rawValue);
//       onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//     }}
//     className="modern-input"
//     placeholder="0"
//     style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//   />
// </div>

//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="per_ticket">Per Ticket</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               Fee applied on each ticket
//             </small>
//           </div>
//         </div>

//         {/* Preview/Calculation Example */}
//         {platformFee.value > 0 && (
//           <div className="fee-preview" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
//             <div className="preview-title" style={{ fontWeight: '500', marginBottom: '5px' }}>Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed' 
//                   ? `₹${platformFee.value} per ticket`
//                   : `${platformFee.value}% of fare per ticket`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // Platform Fee State
//   const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Cancellation Time State
//   const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Existing Images/Video
//   const [existingImages, setExistingImages] = useState([]);
//   const [existingVideo, setExistingVideo] = useState(null);
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Store reconstructed route stops with distances (extracted from existing fareMatrix)
//   const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
//   const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ─── KEY: Load fareMatrix AND reconstruct routes with distances ───
// useEffect(() => {
//   const loadRouteData = async () => {
//     if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) return;

//     const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//     const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//     if (upSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixUp(upSchedule.fareMatrix);

//       // Reconstruct route with proper distanceFromOrigin from existing matrix
//       const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
//       setReconstructedRouteUp(reconstructed);

//       console.log("reconstructed : ", reconstructed)

//       if (reconstructed) {
//         setSourceCity(reconstructed.origin?.city || '');
//         setDestinationCity(reconstructed.destination?.city || '');

//         // Fetch the full route data to get localRouteName and other details
//         let fullRoute = null;
//         try {
//           // Get the route ID from the schedule
//           const routeId = upSchedule.routeId;
//           console.log("Fetching route details for ID:", routeId);

//           const response = await getRouteById(routeId, token);
//           console.log("Full route response:", response);

//           if (response && response.success && response.data) {
//             fullRoute = response.data;
//           } else if (response && response.data) {
//             fullRoute = response.data;
//           }
//         } catch (err) {
//           console.error("Error fetching route details:", err);
//         }

//         // Use the bus's localRouteName if available, otherwise from the route
//         const localRouteName = bus.localRouteName || fullRoute?.localRouteName || null;
//         console.log("Setting localRouteName:", localRouteName);

//         setSelectedRoute({
//           _id: upSchedule.routeId,
//           routeName: upSchedule.routeName ||
//             `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
//           localRouteName: localRouteName, // Add this line
//           origin: reconstructed.origin,
//           destination: reconstructed.destination,
//           intermediateStops: reconstructed.intermediateStops || [],
//           routeDetails: reconstructed.routeDetails,
//           // Store the stops array for generateMatrixForRoute
//           stops: reconstructed.stops,
//           returnJourney: downSchedule ? (() => {
//             const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//             setReconstructedRouteDown(downReconstructed);
//             return downReconstructed;
//           })() : null
//         });
//       }
//     }

//     if (downSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixDown(downSchedule.fareMatrix);
//       if (!upSchedule?.fareMatrix?.length) {
//         const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//         setReconstructedRouteDown(downReconstructed);
//       }
//     }
//   };

//   loadRouteData();
// }, [bus]); // Make sure to include token in dependencies if needed



//   // ─── KEY FIX: Reconstruct stops with cumulative distances from fareMatrix ───
//   const reconstructStopsFromMatrix = (fareMatrix) => {
//     if (!fareMatrix || fareMatrix.length === 0) return null;

//     const stops = [];

//     // Origin stop
//     stops.push({
//       id: fareMatrix[0].fromId || 'origin',
//       name: fareMatrix[0].fromName,
//       distanceFromOrigin: 0,
//       type: fareMatrix[0].fromType || 'origin'
//     });

//     // Read the first row's toCells to get distances from origin to all other stops
//     const firstRowCells = fareMatrix[0].toCells || [];
//     firstRowCells.forEach((cell) => {
//       if (cell) {
//         stops.push({
//           id: cell.toId || cell.toName,
//           name: cell.toName,
//           distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
//           type: 'stop'
//         });
//       }
//     });

//     // Mark the last stop as destination
//     if (stops.length > 1) {
//       stops[stops.length - 1].type = 'destination';
//     }

//     return {
//       stops,
//       origin: { city: stops[0]?.name },
//       destination: { city: stops[stops.length - 1]?.name },
//       intermediateStops: stops.slice(1, -1).map((s, idx) => ({
//         city: s.name,
//         distanceFromOrigin: s.distanceFromOrigin,
//         sequence: idx + 1
//       })),
//       routeDetails: {
//         totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
//       }
//     };
//   };

//   // ─── generateMatrixForRoute: uses distanceFromOrigin for correct pricing ───
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     let allStops = [];

//     // If routeData has pre-built stops array (from reconstructed route), use it directly
//     if (routeData.stops && routeData.stops.length > 0) {
//       allStops = routeData.stops.map(s => ({
//         id: s.id || s.name,
//         name: s.name,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: s.type
//       }));
//     } else {
//       // Build from route object (newly selected route from dropdown)
//       const sortedStops = [...(routeData.intermediateStops || [])]
//         .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//       allStops = [
//         {
//           id: 'origin',
//           name: routeData.origin?.city || 'Origin',
//           distanceFromOrigin: 0,
//           type: 'origin'
//         },
//         ...sortedStops.map((s, i) => ({
//           id: s._id || `stop_${i}`,
//           name: s.city || s.name || `Stop ${i + 1}`,
//           distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//           type: 'stop',
//           sequence: s.sequence
//         })),
//         {
//           id: 'destination',
//           name: routeData.destination?.city || 'Destination',
//           distanceFromOrigin:
//             parseFloat(routeData.destination?.distanceFromOrigin) ||
//             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//           type: 'destination'
//         }
//       ];
//     }

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromType !== 'destination');
//   };

// // Update the useEffect that initializes form data with proper platform fee parsing

// useEffect(() => {
//   if (bus) {
//     console.log('Loading bus data for edit:', bus);

//     setForm({
//       busNumber: bus.busNumber || '',
//       busName: bus.busName || '',
//       busType: bus.busType || 'AC',
//       busCategory: bus.busCategory || 'Seater',
//       amenities: bus.amenities || []
//     });

//     setTripType(bus.tripType || 'oneWay');

//     if (bus.bookingClosedBefore) {
//       setBookingClosedBefore(bus.bookingClosedBefore);
//     }

//     if (bus.cancellationTime) {
//       setCancellationTime(bus.cancellationTime);
//     } else {
//       setCancellationTime({ hours: 1, minutes: 0 });
//     }

//     // ========== FIXED: Platform Fee Loading ==========
//     if (bus.platformFee) {
//       console.log('Raw platform fee from bus:', bus.platformFee);
//       let parsedPlatformFee = null;

//       // Check if platformFee is already an object
//       if (typeof bus.platformFee === 'object' && bus.platformFee !== null) {
//         parsedPlatformFee = bus.platformFee;
//       } 
//       // Check if it's a string that needs parsing
//       else if (typeof bus.platformFee === 'string') {
//         try {
//           // Clean up the string if it's malformed
//           let cleanString = bus.platformFee;

//           // Remove any escape characters
//           cleanString = cleanString.replace(/\\/g, '');

//           // Check if it's a valid JSON string
//           if (cleanString.startsWith('{') && cleanString.endsWith('}')) {
//             parsedPlatformFee = JSON.parse(cleanString);
//           } else {
//             // Try to extract values using regex if JSON parsing fails
//             const typeMatch = cleanString.match(/type["']?\s*:\s*["']?([^"',}]+)/i);
//             const valueMatch = cleanString.match(/value["']?\s*:\s*(\d+(?:\.\d+)?)/i);
//             const applicableOnMatch = cleanString.match(/applicableOn["']?\s*:\s*["']?([^"',}]+)/i);

//             parsedPlatformFee = {
//               type: typeMatch ? typeMatch[1] : 'fixed',
//               value: valueMatch ? parseFloat(valueMatch[1]) : 0,
//               applicableOn: applicableOnMatch ? applicableOnMatch[1] : 'per_ticket'
//             };
//           }
//         } catch (e) {
//           console.error('Error parsing platformFee string:', e);
//           parsedPlatformFee = null;
//         }
//       }

//       // If we have a valid parsed platform fee, use it
//       if (parsedPlatformFee && typeof parsedPlatformFee === 'object') {
//         console.log('Parsed platform fee:', parsedPlatformFee);
//         setPlatformFee({
//           type: parsedPlatformFee.type || 'fixed',
//           value: parseFloat(parsedPlatformFee.value) || 0,
//           applicableOn: parsedPlatformFee.applicableOn || 'per_ticket'
//         });
//       } else {
//         // Default fallback
//         console.log('No valid platform fee found, using default');
//         setPlatformFee({
//           type: 'fixed',
//           value: 0,
//           applicableOn: 'per_ticket'
//         });
//       }
//     } else {
//       console.log('No platform fee field in bus data');
//       setPlatformFee({
//         type: 'fixed',
//         value: 0,
//         applicableOn: 'per_ticket'
//       });
//     }

//     if (bus.operatingDays && bus.operatingDays.length > 0) {
//       setOperatingDays(bus.operatingDays);
//     }

//     if (bus.fareDetails) {
//       setPricing({
//         basePrice: bus.fareDetails.basePrice || '',
//         baseDistance: bus.fareDetails.baseDistance || '',
//         costPerKm: bus.fareDetails.costPerKm || ''
//       });
//     }

//     if (bus.images && bus.images.length > 0) {
//       setExistingImages(bus.images);
//     }
//     if (bus.video && bus.video.length > 0) {
//       setExistingVideo(bus.video[0]);
//     }

//     if (bus.seatConfiguration) {
//       setSelectedConfiguration(bus.seatConfiguration.busType || '2*2');
//     }

//     if (bus.seats && bus.seats.length > 0) {
//       const activeSeatNumbers = bus.seats
//         .filter(seat => seat.isAvailable !== false)
//         .map(seat => seat.seatNumber);
//       setActiveSeats(activeSeatNumbers);

//       const blockedSeatNumbers = bus.seats
//         .filter(seat => seat.isBlocked === true)
//         .map(seat => seat.seatNumber);
//       setBlockedSeats(blockedSeatNumbers);

//       const seatLabels = {};
//       bus.seats.forEach(seat => {
//         seatLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
//       });
//       setCustomSeatLabels(seatLabels);
//     }
//   }
// }, [bus]);

//   // ─── KEY: Load fareMatrix AND reconstruct routes with distances ───
//   useEffect(() => {
//     if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) return;

//     const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//     const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//     if (upSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixUp(upSchedule.fareMatrix);

//       // Reconstruct route with proper distanceFromOrigin from existing matrix
//       const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
//       setReconstructedRouteUp(reconstructed);

//       console.log("reconstructed : ",reconstructed)

//       if (reconstructed) {
//         setSourceCity(reconstructed.origin?.city || '');
//         setDestinationCity(reconstructed.destination?.city || '');

//         setSelectedRoute({
//           _id: upSchedule.routeId,
//           routeName: upSchedule.routeName ||
//             `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
//           origin: reconstructed.origin,
//           destination: reconstructed.destination,
//           intermediateStops: reconstructed.intermediateStops || [],
//           routeDetails: reconstructed.routeDetails,
//           // Store the stops array for generateMatrixForRoute
//           stops: reconstructed.stops,
//           returnJourney: downSchedule ? (() => {
//             const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//             setReconstructedRouteDown(downReconstructed);
//             return downReconstructed;
//           })() : null
//         });
//       }
//     }

//     if (downSchedule?.fareMatrix?.length > 0) {
//       setFareMatrixDown(downSchedule.fareMatrix);
//       if (!upSchedule?.fareMatrix?.length) {
//         const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//         setReconstructedRouteDown(downReconstructed);
//       }
//     }
//   }, [bus]);

//   // const fetchRoutesBySourceDestination = async () => {
//   //   if (!sourceCity || !destinationCity) {
//   //     setAvailableRoutes([]);
//   //     return;
//   //   }
//   //   setLoadingRoutes(true);
//   //   try {
//   //     const response = await getAllBusownerAdminRoutes(
//   //       token, 1, 50, '', '',
//   //       { originCity: sourceCity, destinationCity: destinationCity }
//   //     );
//   //     if (response && response.success && response.routes) {
//   //       setAvailableRoutes(response.routes);
//   //     } else {
//   //       setAvailableRoutes([]);
//   //     }
//   //   } catch (error) {
//   //     console.error('Error fetching routes:', error);
//   //     setAvailableRoutes([]);
//   //   } finally {
//   //     setLoadingRoutes(false);
//   //   }
//   // };

//   const fetchRoutesBySourceDestination = async () => {
//   if (!sourceCity || !destinationCity) {
//     setAvailableRoutes([]);
//     return;
//   }
//   setLoadingRoutes(true);
//   try {
//     const response = await getAllBusownerAdminRoutes(
//       token, 1, 50, '', '',
//       { originCity: sourceCity, destinationCity: destinationCity }
//     );
//     console.log("Fetched routes response:", response);

//     if (response && response.success && response.routes) {
//       // Ensure each route has localRouteName property
//       const routesWithLocalName = response.routes.map(route => ({
//         ...route,
//         localRouteName: route.localRouteName || null
//       }));
//       console.log("Routes with localRouteName:", routesWithLocalName);
//       setAvailableRoutes(routesWithLocalName);
//     } else {
//       setAvailableRoutes([]);
//     }
//   } catch (error) {
//     console.error('Error fetching routes:', error);
//     setAvailableRoutes([]);
//   } finally {
//     setLoadingRoutes(false);
//   }
// };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity && !selectedRoute) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   useEffect(() => {
//     if (selectedConfiguration && form.busCategory) {
//       fetchLayouts(selectedConfiguration);
//     }
//   }, [selectedConfiguration, form.busCategory]);

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);
//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;
//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') || cat.availableSeatTypes?.includes('seater'));
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper'));
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') || cat.availableSeatTypes?.includes('seat+sleeper'));
//         }
//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];
//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//             setSelectedConfiguration(configs[0]);
//           }
//         } else {
//           setAvailableConfigurations([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;
//       setLoadingLayouts(true);
//       let bustype = config.replace('x', '*');
//       const response = await getSeatLayoutsByBustype(bustype, token);
//       if (response && response.success && response.data && Array.isArray(response.data)) {
//         let filteredLayouts = response.data;
//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seat' || layout.seatType === 'seater');
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
//         }
//         setLayoutTemplates(filteredLayouts);
//       } else {
//         setLayoutTemplates([]);
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const getCategoryMultiplier = () => {
//     const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   // const handleSelectRoute = (route) => {
//   //   setSelectedRoute({ ...route, stops: null });
//   //   setShowRouteDropdown(false);
//   //   setRouteSearchTerm('');
//   //   setSourceCity(route.origin?.city || '');
//   //   setDestinationCity(route.destination?.city || '');
//   //   setFareMatrixUp([]);
//   //   setFareMatrixDown([]);
//   //   setReconstructedRouteUp(null);
//   //   setReconstructedRouteDown(null);
//   // };


//   const handleSelectRoute = (route) => {
//   // Store the complete route object including localRouteName
//   setSelectedRoute({ 
//     ...route, 
//     stops: null,
//     localRouteName: route.localRouteName // Ensure localRouteName is preserved
//   });
//   setShowRouteDropdown(false);
//   setRouteSearchTerm('');
//   setSourceCity(route.origin?.city || '');
//   setDestinationCity(route.destination?.city || '');
//   setFareMatrixUp([]);
//   setFareMatrixDown([]);
//   setReconstructedRouteUp(null);
//   setReconstructedRouteDown(null);

//   // Optional: Show a toast with the selected route info
//   if (route.localRouteName) {
//     toast.info(`Selected: ${route.localRouteName}`);
//   }
// };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
//     );
//   };

//   const handleAmenityToggle = (amenity) => {
//     setForm(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenity)
//         ? prev.amenities.filter(a => a !== amenity)
//         : [...prev.amenities, amenity]
//     }));
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];
//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({ file: file, preview: e.target.result, name: file.name });
//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeExistingImage = (index) => {
//     setExistingImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const removeNewImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeExistingVideo = () => setExistingVideo(null);
//   const removeNewVideo = () => setSelectedVideo(null);

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handleCancellationTimeChange = (field, value) => {
//     setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
//       }
//       return { ...row, toCells: newToCells };
//     });
//     if (isUp) setFareMatrixUp(updatedMatrix);
//     else setFareMatrixDown(updatedMatrix);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     if (!selectedTemplate || !selectedTemplate.seats) return;
//     const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });
//     let counter = 1;
//     const newLabels = {};
//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });
//     setCustomSeatLabels(newLabels);
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

// // const handleUpdateBus = async () => {
// //   try {
// //     setIsSubmitting(true);
// //     setError(null);

// //     // Validation checks...
// //     if (!form.busNumber) throw new Error('Bus Number is required');
// //     if (!form.busName) throw new Error('Bus Name is required');
// //     if (!form.busType) throw new Error('Bus Type is required');
// //     if (!form.busCategory) throw new Error('Bus Category is required');
// //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

// //     const amenitiesArray = form.amenities || [];

// //     let finalSeatsPayload = [];
// //     if (selectedTemplate && selectedTemplate.seats) {
// //       finalSeatsPayload = selectedTemplate.seats
// //         .filter(s => activeSeats.includes(s.seatNumber))
// //         .map(s => {
// //           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //           const isBlocked = blockedSeats.includes(s.seatNumber);
// //           return {
// //             seatNumber: s.seatNumber,
// //             globalSeatIndex: finalGlobalIndex,
// //             row: s.row,
// //             column: s.column,
// //             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //             position: s.position || getSeatPosition(s.column),
// //             isBlocked: isBlocked,
// //             isAvailable: !isBlocked,
// //           };
// //         });
// //     } else if (bus.seats) {
// //       finalSeatsPayload = bus.seats;
// //     }

// //     const seatConfigPayload = {
// //       busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
// //       totalSeats: activeSeats.length || bus.totalSeats
// //     };

// //     const formData = new FormData();
// //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //     formData.append('busName', form.busName.trim());
// //     formData.append('busType', form.busType);
// //     formData.append('busCategory', form.busCategory);
// //     formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
// //     formData.append('tripType', tripType);
// //     formData.append('busClass', 'Economy');
// //     formData.append('amenities', JSON.stringify(amenitiesArray));
// //     formData.append('seats', JSON.stringify(finalSeatsPayload));
// //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //     formData.append('operatingDays', JSON.stringify(operatingDays));
// //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
// //     formData.append('cancellationTime', JSON.stringify(cancellationTime));
// //     formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

// //     // ========== FIXED: Platform Fee saving - ensure it's a clean object ==========
// //     const cleanPlatformFee = {
// //       type: platformFee.type || 'fixed',
// //       value: parseFloat(platformFee.value) || 0,
// //       applicableOn: platformFee.applicableOn || 'per_ticket'
// //     };
// //     console.log('Saving platform fee:', cleanPlatformFee);
// //     formData.append('platformFee', JSON.stringify(cleanPlatformFee));

// //     const fareDetails = {
// //       basePrice: parseFloat(pricing.basePrice) || 0,
// //       baseDistance: parseFloat(pricing.baseDistance) || 0,
// //       costPerKm: parseFloat(pricing.costPerKm) || 0
// //     };
// //     formData.append('fareDetails', JSON.stringify(fareDetails));

// //       if (selectedRoute) {
// //         const routeSchedules = [{
// //           routeId: selectedRoute._id,
// //           direction: 'UP',
// //           fareMatrix: fareMatrixUp,
// //           operatingDays: operatingDays,
// //           departureTime: selectedRoute.origin?.departureTime || '08:00',
// //           arrivalTime: selectedRoute.destination?.arrivalTime || '20:00'
// //         }];
// //         if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //           routeSchedules.push({
// //             routeId: selectedRoute._id,
// //             direction: 'DOWN',
// //             fareMatrix: fareMatrixDown,
// //             operatingDays: operatingDays,
// //             departureTime: selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //             arrivalTime: selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //           });
// //         }
// //         formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //       } else if (bus.routeSchedules) {
// //         formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
// //       }

// //       if (existingImages.length > 0) {
// //         formData.append('existingImages', JSON.stringify(existingImages));
// //       }
// //       selectedImages.forEach((img) => {
// //         if (img.file) formData.append('images', img.file);
// //       });
// //       if (existingVideo) {
// //         formData.append('existingVideo', existingVideo);
// //       }
// //       if (selectedVideo && selectedVideo.file) {
// //         formData.append('videos', selectedVideo.file);
// //       }

// //      const response = await updateBus(bus._id, formData, token);

// //     if (response && response.success) {
// //       toast.success('Bus updated successfully!');
// //       if (onUpdate) onUpdate();
// //       onClose();
// //     } else {
// //       throw new Error(response?.message || 'Failed to update bus');
// //     }
// //   } catch (err) {
// //     console.error('Error updating bus:', err);
// //     setError(err.message || 'Failed to update bus');
// //     toast.error(err.message || 'Failed to update bus');
// //   } finally {
// //     setIsSubmitting(false);
// //   }
// // };

// const handleUpdateBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // Validation checks...
//     if (!form.busNumber) throw new Error('Bus Number is required');
//     if (!form.busName) throw new Error('Bus Name is required');
//     if (!form.busType) throw new Error('Bus Type is required');
//     if (!form.busCategory) throw new Error('Bus Category is required');
//     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

//     const amenitiesArray = form.amenities || [];

//     let finalSeatsPayload = [];
//     if (selectedTemplate && selectedTemplate.seats) {
//       finalSeatsPayload = selectedTemplate.seats
//         .filter(s => activeSeats.includes(s.seatNumber))
//         .map(s => {
//           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//           const isBlocked = blockedSeats.includes(s.seatNumber);
//           return {
//             seatNumber: s.seatNumber,
//             globalSeatIndex: finalGlobalIndex,
//             row: s.row,
//             column: s.column,
//             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//             position: s.position || getSeatPosition(s.column),
//             isBlocked: isBlocked,
//             isAvailable: !isBlocked,
//           };
//         });
//     } else if (bus.seats) {
//       finalSeatsPayload = bus.seats;
//     }

//     const seatConfigPayload = {
//       busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
//       totalSeats: activeSeats.length || bus.totalSeats
//     };

//     const formData = new FormData();
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
//     formData.append('tripType', tripType);
//     formData.append('busClass', 'Economy');
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('operatingDays', JSON.stringify(operatingDays));
//     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//     formData.append('cancellationTime', JSON.stringify(cancellationTime));
//     formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

//     // Platform Fee saving
//     const cleanPlatformFee = {
//       type: platformFee.type || 'fixed',
//       value: parseFloat(platformFee.value) || 0,
//       applicableOn: platformFee.applicableOn || 'per_ticket'
//     };
//     console.log('Saving platform fee:', cleanPlatformFee);
//     formData.append('platformFee', JSON.stringify(cleanPlatformFee));

//     const fareDetails = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       baseDistance: parseFloat(pricing.baseDistance) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0
//     };
//     formData.append('fareDetails', JSON.stringify(fareDetails));

//     // ========== ✅ FIXED: Build routeSchedules with proper structure ==========
//     let routeSchedulesToSend = [];

//     if (selectedRoute) {
//       console.log('Building routeSchedules from selectedRoute:', selectedRoute);

//       // Build UP schedule
//       const upSchedule = {
//         routeId: selectedRoute._id,
//         routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//         routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//         direction: 'UP',
//         operatingDays: operatingDays,
//         fareMatrix: fareMatrixUp,
//         origin: {
//           city: selectedRoute.origin?.city || sourceCity,
//           state: selectedRoute.origin?.state || 'West Bengal',
//           address: selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//           terminal: selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//           departureTime: selectedRoute.origin?.departureTime || '08:00',
//           timings: selectedRoute.origin?.timings || [
//             { timeSlotSequence: 1, departureTime: '08:00', arrivalTime: '' },
//             { timeSlotSequence: 2, departureTime: '12:00', arrivalTime: '' }
//           ],
//           coordinates: selectedRoute.origin?.coordinates || { lat: 0, lng: 0 }
//         },
//         destination: {
//           city: selectedRoute.destination?.city || destinationCity,
//           state: selectedRoute.destination?.state || 'West Bengal',
//           address: selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//           terminal: selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//           arrivalTime: selectedRoute.destination?.arrivalTime || '10:00',
//           timings: selectedRoute.destination?.timings || [
//             { timeSlotSequence: 1, arrivalTime: '10:00', departureTime: '' },
//             { timeSlotSequence: 2, arrivalTime: '14:00', departureTime: '' }
//           ],
//           coordinates: selectedRoute.destination?.coordinates || { lat: 0, lng: 0 },
//           distanceFromOrigin: selectedRoute.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//         },
//         intermediateStops: selectedRoute.intermediateStops || [],
//         additionalBoardingPoints: selectedRoute.additionalBoardingPoints || [],
//         additionalDroppingPoints: selectedRoute.additionalDroppingPoints || [],
//         additionalNullPoints: selectedRoute.additionalNullPoints || [],
//         routeDetails: {
//           totalDistance: selectedRoute.routeDetails?.totalDistance || 100,
//           estimatedDuration: selectedRoute.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//         },
//         isActive: true,
//         validFrom: new Date()
//       };

//       routeSchedulesToSend.push(upSchedule);

//       // Build DOWN schedule for round trip
//       if (tripType === 'roundTrip') {
//         const returnJourney = selectedRoute.returnJourney;

//         if (returnJourney || fareMatrixDown.length > 0) {
//           const downSchedule = {
//             routeId: selectedRoute._id,
//             routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//             routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//             direction: 'DOWN',
//             operatingDays: operatingDays,
//             fareMatrix: fareMatrixDown,
//             origin: {
//               city: returnJourney?.origin?.city || selectedRoute.destination?.city || destinationCity,
//               state: returnJourney?.origin?.state || selectedRoute.destination?.state || 'West Bengal',
//               address: returnJourney?.origin?.address || selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//               terminal: returnJourney?.origin?.terminal || selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//               departureTime: returnJourney?.origin?.departureTime || '14:00',
//               timings: returnJourney?.origin?.timings || [
//                 { timeSlotSequence: 1, departureTime: '14:00', arrivalTime: '' },
//                 { timeSlotSequence: 2, departureTime: '18:00', arrivalTime: '' }
//               ],
//               coordinates: returnJourney?.origin?.coordinates || selectedRoute.destination?.coordinates || { lat: 0, lng: 0 }
//             },
//             destination: {
//               city: returnJourney?.destination?.city || selectedRoute.origin?.city || sourceCity,
//               state: returnJourney?.destination?.state || selectedRoute.origin?.state || 'West Bengal',
//               address: returnJourney?.destination?.address || selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//               terminal: returnJourney?.destination?.terminal || selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//               arrivalTime: returnJourney?.destination?.arrivalTime || '16:00',
//               timings: returnJourney?.destination?.timings || [
//                 { timeSlotSequence: 1, arrivalTime: '16:00', departureTime: '' },
//                 { timeSlotSequence: 2, arrivalTime: '20:00', departureTime: '' }
//               ],
//               coordinates: returnJourney?.destination?.coordinates || selectedRoute.origin?.coordinates || { lat: 0, lng: 0 },
//               distanceFromOrigin: returnJourney?.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//             },
//             intermediateStops: returnJourney?.intermediateStops || [],
//             additionalBoardingPoints: returnJourney?.additionalBoardingPoints || [],
//             additionalDroppingPoints: returnJourney?.additionalDroppingPoints || [],
//             additionalNullPoints: returnJourney?.additionalNullPoints || [],
//             routeDetails: {
//               totalDistance: returnJourney?.routeDetails?.totalDistance || selectedRoute.routeDetails?.totalDistance || 100,
//               estimatedDuration: returnJourney?.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//             },
//             isActive: true,
//             validFrom: new Date()
//           };

//           routeSchedulesToSend.push(downSchedule);
//         }
//       }

//       console.log('Sending routeSchedules:', JSON.stringify(routeSchedulesToSend, null, 2));
//       formData.append('routeSchedules', JSON.stringify(routeSchedulesToSend));

//       // Also send localRouteName if available
//       if (selectedRoute.localRouteName) {
//         formData.append('localRouteName', selectedRoute.localRouteName);
//       }

//     } else if (bus.routeSchedules) {
//       // Use existing route schedules from bus
//       console.log('Using existing routeSchedules from bus');
//       formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));

//       // Preserve localRouteName from bus
//       if (bus.localRouteName) {
//         formData.append('localRouteName', bus.localRouteName);
//       }
//     }

//     // Handle images and videos
//     if (existingImages.length > 0) {
//       formData.append('existingImages', JSON.stringify(existingImages));
//     }
//     selectedImages.forEach((img) => {
//       if (img.file) formData.append('images', img.file);
//     });
//     if (existingVideo) {
//       formData.append('existingVideo', existingVideo);
//     }
//     if (selectedVideo && selectedVideo.file) {
//       formData.append('videos', selectedVideo.file);
//     }

//     // Log the routeSchedules being sent for debugging
//     console.log('RouteSchedules being sent:', routeSchedulesToSend);

//     const response = await updateBus(bus._id, formData, token);

//     if (response && response.success) {
//       toast.success('Bus updated successfully!');
//       if (onUpdate) onUpdate();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to update bus');
//     }
//   } catch (err) {
//     console.error('Error updating bus:', err);
//     setError(err.message || 'Failed to update bus');
//     toast.error(err.message || 'Failed to update bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   // ─── renderMatrix: same as before ───
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
//       <div className="matrix-placeholder">
//         <p>No fare matrix available. Please go back and generate the matrix.</p>
//       </div>
//     );

//     const allStops = [];
//     currentMatrix.forEach(row => {
//       if (!allStops.find(s => s.name === row.fromName)) {
//         allStops.push({ name: row.fromName, type: row.fromType });
//       }
//     });
//     const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
//     if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
//       allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
//     }

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                       </div>
//                     </td>
//                     {allStops.map((stop, colIndex) => {
//                       const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
//                       if (matchingCell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{matchingCell.distanceKm || 0} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="text"
//                                   className="matrix-input"
//                                   value={matchingCell.price}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (value === '' || /^\d+$/.test(value)) {
//                                       const actualColIndex = row.toCells.findIndex(
//                                         cell => cell && cell.toName === stop.name
//                                       );
//                                       handlePriceChange(type, rowIndex, actualColIndex, value);
//                                     }
//                                   }}
//                                   min="0"
//                                   step="1"
//                                   pattern="\d*"
//                                   inputMode="numeric"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return (
//       <div className="seat-placeholder">
//         <p>Select a template to configure seats</p>
//         <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Template
//         </button>
//       </div>
//     );

//     if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
//       return <div className="seat-placeholder">No seats available in this template</div>;
//     }

//     const { seats, configuration } = selectedTemplate;
//     let leftCount = 2, rightCount = 2;
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";
//       let seatClass = isSelected ? (isBlocked ? 'blocked' : 'selected') : 'inactive';
//       return (
//         <button key={seatObj.seatNumber} className={`seat-btn ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)} type="button">
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];
//       const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
//         </div>
//       );
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header"><div className="driver-area">Driver</div></div>
//         <div className="bus-body">{rows}</div>
//         <div className="seat-legend">
//           <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
//           <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked</span></div>
//           <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
//         </div>
//         <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
//           Auto-Number Seats
//         </button>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
//         <div className="step-icon">1</div><div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
//         <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
//         <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Edit Bus Information</h3></div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label>Bus Number *</label>
//           <input type="text" value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             className="modern-input" />
//         </div>
//         <div className="input-group">
//           <label>Bus Name *</label>
//           <input type="text" value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             className="modern-input" />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Bus Images</h4>
//         {existingImages.length > 0 && (
//           <div className="existing-images">
//             <label>Current Images</label>
//             <div className="images-grid">
//               {existingImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={`${process.env.REACT_APP_BASE_URL}/uploads/${img}`} alt="bus" />
//                   <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         <input type="file" id="edit-bus-images" multiple accept="image/*"
//           onChange={handleImageUpload} style={{ display: 'none' }} />
//         <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
//         {selectedImages.length > 0 && (
//           <div className="new-images">
//             <div className="images-grid">
//               {selectedImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={img.preview} alt="new" />
//                   <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Bus Type *</label>
//           <select value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select">
//             {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
//           </select>
//         </div>
//         <div className="form-group">
//           <label>Bus Category *</label>
//           <select value={form.busCategory}
//             onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
//             className="modern-select">
//             {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Booking Cut-off Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Cancellation Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="48" value={cancellationTime.hours}
//                 onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={cancellationTime.minutes}
//                 onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//         <small className="helper-text">Cancellation allowed up to this time before departure</small>
//       </div>

//       {/* Platform Fee Configuration */}
//       <PlatformFeeConfig platformFee={platformFee} onChange={setPlatformFee} />

//       <div className="section-card">
//         <h4>Amenities</h4>
//         <div className="amenities-grid">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-checkbox-label">
//               <input type="checkbox" checked={form.amenities.includes(amenity)}
//                 onChange={() => handleAmenityToggle(amenity)} />
//               <span>{amenity}</span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
//       </div>
//     </div>
//   );

//   // ... rest of the component remains the same (renderRouteTab, renderMatrixTab, renderSeatLayoutTab, etc.)

//   // const renderRouteTab = () => (
//   //   <div className="tab-content-wrapper">
//   //     <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//   //     <div className="section-card">
//   //       <h4>Trip Type</h4>
//   //       <div className="trip-type-container">
//   //         <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//   //           onClick={() => setTripType('oneWay')}>One Way</button>
//   //         <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//   //           onClick={() => setTripType('roundTrip')}>Round Trip</button>
//   //       </div>
//   //     </div>

//   //     <div className="section-card">
//   //       <h4>Source & Destination</h4>
//   //       <div className="form-row">
//   //         <div className="form-group">
//   //           <label>Source City</label>
//   //           <input type="text" value={sourceCity}
//   //             onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
//   //             placeholder="Enter source city" className="modern-input" />
//   //         </div>
//   //         <div className="form-group">
//   //           <label>Destination City</label>
//   //           <input type="text" value={destinationCity}
//   //             onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
//   //             placeholder="Enter destination city" className="modern-input" />
//   //         </div>
//   //       </div>
//   //     </div>

//   //     {sourceCity && destinationCity && (
//   //       <div className="section-card">
//   //         <h4>Select Route</h4>
//   //         <div className="route-selector">
//   //           <label>Available Routes</label>
//   //           <div className="route-dropdown-container">
//   //             <input
//   //               type="text"
//   //               value={selectedRoute ? selectedRoute.routeName : routeSearchTerm}
//   //               onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//   //               onChange={(e) => {
//   //                 setRouteSearchTerm(e.target.value);
//   //                 setShowRouteDropdown(true);
//   //                 setSelectedRoute(null);
//   //               }}
//   //               placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//   //               className="modern-input"
//   //             />
//   //             {showRouteDropdown && availableRoutes.length > 0 && (
//   //               <div className="route-dropdown">
//   //                 <div className="dropdown-search">
//   //                   <input type="text" value={routeSearchTerm}
//   //                     onChange={(e) => setRouteSearchTerm(e.target.value)}
//   //                     placeholder="Search routes..." className="dropdown-search-input" autoFocus />
//   //                 </div>
//   //                 <div className="dropdown-list">
//   //                   {availableRoutes
//   //                     .filter(route =>
//   //                       route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//   //                       route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase())
//   //                     )
//   //                     .map(route => (
//   //                       <div key={route._id} className="dropdown-item"
//   //                         onClick={() => handleSelectRoute(route)}>
//   //                         <div className="route-number">{route.routeName}</div>
//   //                         <div className="route-details">
//   //                           {route.origin?.city} → {route.destination?.city} •
//   //                           {route.routeDetails?.totalDistance || 0} km
//   //                         </div>
//   //                       </div>
//   //                     ))}
//   //                 </div>
//   //               </div>
//   //             )}
//   //           </div>
//   //           {selectedRoute && (
//   //             <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//   //               ✓ Route selected: {selectedRoute.routeName}
//   //             </small>
//   //           )}
//   //         </div>
//   //       </div>
//   //     )}

//   //     <div className="section-card">
//   //       <h4>Operating Days</h4>
//   //       <div className="days-grid">
//   //         {DAYS_OF_WEEK.map(day => (
//   //           <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//   //             onClick={() => toggleDay(day)}>
//   //             {day.substring(0, 3)}
//   //           </button>
//   //         ))}
//   //       </div>
//   //     </div>

//   //     <div className="section-card">
//   //       <h4>Pricing Configuration</h4>
//   //       <div className="form-row">
//   //         <div className="form-group">
//   //           <label>Base Price (₹) *</label>
//   //           <input type="number" value={pricing.basePrice}
//   //             onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//   //             placeholder="e.g., 100" className="modern-input" min="0" step="1" />
//   //         </div>
//   //         <div className="form-group">
//   //           <label>Base Distance (km) *</label>
//   //           <input type="number" value={pricing.baseDistance}
//   //             onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//   //             placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
//   //         </div>
//   //         <div className="form-group">
//   //           <label>Cost per km (₹) *</label>
//   //           <input type="number" value={pricing.costPerKm}
//   //             onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//   //             placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
//   //         </div>
//   //       </div>
//   //     </div>

//   //     <div className="form-actions">
//   //       <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//   //       <button
//   //         className="modern-btn primary"
//   //         onClick={() => {
//   //           if (!selectedRoute) {
//   //             toast.error('Please select a route first');
//   //             return;
//   //           }
//   //           if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//   //             toast.error('Please fill all pricing fields');
//   //             return;
//   //           }

//   //           const newMatrixUp = generateMatrixForRoute(selectedRoute);
//   //           setFareMatrixUp(newMatrixUp);

//   //           if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//   //             const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//   //             setFareMatrixDown(newMatrixDown);
//   //           }

//   //           toast.success('Fare matrix generated with updated pricing!');
//   //           setActiveTab('matrix');
//   //         }}
//   //       >
//   //         Continue to Fare Matrix →
//   //       </button>
//   //     </div>
//   //   </div>
//   // );

// // In EditBusModal.jsx, update the renderRouteTab function to display localRouteName:

// const renderRouteTab = () => (
//   <div className="tab-content-wrapper">
//     <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//     <div className="section-card">
//       <h4>Trip Type</h4>
//       <div className="trip-type-container">
//         <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//           onClick={() => setTripType('oneWay')}>One Way</button>
//         <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//           onClick={() => setTripType('roundTrip')}>Round Trip</button>
//       </div>
//     </div>

//     <div className="section-card">
//       <h4>Source & Destination</h4>
//       <div className="form-row">
//         <div className="form-group">
//           <label>Source City</label>
//           <input type="text" value={sourceCity}
//             onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
//             placeholder="Enter source city" className="modern-input" />
//         </div>
//         <div className="form-group">
//           <label>Destination City</label>
//           <input type="text" value={destinationCity}
//             onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
//             placeholder="Enter destination city" className="modern-input" />
//         </div>
//       </div>
//     </div>

//     {sourceCity && destinationCity && (
//       <div className="section-card">
//         <h4>Select Route</h4>
//         <div className="route-selector">
//           <label>Available Routes</label>
//           <div className="route-dropdown-container">
//             <input
//               type="text"
//               value={
//                 selectedRoute 
//                   ? (selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`)
//                   : routeSearchTerm
//               }
//               onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//               onChange={(e) => {
//                 setRouteSearchTerm(e.target.value);
//                 setShowRouteDropdown(true);
//                 setSelectedRoute(null);
//               }}
//               placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//               className="modern-input"
//             />
//             {showRouteDropdown && availableRoutes.length > 0 && (
//               <div className="route-dropdown">
//                 <div className="dropdown-search">
//                   <input type="text" value={routeSearchTerm}
//                     onChange={(e) => setRouteSearchTerm(e.target.value)}
//                     placeholder="Search routes..." className="dropdown-search-input" autoFocus />
//                 </div>
//                 <div className="dropdown-list">
//                   {availableRoutes
//                     .filter(route =>
//                       (route.localRouteName && route.localRouteName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                       (route.routeName && route.routeName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                       (route.origin?.city && route.origin.city.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                       (route.destination?.city && route.destination.city.toLowerCase().includes(routeSearchTerm.toLowerCase()))
//                     )
//                     .map(route => {
//                       // Debug log to see route data
//                       console.log("Route in dropdown:", {
//                         id: route._id,
//                         localRouteName: route.localRouteName,
//                         routeName: route.routeName
//                       });

//                       return (
//                         <div key={route._id} className="dropdown-item"
//                           onClick={() => handleSelectRoute(route)}>

//                           {/* Display local route name if available */}
//                           {route.localRouteName ? (
//                             <>
//                               <div className="route-number" style={{ fontWeight: 'bold', color: '#2c7da0' }}>
//                                 📍 {route.localRouteName}
//                               </div>
//                               <div className="route-details" style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
//                                 {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                 {route.isRoundTrip && ' • Round Trip'}
//                               </div>
//                             </>
//                           ) : (
//                             <>
//                               <div className="route-number" style={{ fontWeight: '500' }}>
//                                 {route.routeName || `${route.origin?.city} → ${route.destination?.city}`}
//                               </div>
//                               <div className="route-details" style={{ fontSize: '12px', color: '#6c757d' }}>
//                                 {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                 {route.isRoundTrip && ' • Round Trip'}
//                               </div>
//                             </>
//                           )}

//                           {route.creatorType === 'BusOwner' && (
//                             <span className="owner-badge" style={{
//                               marginLeft: '8px',
//                               fontSize: '10px',
//                               backgroundColor: '#ffc107',
//                               color: '#000',
//                               padding: '2px 6px',
//                               borderRadius: '4px'
//                             }}>
//                               Owner
//                             </span>
//                           )}
//                         </div>
//                       );
//                     })}
//                 </div>
//               </div>
//             )}
//           </div>
//           {selectedRoute && (
//             <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//               ✓ Route selected: {selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`}
//             </small>
//           )}
//         </div>
//       </div>
//     )}

//     {/* Rest of the component remains the same... */}
//     <div className="section-card">
//       <h4>Operating Days</h4>
//       <div className="days-grid">
//         {DAYS_OF_WEEK.map(day => (
//           <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//             onClick={() => toggleDay(day)}>
//             {day.substring(0, 3)}
//           </button>
//         ))}
//       </div>
//     </div>

//     <div className="section-card">
//       <h4>Pricing Configuration</h4>
//       <div className="form-row">
//         <div className="form-group">
//           <label>Base Price (₹) *</label>
//           <input type="number" value={pricing.basePrice}
//             onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//             placeholder="e.g., 100" className="modern-input" min="0" step="1" />
//         </div>
//         <div className="form-group">
//           <label>Base Distance (km) *</label>
//           <input type="number" value={pricing.baseDistance}
//             onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//             placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
//         </div>
//         <div className="form-group">
//           <label>Cost per km (₹) *</label>
//           <input type="number" value={pricing.costPerKm}
//             onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//             placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
//         </div>
//       </div>
//     </div>

//     <div className="form-actions">
//       <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//       <button
//         className="modern-btn primary"
//         onClick={() => {
//           if (!selectedRoute) {
//             toast.error('Please select a route first');
//             return;
//           }
//           if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//             toast.error('Please fill all pricing fields');
//             return;
//           }

//           const newMatrixUp = generateMatrixForRoute(selectedRoute);
//           setFareMatrixUp(newMatrixUp);

//           if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//             const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//             setFareMatrixDown(newMatrixDown);
//           }

//           toast.success('Fare matrix generated with updated pricing!');
//           setActiveTab('matrix');
//         }}
//       >
//         Continue to Fare Matrix →
//       </button>
//     </div>
//   </div>
// );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Fare Matrix Configuration</h3></div>
//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}>Up Route</button>
//           <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}>Down Route</button>
//         </div>
//       )}
//       {activeMatrixTab === 'up' && renderMatrix('up')}
//       {activeMatrixTab === 'down' && renderMatrix('down')}
//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
//         <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Seat Layout Configuration</h3></div>

//       <div className="section-card">
//         <h4>Bus Configuration</h4>
//         <div className="config-buttons">
//           {availableConfigurations.map(config => (
//             <button key={config}
//               className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//               onClick={() => setSelectedConfiguration(config)}>
//               {config}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Select Template</h4>
//         <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Layout Template
//         </button>
//         {selectedTemplate && (
//           <div className="selected-template">
//             Selected: {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4>Seat Layout</h4>
//           <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
//             View / Edit Seats
//           </button>
//           <div className="seat-summary">
//             <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
//         <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
//           {isSubmitting ? 'Updating...' : 'Update Bus'}
//         </button>
//       </div>
//     </div>
//   );

//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Configure Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="templates-grid">
//             {layoutTemplates.map(template => (
//               <button key={template._id} className="template-card"
//                 onClick={() => handleSelectTemplate(template)}>
//                 <h4>{template.name}</h4>
//                 <div>Config: {template.configuration}</div>
//                 <div>Seats: {template.totalSeats}</div>
//                 <div>Type: {template.seatType || 'seat'}</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header"><h3>Set Seat Label</h3></div>
//         <div className="modal-body">
//           <input type="text" value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="Seat number" autoFocus />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button onClick={() => {
//             setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//             setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//             setEditingSeat(null);
//           }}>Disable</button>
//           <button onClick={() => {
//             if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]);
//             if (!blockedSeats.includes(editingSeat)) setBlockedSeats([...blockedSeats, editingSeat]);
//             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//             setEditingSeat(null);
//           }}>Block</button>
//           <button onClick={() => {
//             if (!activeSeats.includes(editingSeat)) setActiveSeats([...activeSeats, editingSeat]);
//             setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//             setEditingSeat(null);
//           }}>Active</button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
//             <p className="modal-subtitle">Update bus configuration</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body modern">
//           <ProgressSteps />
//           {activeTab === 'basic' && renderBasicInfoTab()}
//           {activeTab === 'route' && renderRouteTab()}
//           {activeTab === 'matrix' && renderMatrixTab()}
//           {activeTab === 'seats' && renderSeatLayoutTab()}
//           {error && <div className="error-message modern">{error}</div>}
//         </div>
//       </div>
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// export default EditBusModal;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes, getRouteById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusManagementModal.css';

// // Platform Fee Configuration Component
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
//       <h4 className="card-title" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//         <span className="title-icon" style={{ fontSize: '20px' }}>💰</span>
//         Platform Fee Configuration
//       </h4>

//       <div className="platform-fee-container">
//         <div className="form-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               {platformFee.type === 'fixed'
//                 ? 'Charge a fixed amount per booking'
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
//               {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//             </label>
//             <input
//               type="number"
//               min="0"
//               step={platformFee.type === 'fixed' ? "1" : "0.1"}
//               value={platformFee.value === 0 ? '' : platformFee.value}
//               onChange={(e) => {
//                 const rawValue = e.target.value;
//                 const value = rawValue === '' ? 0 : parseFloat(rawValue);
//                 onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//               }}
//               className="modern-input"
//               placeholder="0"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             />
//           </div>

//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="per_ticket">Per Ticket</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               Fee applied on each ticket
//             </small>
//           </div>
//         </div>

//         {platformFee.value > 0 && (
//           <div className="fee-preview" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
//             <div className="preview-title" style={{ fontWeight: '500', marginBottom: '5px' }}>Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed'
//                   ? `₹${platformFee.value} per ticket`
//                   : `${platformFee.value}% of fare per ticket`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
//   console.log("bus received in EditBusModal:", bus);
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // Platform Fee State
//   const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Cancellation Time State
//   const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Existing Images/Video
//   const [existingImages, setExistingImages] = useState([]);
//   const [existingVideo, setExistingVideo] = useState(null);
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices - THESE SHOULD PRESERVE THE ORIGINAL PRICES
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Flag to track if we've loaded the initial data
//   const [initialDataLoaded, setInitialDataLoaded] = useState(false);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Store reconstructed route stops with distances (extracted from existing fareMatrix)
//   const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
//   const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ─── KEY: Load fareMatrix AND PRESERVE THE ORIGINAL PRICES ───
//   useEffect(() => {
//     const loadRouteData = async () => {
//       if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) {
//         console.log('No routeSchedules in bus:', bus);
//         return;
//       }

//       console.log('Loading route data from bus:', bus);
//       console.log('RouteSchedules:', bus.routeSchedules);

//       const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//       const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//       // ========== CRITICAL: PRESERVE THE ORIGINAL FARE MATRIX WITH PRICES ==========
//       if (upSchedule?.fareMatrix?.length > 0) {
//         // Log the original prices
//         const firstRow = upSchedule.fareMatrix[0];
//         if (firstRow?.toCells) {
//           const prices = firstRow.toCells
//             .filter(c => c !== null)
//             .map(c => ({ toName: c.toName, price: c.price }));
//           console.log('✅ Original UP FareMatrix prices:', prices);
//         }

//         // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
//         setFareMatrixUp(JSON.parse(JSON.stringify(upSchedule.fareMatrix)));

//         // Reconstruct route with proper distanceFromOrigin from existing matrix
//         const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
//         setReconstructedRouteUp(reconstructed);

//         if (reconstructed) {
//           setSourceCity(reconstructed.origin?.city || '');
//           setDestinationCity(reconstructed.destination?.city || '');

//           // Fetch the full route data to get localRouteName and other details
//           let fullRoute = null;
//           try {
//             const routeId = upSchedule.routeId;
//             console.log("Fetching route details for ID:", routeId);

//             const response = await getRouteById(routeId, token);
//             console.log("Full route response:", response);

//             if (response && response.success && response.data) {
//               fullRoute = response.data;
//             } else if (response && response.data) {
//               fullRoute = response.data;
//             }
//           } catch (err) {
//             console.error("Error fetching route details:", err);
//           }

//           const localRouteName = bus.localRouteName || fullRoute?.localRouteName || null;
//           console.log("Setting localRouteName:", localRouteName);

//           setSelectedRoute({
//             _id: upSchedule.routeId,
//             routeName: upSchedule.routeName ||
//               `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
//             localRouteName: localRouteName,
//             origin: reconstructed.origin,
//             destination: reconstructed.destination,
//             intermediateStops: reconstructed.intermediateStops || [],
//             routeDetails: reconstructed.routeDetails,
//             stops: reconstructed.stops,
//             returnJourney: downSchedule ? (() => {
//               const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//               setReconstructedRouteDown(downReconstructed);
//               return downReconstructed;
//             })() : null
//           });
//         }
//       }

//       if (downSchedule?.fareMatrix?.length > 0) {
//         // Log the original prices
//         const firstRow = downSchedule.fareMatrix[0];
//         if (firstRow?.toCells) {
//           const prices = firstRow.toCells
//             .filter(c => c !== null)
//             .map(c => ({ toName: c.toName, price: c.price }));
//           console.log('✅ Original DOWN FareMatrix prices:', prices);
//         }

//         // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
//         setFareMatrixDown(JSON.parse(JSON.stringify(downSchedule.fareMatrix)));
//         if (!upSchedule?.fareMatrix?.length) {
//           const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//           setReconstructedRouteDown(downReconstructed);
//         }
//       }

//       setInitialDataLoaded(true);
//     };

//     loadRouteData();
//   }, [bus, token]);

//   // ─── KEY FIX: Reconstruct stops with cumulative distances from fareMatrix ───
//   // This function ONLY reconstructs stops, it does NOT recalculate prices
//   const reconstructStopsFromMatrix = (fareMatrix) => {
//     if (!fareMatrix || fareMatrix.length === 0) return null;

//     const stops = [];

//     // Origin stop
//     stops.push({
//       id: fareMatrix[0].fromId || 'origin',
//       name: fareMatrix[0].fromName,
//       distanceFromOrigin: 0,
//       type: fareMatrix[0].fromType || 'origin'
//     });

//     // Read the first row's toCells to get distances from origin to all other stops
//     const firstRowCells = fareMatrix[0].toCells || [];
//     firstRowCells.forEach((cell) => {
//       if (cell) {
//         stops.push({
//           id: cell.toId || cell.toName,
//           name: cell.toName,
//           distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
//           type: 'stop'
//         });
//       }
//     });

//     // Mark the last stop as destination
//     if (stops.length > 1) {
//       stops[stops.length - 1].type = 'destination';
//     }

//     return {
//       stops,
//       origin: { city: stops[0]?.name },
//       destination: { city: stops[stops.length - 1]?.name },
//       intermediateStops: stops.slice(1, -1).map((s, idx) => ({
//         city: s.name,
//         distanceFromOrigin: s.distanceFromOrigin,
//         sequence: idx + 1
//       })),
//       routeDetails: {
//         totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
//       }
//     };
//   };

//   // ─── generateMatrixForRoute: This function is called when user clicks "Regenerate" ───
//   // It should ONLY be used when generating a NEW matrix, not when editing existing one
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     let allStops = [];

//     if (routeData.stops && routeData.stops.length > 0) {
//       allStops = routeData.stops.map(s => ({
//         id: s.id || s.name,
//         name: s.name,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: s.type
//       }));
//     } else {
//       const sortedStops = [...(routeData.intermediateStops || [])]
//         .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//       allStops = [
//         {
//           id: 'origin',
//           name: routeData.origin?.city || 'Origin',
//           distanceFromOrigin: 0,
//           type: 'origin'
//         },
//         ...sortedStops.map((s, i) => ({
//           id: s._id || `stop_${i}`,
//           name: s.city || s.name || `Stop ${i + 1}`,
//           distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//           type: 'stop',
//           sequence: s.sequence
//         })),
//         {
//           id: 'destination',
//           name: routeData.destination?.city || 'Destination',
//           distanceFromOrigin:
//             parseFloat(routeData.destination?.distanceFromOrigin) ||
//             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//           type: 'destination'
//         }
//       ];
//     }

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromType !== 'destination');
//   };

//   // ─── Update the useEffect that initializes form data with proper platform fee parsing ───
//   // Update the useEffect that initializes form data - specifically the seats section
//   useEffect(() => {
//     if (bus) {
//       console.log('Loading bus data for edit:', bus);

//       setForm({
//         busNumber: bus.busNumber || '',
//         busName: bus.busName || '',
//         busType: bus.busType || 'AC',
//         busCategory: bus.busCategory || 'Seater',
//         amenities: bus.amenities || []
//       });

//       setTripType(bus.tripType || 'oneWay');

//       if (bus.bookingClosedBefore) {
//         setBookingClosedBefore(bus.bookingClosedBefore);
//       }

//       if (bus.cancellationTime) {
//         setCancellationTime(bus.cancellationTime);
//       } else {
//         setCancellationTime({ hours: 1, minutes: 0 });
//       }

// // Platform Fee Loading - FIXED
// if (bus.platformFee) {
//   setPlatformFee({
//     type: bus.platformFee.type || 'fixed',
//     value: bus.platformFee.value || 0,
//     applicableOn: bus.platformFee.applicableOn || 'per_ticket'
//   });
// } else {
//   // Set default if no platform fee exists
//   setPlatformFee({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });
// }

//       if (bus.operatingDays && bus.operatingDays.length > 0) {
//         setOperatingDays(bus.operatingDays);
//       }

//       if (bus.fareDetails) {
//         setPricing({
//           basePrice: bus.fareDetails.basePrice || '',
//           baseDistance: bus.fareDetails.baseDistance || '',
//           costPerKm: bus.fareDetails.costPerKm || ''
//         });
//       }

//       if (bus.images && bus.images.length > 0) {
//         setExistingImages(bus.images);
//       }
//       if (bus.video && bus.video.length > 0) {
//         setExistingVideo(bus.video[0]);
//       }

//       if (bus.seatConfiguration) {
//         setSelectedConfiguration(bus.seatConfiguration.busType || '2*2');
//       }

//       // ========== FIX: Load seats with proper labels from database ==========
//       if (bus.seats && bus.seats.length > 0) {
//         // Get all seat numbers that are available
//         const activeSeatNumbers = bus.seats
//           .filter(seat => seat.isAvailable !== false)
//           .map(seat => seat.seatNumber);
//         setActiveSeats(activeSeatNumbers);

//         // Get blocked seats
//         const blockedSeatNumbers = bus.seats
//           .filter(seat => seat.isBlocked === true)
//           .map(seat => seat.seatNumber);
//         setBlockedSeats(blockedSeatNumbers);

//         // ========== KEY FIX: Use the seat numbers from the database ==========
//         // The seat number is already the display label (e.g., S1, S2, B1, etc.)
//         const seatLabels = {};
//         bus.seats.forEach(seat => {
//           // Use the seatNumber as the label (this is what you want to display)
//           // If you have a custom display name, use that instead
//           const displayLabel = seat.seatNumber || seat.globalSeatIndex || seat.seatNumber;
//           seatLabels[seat.seatNumber] = displayLabel;
//         });
//         setCustomSeatLabels(seatLabels);

//         console.log('Loaded seat labels from database:', seatLabels);
//         console.log('Active seats:', activeSeatNumbers);
//         console.log('Blocked seats:', blockedSeatNumbers);
//       }
//     }
//   }, [bus]);

//   // ─── Rest of the component (fetchRoutes, handlers, render functions) ───
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }
//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token, 1, 50, '', '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
//       console.log("Fetched routes response:", response);

//       if (response && response.success && response.routes) {
//         const routesWithLocalName = response.routes.map(route => ({
//           ...route,
//           localRouteName: route.localRouteName || null
//         }));
//         setAvailableRoutes(routesWithLocalName);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity && !selectedRoute) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   useEffect(() => {
//     if (selectedConfiguration && form.busCategory) {
//       fetchLayouts(selectedConfiguration);
//     }
//   }, [selectedConfiguration, form.busCategory]);

//   // const fetchAvailableConfigurations = async () => {
//   //   try {
//   //     setLoadingLayouts(true);
//   //     const response = await getAllCategory(token);
//   //     if (response && response.success && response.data) {
//   //       let relevantCategories = response.data;
//   //       if (form.busCategory === 'Seater') {
//   //         relevantCategories = response.data.filter(cat =>
//   //           cat.availableSeatTypes?.includes('seat') || cat.availableSeatTypes?.includes('seater'));
//   //       } else if (form.busCategory === 'Sleeper') {
//   //         relevantCategories = response.data.filter(cat =>
//   //           cat.availableSeatTypes?.includes('sleeper'));
//   //       } else if (form.busCategory === 'Seater+Sleeper') {
//   //         relevantCategories = response.data.filter(cat =>
//   //           cat.availableSeatTypes?.includes('seater+sleeper') || cat.availableSeatTypes?.includes('seat+sleeper'));
//   //       }
//   //       const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];
//   //       if (configs.length > 0) {
//   //         setAvailableConfigurations(configs);
//   //         if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//   //           setSelectedConfiguration(configs[0]);
//   //         }
//   //       } else {
//   //         setAvailableConfigurations([]);
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error('Error fetching configurations:', error);
//   //     setAvailableConfigurations([]);
//   //   } finally {
//   //     setLoadingLayouts(false);
//   //   }
//   // };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       // Pass the busCategory to the API
//       const response = await getAllCategory(token, form.busCategory);
//       if (response && response.success && response.data) {
//         // The API now handles filtering, so we don't need to filter again
//         const configs = [...new Set(response.data.map(cat => cat.configuration))];
//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//             setSelectedConfiguration(configs[0]);
//           }
//         } else {
//           setAvailableConfigurations([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;
//       setLoadingLayouts(true);
//       let bustype = config.replace('x', '*');
//       const response = await getSeatLayoutsByBustype(bustype, token);
//       if (response && response.success && response.data && Array.isArray(response.data)) {
//         let filteredLayouts = response.data;
//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seat' || layout.seatType === 'seater');
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout =>
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
//         }
//         setLayoutTemplates(filteredLayouts);
//       } else {
//         setLayoutTemplates([]);
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const getCategoryMultiplier = () => {
//     const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const handleSelectRoute = (route) => {
//     setSelectedRoute({
//       ...route,
//       stops: null,
//       localRouteName: route.localRouteName
//     });
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setSourceCity(route.origin?.city || '');
//     setDestinationCity(route.destination?.city || '');
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//     setReconstructedRouteUp(null);
//     setReconstructedRouteDown(null);

//     if (route.localRouteName) {
//       toast.info(`Selected: ${route.localRouteName}`);
//     }
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
//     );
//   };

//   const handleAmenityToggle = (amenity) => {
//     setForm(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenity)
//         ? prev.amenities.filter(a => a !== amenity)
//         : [...prev.amenities, amenity]
//     }));
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];
//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({ file: file, preview: e.target.result, name: file.name });
//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeExistingImage = (index) => {
//     setExistingImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const removeNewImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeExistingVideo = () => setExistingVideo(null);
//   const removeNewVideo = () => setSelectedVideo(null);

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handleCancellationTimeChange = (field, value) => {
//     setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
//       }
//       return { ...row, toCells: newToCells };
//     });
//     if (isUp) setFareMatrixUp(updatedMatrix);
//     else setFareMatrixDown(updatedMatrix);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);

//     // ========== FIX: Use the existing label from customSeatLabels ==========
//     const existingLabel = customSeatLabels[seatObj.seatNumber];

//     if (activeSeats.includes(seatObj.seatNumber)) {
//       // If the seat is active, show its current label
//       setTempSeatLabel(String(existingLabel || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       // If the seat is inactive, show the seat number as default
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     if (!selectedTemplate || !selectedTemplate.seats) return;
//     const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });
//     let counter = 1;
//     const newLabels = {};
//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });
//     setCustomSeatLabels(newLabels);
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // ========== UPDATE BUS FUNCTION ==========
//   const handleUpdateBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       // Validation checks...
//       if (!form.busNumber) throw new Error('Bus Number is required');
//       if (!form.busName) throw new Error('Bus Name is required');
//       if (!form.busType) throw new Error('Bus Type is required');
//       if (!form.busCategory) throw new Error('Bus Category is required');
//       if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

//       const amenitiesArray = form.amenities || [];

//       let finalSeatsPayload = [];
//       if (selectedTemplate && selectedTemplate.seats) {
//         finalSeatsPayload = selectedTemplate.seats
//           .filter(s => activeSeats.includes(s.seatNumber))
//           .map(s => {
//             // ========== FIX: Use the label from customSeatLabels ==========
//             const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//             const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//             const isBlocked = blockedSeats.includes(s.seatNumber);

//             return {
//               seatNumber: s.seatNumber,  // Keep the original seat number
//               globalSeatIndex: finalGlobalIndex,  // This is what's displayed
//               row: s.row,
//               column: s.column,
//               seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//               position: s.position || getSeatPosition(s.column),
//               isBlocked: isBlocked,
//               isAvailable: !isBlocked,
//             };
//           });
//       } else if (bus.seats) {
//         // If no template selected, use existing seats but update labels
//         finalSeatsPayload = bus.seats.map(seat => {
//           const label = customSeatLabels[seat.seatNumber] || seat.globalSeatIndex || seat.seatNumber;
//           return {
//             ...seat,
//             globalSeatIndex: label,
//           };
//         });
//       }

//       const seatConfigPayload = {
//         busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
//         totalSeats: activeSeats.length || bus.totalSeats
//       };

//       const formData = new FormData();
//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');
//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('operatingDays', JSON.stringify(operatingDays));
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//       formData.append('cancellationTime', JSON.stringify(cancellationTime));
//       formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

//       const cleanPlatformFee = {
//         type: platformFee.type || 'fixed',
//         value: parseFloat(platformFee.value) || 0,
//         applicableOn: platformFee.applicableOn || 'per_ticket'
//       };
//       formData.append('platformFee', JSON.stringify(cleanPlatformFee));

//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };
//       formData.append('fareDetails', JSON.stringify(fareDetails));

//       // ========== Build routeSchedules with the CORRECT fareMatrix from state ==========
//       let routeSchedulesToSend = [];

//       if (selectedRoute) {
//         // Build UP schedule with fareMatrixUp (which has the original prices)
//         const upSchedule = {
//           routeId: selectedRoute._id,
//           routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//           routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//           direction: 'UP',
//           operatingDays: operatingDays,
//           fareMatrix: fareMatrixUp, // ← This has the PRESERVED original prices
//           origin: {
//             city: selectedRoute.origin?.city || sourceCity,
//             state: selectedRoute.origin?.state || 'West Bengal',
//             address: selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//             terminal: selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//             departureTime: selectedRoute.origin?.departureTime || '08:00',
//             timings: selectedRoute.origin?.timings || [
//               { timeSlotSequence: 1, departureTime: '08:00', arrivalTime: '' },
//               { timeSlotSequence: 2, departureTime: '12:00', arrivalTime: '' }
//             ],
//             coordinates: selectedRoute.origin?.coordinates || { lat: 0, lng: 0 }
//           },
//           destination: {
//             city: selectedRoute.destination?.city || destinationCity,
//             state: selectedRoute.destination?.state || 'West Bengal',
//             address: selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//             terminal: selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//             arrivalTime: selectedRoute.destination?.arrivalTime || '10:00',
//             timings: selectedRoute.destination?.timings || [
//               { timeSlotSequence: 1, arrivalTime: '10:00', departureTime: '' },
//               { timeSlotSequence: 2, arrivalTime: '14:00', departureTime: '' }
//             ],
//             coordinates: selectedRoute.destination?.coordinates || { lat: 0, lng: 0 },
//             distanceFromOrigin: selectedRoute.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//           },
//           intermediateStops: selectedRoute.intermediateStops || [],
//           additionalBoardingPoints: selectedRoute.additionalBoardingPoints || [],
//           additionalDroppingPoints: selectedRoute.additionalDroppingPoints || [],
//           additionalNullPoints: selectedRoute.additionalNullPoints || [],
//           routeDetails: {
//             totalDistance: selectedRoute.routeDetails?.totalDistance || 100,
//             estimatedDuration: selectedRoute.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//           },
//           isActive: true,
//           validFrom: new Date()
//         };

//         routeSchedulesToSend.push(upSchedule);

//         // Build DOWN schedule for round trip with fareMatrixDown
//         if (tripType === 'roundTrip') {
//           const returnJourney = selectedRoute.returnJourney;

//           if (returnJourney || fareMatrixDown.length > 0) {
//             const downSchedule = {
//               routeId: selectedRoute._id,
//               routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//               routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//               direction: 'DOWN',
//               operatingDays: operatingDays,
//               fareMatrix: fareMatrixDown, // ← This has the PRESERVED original prices
//               origin: {
//                 city: returnJourney?.origin?.city || selectedRoute.destination?.city || destinationCity,
//                 state: returnJourney?.origin?.state || selectedRoute.destination?.state || 'West Bengal',
//                 address: returnJourney?.origin?.address || selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//                 terminal: returnJourney?.origin?.terminal || selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//                 departureTime: returnJourney?.origin?.departureTime || '14:00',
//                 timings: returnJourney?.origin?.timings || [
//                   { timeSlotSequence: 1, departureTime: '14:00', arrivalTime: '' },
//                   { timeSlotSequence: 2, departureTime: '18:00', arrivalTime: '' }
//                 ],
//                 coordinates: returnJourney?.origin?.coordinates || selectedRoute.destination?.coordinates || { lat: 0, lng: 0 }
//               },
//               destination: {
//                 city: returnJourney?.destination?.city || selectedRoute.origin?.city || sourceCity,
//                 state: returnJourney?.destination?.state || selectedRoute.origin?.state || 'West Bengal',
//                 address: returnJourney?.destination?.address || selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//                 terminal: returnJourney?.destination?.terminal || selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//                 arrivalTime: returnJourney?.destination?.arrivalTime || '16:00',
//                 timings: returnJourney?.destination?.timings || [
//                   { timeSlotSequence: 1, arrivalTime: '16:00', departureTime: '' },
//                   { timeSlotSequence: 2, arrivalTime: '20:00', departureTime: '' }
//                 ],
//                 coordinates: returnJourney?.destination?.coordinates || selectedRoute.origin?.coordinates || { lat: 0, lng: 0 },
//                 distanceFromOrigin: returnJourney?.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//               },
//               intermediateStops: returnJourney?.intermediateStops || [],
//               additionalBoardingPoints: returnJourney?.additionalBoardingPoints || [],
//               additionalDroppingPoints: returnJourney?.additionalDroppingPoints || [],
//               additionalNullPoints: returnJourney?.additionalNullPoints || [],
//               routeDetails: {
//                 totalDistance: returnJourney?.routeDetails?.totalDistance || selectedRoute.routeDetails?.totalDistance || 100,
//                 estimatedDuration: returnJourney?.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//               },
//               isActive: true,
//               validFrom: new Date()
//             };

//             routeSchedulesToSend.push(downSchedule);
//           }
//         }

//         console.log('Sending routeSchedules with fareMatrix:', JSON.stringify(routeSchedulesToSend, null, 2));
//         formData.append('routeSchedules', JSON.stringify(routeSchedulesToSend));

//         if (selectedRoute.localRouteName) {
//           formData.append('localRouteName', selectedRoute.localRouteName);
//         }

//       } else if (bus.routeSchedules) {
//         formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
//         if (bus.localRouteName) {
//           formData.append('localRouteName', bus.localRouteName);
//         }
//       }

//       // Handle images and videos
//       if (existingImages.length > 0) {
//         formData.append('existingImages', JSON.stringify(existingImages));
//       }
//       selectedImages.forEach((img) => {
//         if (img.file) formData.append('images', img.file);
//       });
//       if (existingVideo) {
//         formData.append('existingVideo', existingVideo);
//       }
//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       const response = await updateBus(bus._id, formData, token);

//       if (response && response.success) {
//         toast.success('Bus updated successfully!');
//         if (onUpdate) onUpdate();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to update bus');
//       }
//     } catch (err) {
//       console.error('Error updating bus:', err);
//       setError(err.message || 'Failed to update bus');
//       toast.error(err.message || 'Failed to update bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ─── renderMatrix: Renders the fare matrix with preserved prices ───
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
//       <div className="matrix-placeholder">
//         <p>No fare matrix available. Please go back and generate the matrix.</p>
//       </div>
//     );

//     const allStops = [];
//     currentMatrix.forEach(row => {
//       if (!allStops.find(s => s.name === row.fromName)) {
//         allStops.push({ name: row.fromName, type: row.fromType });
//       }
//     });
//     const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
//     if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
//       allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
//     }

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                       </div>
//                     </td>
//                     {allStops.map((stop, colIndex) => {
//                       const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
//                       if (matchingCell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{matchingCell.distanceKm || 0} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="text"
//                                   className="matrix-input"
//                                   value={matchingCell.price}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (value === '' || /^\d+$/.test(value)) {
//                                       const actualColIndex = row.toCells.findIndex(
//                                         cell => cell && cell.toName === stop.name
//                                       );
//                                       handlePriceChange(type, rowIndex, actualColIndex, value);
//                                     }
//                                   }}
//                                   min="0"
//                                   step="1"
//                                   pattern="\d*"
//                                   inputMode="numeric"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ─── renderSeatVisualizer ───
//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return (
//       <div className="seat-placeholder">
//         <p>Select a template to configure seats</p>
//         <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Template
//         </button>
//       </div>
//     );

//     if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
//       return <div className="seat-placeholder">No seats available in this template</div>;
//     }

//     const { seats, configuration } = selectedTemplate;
//     let leftCount = 2, rightCount = 2;
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       // ========== FIX: Use the label from customSeatLabels or fallback ==========
//       let displayLabel = '';

//       if (isSelected) {
//         // Check if we have a custom label (from database)
//         if (customSeatLabels[seatObj.seatNumber]) {
//           displayLabel = customSeatLabels[seatObj.seatNumber];
//         } else if (seatObj.globalSeatIndex) {
//           displayLabel = seatObj.globalSeatIndex;
//         } else {
//           displayLabel = seatObj.seatNumber;
//         }
//       }

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];
//       const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
//         </div>
//       );
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header"><div className="driver-area">Driver</div></div>
//         <div className="bus-body">{rows}</div>
//         <div className="seat-legend">
//           <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
//           <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked</span></div>
//           <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
//         </div>
//         <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
//           Auto-Number Seats
//         </button>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
//         <div className="step-icon">1</div><div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
//         <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
//         <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   // ─── renderBasicInfoTab ───
//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Edit Bus Information</h3></div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label>Bus Number *</label>
//           <input type="text" value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             className="modern-input" />
//         </div>
//         <div className="input-group">
//           <label>Bus Name *</label>
//           <input type="text" value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             className="modern-input" />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Bus Images</h4>
//         {existingImages.length > 0 && (
//           <div className="existing-images">
//             <label>Current Images</label>
//             <div className="images-grid">
//               {existingImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={`https://admin.roamjssln.com/uploads/buses/images/${img}`} alt="bus" />
//                   <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         <input type="file" id="edit-bus-images" multiple accept="image/*"
//           onChange={handleImageUpload} style={{ display: 'none' }} />
//         <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
//         {selectedImages.length > 0 && (
//           <div className="new-images">
//             <div className="images-grid">
//               {selectedImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={img.preview} alt="new" />
//                   <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Bus Type *</label>
//           <select value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select">
//             {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
//           </select>
//         </div>
//         <div className="form-group">
//           <label>Bus Category *</label>
//           <select value={form.busCategory}
//             onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
//             className="modern-select">
//             {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Booking Cut-off Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Cancellation Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="48" value={cancellationTime.hours}
//                 onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={cancellationTime.minutes}
//                 onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//         <small className="helper-text">Cancellation allowed up to this time before departure</small>
//       </div>

//       <PlatformFeeConfig platformFee={platformFee} onChange={setPlatformFee} />

//       <div className="section-card">
//         <h4>Amenities</h4>
//         <div className="amenities-grid">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-checkbox-label">
//               <input type="checkbox" checked={form.amenities.includes(amenity)}
//                 onChange={() => handleAmenityToggle(amenity)} />
//               <span>{amenity}</span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
//       </div>
//     </div>
//   );

//   // ─── renderRouteTab ───
//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//       <div className="section-card">
//         <h4>Trip Type</h4>
//         <div className="trip-type-container">
//           <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}>One Way</button>
//           <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}>Round Trip</button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Source & Destination</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Source City</label>
//             <input type="text" value={sourceCity}
//               onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter source city" className="modern-input" />
//           </div>
//           <div className="form-group">
//             <label>Destination City</label>
//             <input type="text" value={destinationCity}
//               onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter destination city" className="modern-input" />
//           </div>
//         </div>
//       </div>

//       {sourceCity && destinationCity && (
//         <div className="section-card">
//           <h4>Select Route</h4>
//           <div className="route-selector">
//             <label>Available Routes</label>
//             <div className="route-dropdown-container">
//               <input
//                 type="text"
//                 value={
//                   selectedRoute
//                     ? (selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`)
//                     : routeSearchTerm
//                 }
//                 onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//                 onChange={(e) => {
//                   setRouteSearchTerm(e.target.value);
//                   setShowRouteDropdown(true);
//                   setSelectedRoute(null);
//                 }}
//                 placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//                 className="modern-input"
//               />
//               {showRouteDropdown && availableRoutes.length > 0 && (
//                 <div className="route-dropdown">
//                   <div className="dropdown-search">
//                     <input type="text" value={routeSearchTerm}
//                       onChange={(e) => setRouteSearchTerm(e.target.value)}
//                       placeholder="Search routes..." className="dropdown-search-input" autoFocus />
//                   </div>
//                   <div className="dropdown-list">
//                     {availableRoutes
//                       .filter(route =>
//                         (route.localRouteName && route.localRouteName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.routeName && route.routeName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.origin?.city && route.origin.city.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.destination?.city && route.destination.city.toLowerCase().includes(routeSearchTerm.toLowerCase()))
//                       )
//                       .map(route => {
//                         return (
//                           <div key={route._id} className="dropdown-item"
//                             onClick={() => handleSelectRoute(route)}>

//                             {route.localRouteName ? (
//                               <>
//                                 <div className="route-number" style={{ fontWeight: 'bold', color: '#2c7da0' }}>
//                                   📍 {route.localRouteName}
//                                 </div>
//                                 <div className="route-details" style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
//                                   {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                   {route.isRoundTrip && ' • Round Trip'}
//                                 </div>
//                               </>
//                             ) : (
//                               <>
//                                 <div className="route-number" style={{ fontWeight: '500' }}>
//                                   {route.routeName || `${route.origin?.city} → ${route.destination?.city}`}
//                                 </div>
//                                 <div className="route-details" style={{ fontSize: '12px', color: '#6c757d' }}>
//                                   {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                   {route.isRoundTrip && ' • Round Trip'}
//                                 </div>
//                               </>
//                             )}

//                             {route.creatorType === 'BusOwner' && (
//                               <span className="owner-badge" style={{
//                                 marginLeft: '8px',
//                                 fontSize: '10px',
//                                 backgroundColor: '#ffc107',
//                                 color: '#000',
//                                 padding: '2px 6px',
//                                 borderRadius: '4px'
//                               }}>
//                                 Owner
//                               </span>
//                             )}
//                           </div>
//                         );
//                       })}
//                   </div>
//                 </div>
//               )}
//             </div>
//             {selectedRoute && (
//               <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//                 ✓ Route selected: {selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`}
//               </small>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4>Operating Days</h4>
//         <div className="days-grid">
//           {DAYS_OF_WEEK.map(day => (
//             <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}>
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Pricing Configuration</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input type="number" value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100" className="modern-input" min="0" step="1" />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input type="number" value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input type="number" value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
//           </div>
//         </div>
//         <small className="helper-text">These values are used to calculate fares. Changing them will regenerate the matrix.</small>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//         <button
//           className="modern-btn primary"
//           onClick={() => {
//             if (!selectedRoute) {
//               toast.error('Please select a route first');
//               return;
//             }

//             // ========== FIX: Check if we already have fareMatrix ==========
//             // If we already have fareMatrix from the API, just navigate to matrix tab
//             if (fareMatrixUp && fareMatrixUp.length > 0) {
//               toast.info('Using existing fare matrix from bus data');
//               setActiveTab('matrix');
//               return;
//             }

//             // Only generate new matrix if no matrix exists
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields to generate matrix');
//               return;
//             }

//             const newMatrixUp = generateMatrixForRoute(selectedRoute);
//             setFareMatrixUp(newMatrixUp);

//             if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//               const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//               setFareMatrixDown(newMatrixDown);
//             }

//             toast.success('Fare matrix generated with updated pricing!');
//             setActiveTab('matrix');
//           }}
//         >
//           {fareMatrixUp && fareMatrixUp.length > 0 ? 'View Fare Matrix →' : 'Generate Fare Matrix →'}
//         </button>
//       </div>
//     </div>
//   );

//   // ─── renderMatrixTab ───
//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Fare Matrix Configuration</h3></div>

//       <div className="matrix-info" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#e8f4fd', borderRadius: '4px' }}>
//         <p style={{ margin: 0, fontSize: '14px', color: '#2c7da0' }}>
//           💡 You can edit individual prices by clicking on the price fields below.
//           {fareMatrixUp && fareMatrixUp.length > 0 && ' The current matrix is loaded from the bus data.'}
//         </p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}>Up Route</button>
//           <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}>Down Route</button>
//         </div>
//       )}

//       {activeMatrixTab === 'up' && renderMatrix('up')}
//       {activeMatrixTab === 'down' && renderMatrix('down')}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
//         <button
//           className="modern-btn outline"
//           onClick={() => {
//             // Allow regeneration if needed
//             if (!selectedRoute) {
//               toast.error('No route selected');
//               return;
//             }
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields in the Route tab');
//               return;
//             }
//             if (window.confirm('This will regenerate the fare matrix with current pricing. Continue?')) {
//               const newMatrixUp = generateMatrixForRoute(selectedRoute);
//               setFareMatrixUp(newMatrixUp);
//               if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//                 const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//                 setFareMatrixDown(newMatrixDown);
//               }
//               toast.success('Fare matrix regenerated!');
//             }
//           }}
//           style={{ marginRight: '10px' }}
//         >
//           🔄 Regenerate
//         </button>
//         <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
//       </div>
//     </div>
//   );

//   // ─── renderSeatLayoutTab ───
//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Seat Layout Configuration</h3></div>

//       <div className="section-card">
//         <h4>Bus Configuration</h4>
//         <div className="config-buttons">
//           {availableConfigurations.map(config => (
//             <button key={config}
//               className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//               onClick={() => setSelectedConfiguration(config)}>
//               {config}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Select Template</h4>
//         <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Layout Template
//         </button>
//         {selectedTemplate && (
//           <div className="selected-template">
//             Selected: {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4>Seat Layout</h4>
//           <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
//             View / Edit Seats
//           </button>
//           <div className="seat-summary">
//             <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
//         <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
//           {isSubmitting ? 'Updating...' : 'Update Bus'}
//         </button>
//       </div>
//     </div>
//   );

//   // ─── renderLayoutModal ───
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Configure Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // ─── renderTemplateModal ───
//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="templates-grid">
//             {layoutTemplates.map(template => (
//               <button key={template._id} className="template-card"
//                 onClick={() => handleSelectTemplate(template)}>
//                 <h4>{template.name}</h4>
//                 <div>Config: {template.configuration}</div>
//                 <div>Seats: {template.totalSeats}</div>
//                 <div>Type: {template.seatType || 'seat'}</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // ─── renderSeatEditModal ───
//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" style={{ maxWidth: "500px", maxHeight: "35vh" }} onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g., S1, B1, 1A, etc."
//             autoFocus
//           />
//           <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
//             Current seat number: {editingSeat}
//           </small>
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>
//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               // ========== FIX: Update the label ==========
//               if (tempSeatLabel.trim()) {
//                 setCustomSeatLabels(prev => ({
//                   ...prev,
//                   [editingSeat]: tempSeatLabel.trim()
//                 }));
//               }
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>
//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               // ========== FIX: Update the label ==========
//               if (tempSeatLabel.trim()) {
//                 setCustomSeatLabels(prev => ({
//                   ...prev,
//                   [editingSeat]: tempSeatLabel.trim()
//                 }));
//               }
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
//             <p className="modal-subtitle">Update bus configuration</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body modern">
//           <ProgressSteps />
//           {activeTab === 'basic' && renderBasicInfoTab()}
//           {activeTab === 'route' && renderRouteTab()}
//           {activeTab === 'matrix' && renderMatrixTab()}
//           {activeTab === 'seats' && renderSeatLayoutTab()}
//           {error && <div className="error-message modern">{error}</div>}
//         </div>
//       </div>
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// export default EditBusModal;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes, getRouteById } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusManagementModal.css';

// // Platform Fee Configuration Component
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
//       <h4 className="card-title" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//         <span className="title-icon" style={{ fontSize: '20px' }}>💰</span>
//         Platform Fee Configuration
//       </h4>

//       <div className="platform-fee-container">
//         <div className="form-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               {platformFee.type === 'fixed'
//                 ? 'Charge a fixed amount per booking'
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
//               {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//             </label>
//             <input
//               type="number"
//               min="0"
//               step={platformFee.type === 'fixed' ? "1" : "0.1"}
//               value={platformFee.value === 0 ? '' : platformFee.value}
//               onChange={(e) => {
//                 const rawValue = e.target.value;
//                 const value = rawValue === '' ? 0 : parseFloat(rawValue);
//                 onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//               }}
//               className="modern-input"
//               placeholder="0"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             />
//           </div>

//           <div className="form-group">
//             <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//               style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//             >
//               <option value="per_ticket">Per Ticket</option>
//             </select>
//             <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
//               Fee applied on each ticket
//             </small>
//           </div>
//         </div>

//         {platformFee.value > 0 && (
//           <div className="fee-preview" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
//             <div className="preview-title" style={{ fontWeight: '500', marginBottom: '5px' }}>Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed'
//                   ? `₹${platformFee.value} per ticket`
//                   : `${platformFee.value}% of fare per ticket`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
//   console.log("bus received in EditBusModal:", bus);
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // Platform Fee State
//   const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Cancellation Time State
//   const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Existing Images/Video
//   const [existingImages, setExistingImages] = useState([]);
//   const [existingVideo, setExistingVideo] = useState(null);
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices - THESE SHOULD PRESERVE THE ORIGINAL PRICES
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Flag to track if we've loaded the initial data
//   const [initialDataLoaded, setInitialDataLoaded] = useState(false);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Store reconstructed route stops with distances (extracted from existing fareMatrix)
//   const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
//   const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ─── Helper function to sync seats with template ───
//   const syncSeatsWithTemplate = (template, existingActiveSeats, existingBlockedSeats, existingLabels) => {
//     if (!template || !template.seats) return null;
    
//     // Get all seat numbers from template
//     const templateSeatNumbers = template.seats.map(s => s.seatNumber);
    
//     // Keep only active seats that exist in the template
//     const validActiveSeats = existingActiveSeats.filter(s => templateSeatNumbers.includes(s));
    
//     // Keep only blocked seats that exist in the template
//     const validBlockedSeats = existingBlockedSeats.filter(s => templateSeatNumbers.includes(s));
    
//     // Update custom seat labels from template
//     const newLabels = {};
//     template.seats.forEach(seat => {
//       // If the seat is active and has a label in the existing data, use it
//       if (validActiveSeats.includes(seat.seatNumber) && existingLabels[seat.seatNumber]) {
//         newLabels[seat.seatNumber] = existingLabels[seat.seatNumber];
//       } else {
//         // Otherwise use the template's globalSeatIndex or seatNumber
//         newLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
//       }
//     });
    
//     return {
//       activeSeats: validActiveSeats.length > 0 ? validActiveSeats : templateSeatNumbers,
//       blockedSeats: validBlockedSeats,
//       labels: newLabels
//     };
//   };

//   // ─── KEY: Load fareMatrix AND PRESERVE THE ORIGINAL PRICES ───
//   useEffect(() => {
//     const loadRouteData = async () => {
//       if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) {
//         console.log('No routeSchedules in bus:', bus);
//         return;
//       }

//       console.log('Loading route data from bus:', bus);
//       console.log('RouteSchedules:', bus.routeSchedules);

//       const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
//       const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

//       // ========== CRITICAL: PRESERVE THE ORIGINAL FARE MATRIX WITH PRICES ==========
//       if (upSchedule?.fareMatrix?.length > 0) {
//         // Log the original prices
//         const firstRow = upSchedule.fareMatrix[0];
//         if (firstRow?.toCells) {
//           const prices = firstRow.toCells
//             .filter(c => c !== null)
//             .map(c => ({ toName: c.toName, price: c.price }));
//           console.log('✅ Original UP FareMatrix prices:', prices);
//         }

//         // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
//         setFareMatrixUp(JSON.parse(JSON.stringify(upSchedule.fareMatrix)));

//         // Reconstruct route with proper distanceFromOrigin from existing matrix
//         const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
//         setReconstructedRouteUp(reconstructed);

//         if (reconstructed) {
//           setSourceCity(reconstructed.origin?.city || '');
//           setDestinationCity(reconstructed.destination?.city || '');

//           // Fetch the full route data to get localRouteName and other details
//           let fullRoute = null;
//           try {
//             const routeId = upSchedule.routeId;
//             console.log("Fetching route details for ID:", routeId);

//             const response = await getRouteById(routeId, token);
//             console.log("Full route response:", response);

//             if (response && response.success && response.data) {
//               fullRoute = response.data;
//             } else if (response && response.data) {
//               fullRoute = response.data;
//             }
//           } catch (err) {
//             console.error("Error fetching route details:", err);
//           }

//           const localRouteName = bus.localRouteName || fullRoute?.localRouteName || null;
//           console.log("Setting localRouteName:", localRouteName);

//           setSelectedRoute({
//             _id: upSchedule.routeId,
//             routeName: upSchedule.routeName ||
//               `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
//             localRouteName: localRouteName,
//             origin: reconstructed.origin,
//             destination: reconstructed.destination,
//             intermediateStops: reconstructed.intermediateStops || [],
//             routeDetails: reconstructed.routeDetails,
//             stops: reconstructed.stops,
//             returnJourney: downSchedule ? (() => {
//               const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//               setReconstructedRouteDown(downReconstructed);
//               return downReconstructed;
//             })() : null
//           });
//         }
//       }

//       if (downSchedule?.fareMatrix?.length > 0) {
//         // Log the original prices
//         const firstRow = downSchedule.fareMatrix[0];
//         if (firstRow?.toCells) {
//           const prices = firstRow.toCells
//             .filter(c => c !== null)
//             .map(c => ({ toName: c.toName, price: c.price }));
//           console.log('✅ Original DOWN FareMatrix prices:', prices);
//         }

//         // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
//         setFareMatrixDown(JSON.parse(JSON.stringify(downSchedule.fareMatrix)));
//         if (!upSchedule?.fareMatrix?.length) {
//           const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
//           setReconstructedRouteDown(downReconstructed);
//         }
//       }

//       setInitialDataLoaded(true);
//     };

//     loadRouteData();
//   }, [bus, token]);

//   // ─── KEY FIX: Reconstruct stops with cumulative distances from fareMatrix ───
//   // This function ONLY reconstructs stops, it does NOT recalculate prices
//   const reconstructStopsFromMatrix = (fareMatrix) => {
//     if (!fareMatrix || fareMatrix.length === 0) return null;

//     const stops = [];

//     // Origin stop
//     stops.push({
//       id: fareMatrix[0].fromId || 'origin',
//       name: fareMatrix[0].fromName,
//       distanceFromOrigin: 0,
//       type: fareMatrix[0].fromType || 'origin'
//     });

//     // Read the first row's toCells to get distances from origin to all other stops
//     const firstRowCells = fareMatrix[0].toCells || [];
//     firstRowCells.forEach((cell) => {
//       if (cell) {
//         stops.push({
//           id: cell.toId || cell.toName,
//           name: cell.toName,
//           distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
//           type: 'stop'
//         });
//       }
//     });

//     // Mark the last stop as destination
//     if (stops.length > 1) {
//       stops[stops.length - 1].type = 'destination';
//     }

//     return {
//       stops,
//       origin: { city: stops[0]?.name },
//       destination: { city: stops[stops.length - 1]?.name },
//       intermediateStops: stops.slice(1, -1).map((s, idx) => ({
//         city: s.name,
//         distanceFromOrigin: s.distanceFromOrigin,
//         sequence: idx + 1
//       })),
//       routeDetails: {
//         totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
//       }
//     };
//   };

//   // ─── generateMatrixForRoute: This function is called when user clicks "Regenerate" ───
//   // It should ONLY be used when generating a NEW matrix, not when editing existing one
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     let allStops = [];

//     if (routeData.stops && routeData.stops.length > 0) {
//       allStops = routeData.stops.map(s => ({
//         id: s.id || s.name,
//         name: s.name,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: s.type
//       }));
//     } else {
//       const sortedStops = [...(routeData.intermediateStops || [])]
//         .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//       allStops = [
//         {
//           id: 'origin',
//           name: routeData.origin?.city || 'Origin',
//           distanceFromOrigin: 0,
//           type: 'origin'
//         },
//         ...sortedStops.map((s, i) => ({
//           id: s._id || `stop_${i}`,
//           name: s.city || s.name || `Stop ${i + 1}`,
//           distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//           type: 'stop',
//           sequence: s.sequence
//         })),
//         {
//           id: 'destination',
//           name: routeData.destination?.city || 'Destination',
//           distanceFromOrigin:
//             parseFloat(routeData.destination?.distanceFromOrigin) ||
//             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//           type: 'destination'
//         }
//       ];
//     }

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromType !== 'destination');
//   };

//   // ─── Update the useEffect that initializes form data with proper platform fee parsing ───
// // In the useEffect that loads bus data, make sure blockedSeats is set correctly
// useEffect(() => {
//   if (bus) {
//     console.log('Loading bus data for edit:', bus);

//     setForm({
//       busNumber: bus.busNumber || '',
//       busName: bus.busName || '',
//       busType: bus.busType || 'AC',
//       busCategory: bus.busCategory || 'Seater',
//       amenities: bus.amenities || []
//     });

//     setTripType(bus.tripType || 'oneWay');

//     if (bus.bookingClosedBefore) {
//       setBookingClosedBefore(bus.bookingClosedBefore);
//     }

//     if (bus.cancellationTime) {
//       setCancellationTime(bus.cancellationTime);
//     } else {
//       setCancellationTime({ hours: 1, minutes: 0 });
//     }

//     if (bus.platformFee) {
//       setPlatformFee({
//         type: bus.platformFee.type || 'fixed',
//         value: bus.platformFee.value || 0,
//         applicableOn: bus.platformFee.applicableOn || 'per_ticket'
//       });
//     } else {
//       setPlatformFee({
//         type: 'fixed',
//         value: 0,
//         applicableOn: 'per_ticket'
//       });
//     }

//     if (bus.operatingDays && bus.operatingDays.length > 0) {
//       setOperatingDays(bus.operatingDays);
//     }

//     if (bus.fareDetails) {
//       setPricing({
//         basePrice: bus.fareDetails.basePrice || '',
//         baseDistance: bus.fareDetails.baseDistance || '',
//         costPerKm: bus.fareDetails.costPerKm || ''
//       });
//     }

//     if (bus.images && bus.images.length > 0) {
//       setExistingImages(bus.images);
//     }
//     if (bus.video && bus.video.length > 0) {
//       setExistingVideo(bus.video[0]);
//     }

//     if (bus.seatConfiguration) {
//       const config = bus.seatConfiguration.busType || '2*2';
//       setSelectedConfiguration(config);
//       console.log('Set configuration from bus:', config);
//     }

//     // ========== FIX: Load seats with proper labels and blocked status ==========
//     if (bus.seats && bus.seats.length > 0) {
//       // Get all seat numbers that are available
//       const activeSeatNumbers = bus.seats
//         .filter(seat => seat.isAvailable !== false)
//         .map(seat => seat.seatNumber);
//       setActiveSeats(activeSeatNumbers);

//       // ========== CRITICAL FIX: Get blocked seats ==========
//       const blockedSeatNumbers = bus.seats
//         .filter(seat => seat.isBlocked === true)
//         .map(seat => seat.seatNumber);
//       setBlockedSeats(blockedSeatNumbers);

//       console.log('Loaded blocked seats:', blockedSeatNumbers);

//       // Set seat labels
//       const seatLabels = {};
//       bus.seats.forEach(seat => {
//         const displayLabel = seat.globalSeatIndex || seat.seatNumber;
//         seatLabels[seat.seatNumber] = displayLabel;
//       });
//       setCustomSeatLabels(seatLabels);

//       console.log('Loaded seat labels from database:', seatLabels);
//       console.log('Active seats:', activeSeatNumbers);
//       console.log('Blocked seats:', blockedSeatNumbers);
//     }
//   }
// }, [bus]);

//   // ─── Fetch layouts and auto-select template when configuration changes ───
//   useEffect(() => {
//     if (selectedConfiguration && form.busCategory) {
//       fetchLayouts(selectedConfiguration);
//     }
//   }, [selectedConfiguration, form.busCategory]);

//   // ─── Fetch available configurations ───
//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       // Pass the busCategory to the API
//       const response = await getAllCategory(token, form.busCategory);
//       if (response && response.success && response.data) {
//         // The API now handles filtering, so we don't need to filter again
//         const configs = [...new Set(response.data.map(cat => cat.configuration))];
//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           // Don't override selectedConfiguration if it's already set from bus data
//           if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
//             setSelectedConfiguration(configs[0]);
//           }
//         } else {
//           setAvailableConfigurations([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   // ─── Fetch layouts and auto-select template ───
// const fetchLayouts = async (config) => {
//   try {
//     if (!config) return;
//     setLoadingLayouts(true);
//     let bustype = config.replace('x', '*');
//     const response = await getSeatLayoutsByBustype(bustype, token);
//     if (response && response.success && response.data && Array.isArray(response.data)) {
//       let filteredLayouts = response.data;
//       if (form.busCategory === 'Seater') {
//         filteredLayouts = response.data.filter(layout =>
//           layout.seatType === 'seat' || layout.seatType === 'seater');
//       } else if (form.busCategory === 'Sleeper') {
//         filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
//       } else if (form.busCategory === 'Seater+Sleeper') {
//         filteredLayouts = response.data.filter(layout =>
//           layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
//       }
//       setLayoutTemplates(filteredLayouts);
      
//       if (bus && bus.seats && bus.seats.length > 0 && filteredLayouts.length > 0) {
//         const totalSeats = bus.seats.length;
//         const existingConfig = bus.seatConfiguration?.busType || config;
        
//         let matchingTemplate = filteredLayouts.find(template => {
//           if (template.totalSeats === totalSeats) {
//             return template.configuration === existingConfig || 
//                    template.configuration === existingConfig.replace('*', 'x');
//           }
//           return false;
//         });
        
//         if (!matchingTemplate) {
//           matchingTemplate = filteredLayouts.find(template => 
//             template.configuration === existingConfig || 
//             template.configuration === existingConfig.replace('*', 'x')
//           );
//         }
        
//         const autoSelected = matchingTemplate || filteredLayouts[0];
        
//         if (autoSelected && !selectedTemplate) {
//           setSelectedTemplate(autoSelected);
//           console.log('Auto-selected template from fetchLayouts:', autoSelected.name);
          
//           if (autoSelected.seats && autoSelected.seats.length > 0) {
//             const templateSeatNumbers = autoSelected.seats.map(s => s.seatNumber);
            
//             // ========== FIX: Preserve blocked seats ==========
//             const currentActiveSeats = bus.seats
//               .filter(seat => seat.isAvailable !== false)
//               .map(seat => seat.seatNumber);
//             const currentBlockedSeats = bus.seats
//               .filter(seat => seat.isBlocked === true)
//               .map(seat => seat.seatNumber);
            
//             // Only keep seats that exist in the template
//             const validActiveSeats = currentActiveSeats.filter(s => templateSeatNumbers.includes(s));
//             const validBlockedSeats = currentBlockedSeats.filter(s => templateSeatNumbers.includes(s));
            
//             if (validActiveSeats.length > 0) {
//               setActiveSeats(validActiveSeats);
//             } else {
//               setActiveSeats(templateSeatNumbers);
//             }
            
//             // ========== PRESERVE BLOCKED SEATS ==========
//             setBlockedSeats(validBlockedSeats);
            
//             // Update labels
//             const newLabels = {};
//             autoSelected.seats.forEach(seat => {
//               const existingLabel = bus.seats?.find(s => s.seatNumber === seat.seatNumber)?.globalSeatIndex;
//               newLabels[seat.seatNumber] = existingLabel || seat.globalSeatIndex || seat.seatNumber;
//             });
//             setCustomSeatLabels(newLabels);
            
//             console.log('Preserved blocked seats:', validBlockedSeats);
//           }
//         }
//       } else if (!selectedTemplate && filteredLayouts.length > 0) {
//         setSelectedTemplate(filteredLayouts[0]);
//         if (filteredLayouts[0].seats) {
//           const seatNumbers = filteredLayouts[0].seats.map(s => s.seatNumber);
//           setActiveSeats(seatNumbers);
//           // ========== Clear blocked seats when no bus data ==========
//           setBlockedSeats([]);
//           const labels = {};
//           filteredLayouts[0].seats.forEach(s => {
//             labels[s.seatNumber] = s.globalSeatIndex || s.seatNumber;
//           });
//           setCustomSeatLabels(labels);
//         }
//       }
//     } else {
//       setLayoutTemplates([]);
//     }
//   } catch (error) {
//     console.error("Layout Fetch Error:", error);
//     setLayoutTemplates([]);
//   } finally {
//     setLoadingLayouts(false);
//   }
// };

//   // ─── Fetch routes ───
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }
//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token, 1, 50, '', '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
//       console.log("Fetched routes response:", response);

//       if (response && response.success && response.routes) {
//         const routesWithLocalName = response.routes.map(route => ({
//           ...route,
//           localRouteName: route.localRouteName || null
//         }));
//         setAvailableRoutes(routesWithLocalName);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity && !selectedRoute) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const handleSelectRoute = (route) => {
//     setSelectedRoute({
//       ...route,
//       stops: null,
//       localRouteName: route.localRouteName
//     });
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setSourceCity(route.origin?.city || '');
//     setDestinationCity(route.destination?.city || '');
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//     setReconstructedRouteUp(null);
//     setReconstructedRouteDown(null);

//     if (route.localRouteName) {
//       toast.info(`Selected: ${route.localRouteName}`);
//     }
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
//     );
//   };

//   const handleAmenityToggle = (amenity) => {
//     setForm(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenity)
//         ? prev.amenities.filter(a => a !== amenity)
//         : [...prev.amenities, amenity]
//     }));
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];
//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({ file: file, preview: e.target.result, name: file.name });
//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeExistingImage = (index) => {
//     setExistingImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const removeNewImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeExistingVideo = () => setExistingVideo(null);
//   const removeNewVideo = () => setSelectedVideo(null);

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handleCancellationTimeChange = (field, value) => {
//     setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
//       }
//       return { ...row, toCells: newToCells };
//     });
//     if (isUp) setFareMatrixUp(updatedMatrix);
//     else setFareMatrixDown(updatedMatrix);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
    
//     // Sync active seats with the new template
//     if (template.seats && template.seats.length > 0) {
//       const templateSeatNumbers = template.seats.map(s => s.seatNumber);
//       // Keep only active seats that exist in the template
//       const validActiveSeats = activeSeats.filter(s => templateSeatNumbers.includes(s));
//       if (validActiveSeats.length > 0) {
//         setActiveSeats(validActiveSeats);
//       } else {
//         // If no matching active seats, activate all seats in the template
//         setActiveSeats(templateSeatNumbers);
//       }
      
//       // Update seat labels from template
//       const newLabels = {};
//       template.seats.forEach(seat => {
//         // Preserve existing custom labels if they exist
//         if (customSeatLabels[seat.seatNumber]) {
//           newLabels[seat.seatNumber] = customSeatLabels[seat.seatNumber];
//         } else {
//           newLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
//         }
//       });
//       setCustomSeatLabels(newLabels);
//     }
    
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);

//     // ========== FIX: Use the existing label from customSeatLabels ==========
//     const existingLabel = customSeatLabels[seatObj.seatNumber];

//     if (activeSeats.includes(seatObj.seatNumber)) {
//       // If the seat is active, show its current label
//       setTempSeatLabel(String(existingLabel || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       // If the seat is inactive, show the seat number as default
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     if (!selectedTemplate || !selectedTemplate.seats) return;
//     const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });
//     let counter = 1;
//     const newLabels = {};
//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });
//     setCustomSeatLabels(newLabels);
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // ========== UPDATE BUS FUNCTION ==========
//   const handleUpdateBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       // Validation checks...
//       if (!form.busNumber) throw new Error('Bus Number is required');
//       if (!form.busName) throw new Error('Bus Name is required');
//       if (!form.busType) throw new Error('Bus Type is required');
//       if (!form.busCategory) throw new Error('Bus Category is required');
//       if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

//       const amenitiesArray = form.amenities || [];

//       let finalSeatsPayload = [];
//       if (selectedTemplate && selectedTemplate.seats) {
//         finalSeatsPayload = selectedTemplate.seats
//           .filter(s => activeSeats.includes(s.seatNumber))
//           .map(s => {
//             // ========== FIX: Use the label from customSeatLabels ==========
//             const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//             const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//             const isBlocked = blockedSeats.includes(s.seatNumber);

//             return {
//               seatNumber: s.seatNumber,  // Keep the original seat number
//               globalSeatIndex: finalGlobalIndex,  // This is what's displayed
//               row: s.row,
//               column: s.column,
//               seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//               position: s.position || getSeatPosition(s.column),
//               isBlocked: isBlocked,
//               isAvailable: !isBlocked,
//             };
//           });
//       } else if (bus.seats) {
//         // If no template selected, use existing seats but update labels
//         finalSeatsPayload = bus.seats.map(seat => {
//           const label = customSeatLabels[seat.seatNumber] || seat.globalSeatIndex || seat.seatNumber;
//           return {
//             ...seat,
//             globalSeatIndex: label,
//           };
//         });
//       }

//       const seatConfigPayload = {
//         busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
//         totalSeats: activeSeats.length || bus.totalSeats
//       };

//       const formData = new FormData();
//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');
//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('operatingDays', JSON.stringify(operatingDays));
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//       formData.append('cancellationTime', JSON.stringify(cancellationTime));
//       formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

//       const cleanPlatformFee = {
//         type: platformFee.type || 'fixed',
//         value: parseFloat(platformFee.value) || 0,
//         applicableOn: platformFee.applicableOn || 'per_ticket'
//       };
//       formData.append('platformFee', JSON.stringify(cleanPlatformFee));

//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };
//       formData.append('fareDetails', JSON.stringify(fareDetails));

//       // ========== Build routeSchedules with the CORRECT fareMatrix from state ==========
//       let routeSchedulesToSend = [];

//       if (selectedRoute) {
//         // Build UP schedule with fareMatrixUp (which has the original prices)
//         const upSchedule = {
//           routeId: selectedRoute._id,
//           routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//           routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//           direction: 'UP',
//           operatingDays: operatingDays,
//           fareMatrix: fareMatrixUp, // ← This has the PRESERVED original prices
//           origin: {
//             city: selectedRoute.origin?.city || sourceCity,
//             state: selectedRoute.origin?.state || 'West Bengal',
//             address: selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//             terminal: selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//             departureTime: selectedRoute.origin?.departureTime || '08:00',
//             timings: selectedRoute.origin?.timings || [
//               { timeSlotSequence: 1, departureTime: '08:00', arrivalTime: '' },
//               { timeSlotSequence: 2, departureTime: '12:00', arrivalTime: '' }
//             ],
//             coordinates: selectedRoute.origin?.coordinates || { lat: 0, lng: 0 }
//           },
//           destination: {
//             city: selectedRoute.destination?.city || destinationCity,
//             state: selectedRoute.destination?.state || 'West Bengal',
//             address: selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//             terminal: selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//             arrivalTime: selectedRoute.destination?.arrivalTime || '10:00',
//             timings: selectedRoute.destination?.timings || [
//               { timeSlotSequence: 1, arrivalTime: '10:00', departureTime: '' },
//               { timeSlotSequence: 2, arrivalTime: '14:00', departureTime: '' }
//             ],
//             coordinates: selectedRoute.destination?.coordinates || { lat: 0, lng: 0 },
//             distanceFromOrigin: selectedRoute.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//           },
//           intermediateStops: selectedRoute.intermediateStops || [],
//           additionalBoardingPoints: selectedRoute.additionalBoardingPoints || [],
//           additionalDroppingPoints: selectedRoute.additionalDroppingPoints || [],
//           additionalNullPoints: selectedRoute.additionalNullPoints || [],
//           routeDetails: {
//             totalDistance: selectedRoute.routeDetails?.totalDistance || 100,
//             estimatedDuration: selectedRoute.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//           },
//           isActive: true,
//           validFrom: new Date()
//         };

//         routeSchedulesToSend.push(upSchedule);

//         // Build DOWN schedule for round trip with fareMatrixDown
//         if (tripType === 'roundTrip') {
//           const returnJourney = selectedRoute.returnJourney;

//           if (returnJourney || fareMatrixDown.length > 0) {
//             const downSchedule = {
//               routeId: selectedRoute._id,
//               routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
//               routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
//               direction: 'DOWN',
//               operatingDays: operatingDays,
//               fareMatrix: fareMatrixDown, // ← This has the PRESERVED original prices
//               origin: {
//                 city: returnJourney?.origin?.city || selectedRoute.destination?.city || destinationCity,
//                 state: returnJourney?.origin?.state || selectedRoute.destination?.state || 'West Bengal',
//                 address: returnJourney?.origin?.address || selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
//                 terminal: returnJourney?.origin?.terminal || selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
//                 departureTime: returnJourney?.origin?.departureTime || '14:00',
//                 timings: returnJourney?.origin?.timings || [
//                   { timeSlotSequence: 1, departureTime: '14:00', arrivalTime: '' },
//                   { timeSlotSequence: 2, departureTime: '18:00', arrivalTime: '' }
//                 ],
//                 coordinates: returnJourney?.origin?.coordinates || selectedRoute.destination?.coordinates || { lat: 0, lng: 0 }
//               },
//               destination: {
//                 city: returnJourney?.destination?.city || selectedRoute.origin?.city || sourceCity,
//                 state: returnJourney?.destination?.state || selectedRoute.origin?.state || 'West Bengal',
//                 address: returnJourney?.destination?.address || selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
//                 terminal: returnJourney?.destination?.terminal || selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
//                 arrivalTime: returnJourney?.destination?.arrivalTime || '16:00',
//                 timings: returnJourney?.destination?.timings || [
//                   { timeSlotSequence: 1, arrivalTime: '16:00', departureTime: '' },
//                   { timeSlotSequence: 2, arrivalTime: '20:00', departureTime: '' }
//                 ],
//                 coordinates: returnJourney?.destination?.coordinates || selectedRoute.origin?.coordinates || { lat: 0, lng: 0 },
//                 distanceFromOrigin: returnJourney?.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
//               },
//               intermediateStops: returnJourney?.intermediateStops || [],
//               additionalBoardingPoints: returnJourney?.additionalBoardingPoints || [],
//               additionalDroppingPoints: returnJourney?.additionalDroppingPoints || [],
//               additionalNullPoints: returnJourney?.additionalNullPoints || [],
//               routeDetails: {
//                 totalDistance: returnJourney?.routeDetails?.totalDistance || selectedRoute.routeDetails?.totalDistance || 100,
//                 estimatedDuration: returnJourney?.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
//               },
//               isActive: true,
//               validFrom: new Date()
//             };

//             routeSchedulesToSend.push(downSchedule);
//           }
//         }

//         console.log('Sending routeSchedules with fareMatrix:', JSON.stringify(routeSchedulesToSend, null, 2));
//         formData.append('routeSchedules', JSON.stringify(routeSchedulesToSend));

//         if (selectedRoute.localRouteName) {
//           formData.append('localRouteName', selectedRoute.localRouteName);
//         }

//       } else if (bus.routeSchedules) {
//         formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
//         if (bus.localRouteName) {
//           formData.append('localRouteName', bus.localRouteName);
//         }
//       }

//       // Handle images and videos
//       if (existingImages.length > 0) {
//         formData.append('existingImages', JSON.stringify(existingImages));
//       }
//       selectedImages.forEach((img) => {
//         if (img.file) formData.append('images', img.file);
//       });
//       if (existingVideo) {
//         formData.append('existingVideo', existingVideo);
//       }
//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       const response = await updateBus(bus._id, formData, token);

//       if (response && response.success) {
//         toast.success('Bus updated successfully!');
//         if (onUpdate) onUpdate();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to update bus');
//       }
//     } catch (err) {
//       console.error('Error updating bus:', err);
//       setError(err.message || 'Failed to update bus');
//       toast.error(err.message || 'Failed to update bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ─── renderMatrix: Renders the fare matrix with preserved prices ───
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
//       <div className="matrix-placeholder">
//         <p>No fare matrix available. Please go back and generate the matrix.</p>
//       </div>
//     );

//     const allStops = [];
//     currentMatrix.forEach(row => {
//       if (!allStops.find(s => s.name === row.fromName)) {
//         allStops.push({ name: row.fromName, type: row.fromType });
//       }
//     });
//     const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
//     if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
//       allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
//     }

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                       </div>
//                     </td>
//                     {allStops.map((stop, colIndex) => {
//                       const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
//                       if (matchingCell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{matchingCell.distanceKm || 0} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="text"
//                                   className="matrix-input"
//                                   value={matchingCell.price}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (value === '' || /^\d+$/.test(value)) {
//                                       const actualColIndex = row.toCells.findIndex(
//                                         cell => cell && cell.toName === stop.name
//                                       );
//                                       handlePriceChange(type, rowIndex, actualColIndex, value);
//                                     }
//                                   }}
//                                   min="0"
//                                   step="1"
//                                   pattern="\d*"
//                                   inputMode="numeric"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ─── renderSeatVisualizer ───
//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return (
//       <div className="seat-placeholder">
//         <p>Select a template to configure seats</p>
//         <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//           Select Template
//         </button>
//       </div>
//     );

//     if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
//       return <div className="seat-placeholder">No seats available in this template</div>;
//     }

//     const { seats, configuration } = selectedTemplate;
//     let leftCount = 2, rightCount = 2;
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
//     const rows = [];

// const renderSeat = (seatObj) => {
//   const isSelected = activeSeats.includes(seatObj.seatNumber);
//   const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//   const isSleeper = seatObj.seatType === 'sleeper' ||
//     seatObj.seatType === 'seat+sleeper' ||
//     selectedTemplate.seatType === 'sleeper' ||
//     selectedTemplate.seatType === 'seater+sleeper';

//   let displayLabel = '';

//   if (isSelected) {
//     if (customSeatLabels[seatObj.seatNumber]) {
//       displayLabel = customSeatLabels[seatObj.seatNumber];
//     } else if (seatObj.globalSeatIndex) {
//       displayLabel = seatObj.globalSeatIndex;
//     } else {
//       displayLabel = seatObj.seatNumber;
//     }
//   }

//   let seatClass = '';
//   if (isSelected) {
//     // ========== BLOCKED SEATS SHOW WITH DIFFERENT COLOR ==========
//     seatClass = isBlocked ? 'blocked' : 'selected';
//   } else {
//     seatClass = 'inactive';
//   }

//   return (
//     <button
//       key={seatObj.seatNumber}
//       className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//       onClick={() => handleSeatPress(seatObj)}
//       type="button"
//     >
//       <span className="seat-number">{displayLabel}</span>
//     </button>
//   );
// };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];
//       const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
//         </div>
//       );
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header"><div className="driver-area">Driver</div></div>
//         <div className="bus-body">{rows}</div>
//         <div className="seat-legend">
//           <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
//           <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked</span></div>
//           <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
//         </div>
//         <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
//           Auto-Number Seats
//         </button>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
//         <div className="step-icon">1</div><div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
//         <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
//         <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   // ─── renderBasicInfoTab ───
//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Edit Bus Information</h3></div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label>Bus Number *</label>
//           <input type="text" value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             className="modern-input" />
//         </div>
//         <div className="input-group">
//           <label>Bus Name *</label>
//           <input type="text" value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             className="modern-input" />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Bus Images</h4>
//         {existingImages.length > 0 && (
//           <div className="existing-images">
//             <label>Current Images</label>
//             <div className="images-grid">
//               {existingImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                    <img src={`https://admin.roamjssln.com/uploads/buses/images/${img}`} alt="bus" />
//                   <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         <input type="file" id="edit-bus-images" multiple accept="image/*"
//           onChange={handleImageUpload} style={{ display: 'none' }} />
//         <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
//         {selectedImages.length > 0 && (
//           <div className="new-images">
//             <div className="images-grid">
//               {selectedImages.map((img, idx) => (
//                 <div key={idx} className="image-preview-item">
//                   <img src={img.preview} alt="new" />
//                   <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Bus Type *</label>
//           <select value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select">
//             {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
//           </select>
//         </div>
//         <div className="form-group">
//           <label>Bus Category *</label>
//           <select value={form.busCategory}
//             onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
//             className="modern-select">
//             {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Booking Cut-off Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Cancellation Time</h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label>Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="48" value={cancellationTime.hours}
//                 onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label>Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input type="number" min="0" max="59" value={cancellationTime.minutes}
//                 onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input" />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//         <small className="helper-text">Cancellation allowed up to this time before departure</small>
//       </div>

//       <PlatformFeeConfig platformFee={platformFee} onChange={setPlatformFee} />

//       <div className="section-card">
//         <h4>Amenities</h4>
//         <div className="amenities-grid">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-checkbox-label">
//               <input type="checkbox" checked={form.amenities.includes(amenity)}
//                 onChange={() => handleAmenityToggle(amenity)} />
//               <span>{amenity}</span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
//       </div>
//     </div>
//   );

//   // ─── renderRouteTab ───
//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

//       <div className="section-card">
//         <h4>Trip Type</h4>
//         <div className="trip-type-container">
//           <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}>One Way</button>
//           <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}>Round Trip</button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Source & Destination</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Source City</label>
//             <input type="text" value={sourceCity}
//               onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter source city" className="modern-input" />
//           </div>
//           <div className="form-group">
//             <label>Destination City</label>
//             <input type="text" value={destinationCity}
//               onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
//               placeholder="Enter destination city" className="modern-input" />
//           </div>
//         </div>
//       </div>

//       {sourceCity && destinationCity && (
//         <div className="section-card">
//           <h4>Select Route</h4>
//           <div className="route-selector">
//             <label>Available Routes</label>
//             <div className="route-dropdown-container">
//               <input
//                 type="text"
//                 value={
//                   selectedRoute
//                     ? (selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`)
//                     : routeSearchTerm
//                 }
//                 onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//                 onChange={(e) => {
//                   setRouteSearchTerm(e.target.value);
//                   setShowRouteDropdown(true);
//                   setSelectedRoute(null);
//                 }}
//                 placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//                 className="modern-input"
//               />
//               {showRouteDropdown && availableRoutes.length > 0 && (
//                 <div className="route-dropdown">
//                   <div className="dropdown-search">
//                     <input type="text" value={routeSearchTerm}
//                       onChange={(e) => setRouteSearchTerm(e.target.value)}
//                       placeholder="Search routes..." className="dropdown-search-input" autoFocus />
//                   </div>
//                   <div className="dropdown-list">
//                     {availableRoutes
//                       .filter(route =>
//                         (route.localRouteName && route.localRouteName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.routeName && route.routeName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.origin?.city && route.origin.city.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
//                         (route.destination?.city && route.destination.city.toLowerCase().includes(routeSearchTerm.toLowerCase()))
//                       )
//                       .map(route => {
//                         return (
//                           <div key={route._id} className="dropdown-item"
//                             onClick={() => handleSelectRoute(route)}>

//                             {route.localRouteName ? (
//                               <>
//                                 <div className="route-number" style={{ fontWeight: 'bold', color: '#2c7da0' }}>
//                                   📍 {route.localRouteName}
//                                 </div>
//                                 <div className="route-details" style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
//                                   {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                   {route.isRoundTrip && ' • Round Trip'}
//                                 </div>
//                               </>
//                             ) : (
//                               <>
//                                 <div className="route-number" style={{ fontWeight: '500' }}>
//                                   {route.routeName || `${route.origin?.city} → ${route.destination?.city}`}
//                                 </div>
//                                 <div className="route-details" style={{ fontSize: '12px', color: '#6c757d' }}>
//                                   {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
//                                   {route.isRoundTrip && ' • Round Trip'}
//                                 </div>
//                               </>
//                             )}

//                             {route.creatorType === 'BusOwner' && (
//                               <span className="owner-badge" style={{
//                                 marginLeft: '8px',
//                                 fontSize: '10px',
//                                 backgroundColor: '#ffc107',
//                                 color: '#000',
//                                 padding: '2px 6px',
//                                 borderRadius: '4px'
//                               }}>
//                                 Owner
//                               </span>
//                             )}
//                           </div>
//                         );
//                       })}
//                   </div>
//                 </div>
//               )}
//             </div>
//             {selectedRoute && (
//               <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
//                 ✓ Route selected: {selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`}
//               </small>
//             )}
//           </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4>Operating Days</h4>
//         <div className="days-grid">
//           {DAYS_OF_WEEK.map(day => (
//             <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}>
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4>Pricing Configuration</h4>
//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input type="number" value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100" className="modern-input" min="0" step="1" />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input type="number" value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input type="number" value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
//           </div>
//         </div>
//         <small className="helper-text">These values are used to calculate fares. Changing them will regenerate the matrix.</small>
//       </div>

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
//         <button
//           className="modern-btn primary"
//           onClick={() => {
//             if (!selectedRoute) {
//               toast.error('Please select a route first');
//               return;
//             }

//             // ========== FIX: Check if we already have fareMatrix ==========
//             // If we already have fareMatrix from the API, just navigate to matrix tab
//             if (fareMatrixUp && fareMatrixUp.length > 0) {
//               toast.info('Using existing fare matrix from bus data');
//               setActiveTab('matrix');
//               return;
//             }

//             // Only generate new matrix if no matrix exists
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields to generate matrix');
//               return;
//             }

//             const newMatrixUp = generateMatrixForRoute(selectedRoute);
//             setFareMatrixUp(newMatrixUp);

//             if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//               const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//               setFareMatrixDown(newMatrixDown);
//             }

//             toast.success('Fare matrix generated with updated pricing!');
//             setActiveTab('matrix');
//           }}
//         >
//           {fareMatrixUp && fareMatrixUp.length > 0 ? 'View Fare Matrix →' : 'Generate Fare Matrix →'}
//         </button>
//       </div>
//     </div>
//   );

//   // ─── renderMatrixTab ───
//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Fare Matrix Configuration</h3></div>

//       <div className="matrix-info" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#e8f4fd', borderRadius: '4px' }}>
//         <p style={{ margin: 0, fontSize: '14px', color: '#2c7da0' }}>
//           💡 You can edit individual prices by clicking on the price fields below.
//           {fareMatrixUp && fareMatrixUp.length > 0 && ' The current matrix is loaded from the bus data.'}
//         </p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}>Up Route</button>
//           <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}>Down Route</button>
//         </div>
//       )}

//       {activeMatrixTab === 'up' && renderMatrix('up')}
//       {activeMatrixTab === 'down' && renderMatrix('down')}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
//         <button
//           className="modern-btn outline"
//           onClick={() => {
//             // Allow regeneration if needed
//             if (!selectedRoute) {
//               toast.error('No route selected');
//               return;
//             }
//             if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//               toast.error('Please fill all pricing fields in the Route tab');
//               return;
//             }
//             if (window.confirm('This will regenerate the fare matrix with current pricing. Continue?')) {
//               const newMatrixUp = generateMatrixForRoute(selectedRoute);
//               setFareMatrixUp(newMatrixUp);
//               if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//                 const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//                 setFareMatrixDown(newMatrixDown);
//               }
//               toast.success('Fare matrix regenerated!');
//             }
//           }}
//           style={{ marginRight: '10px' }}
//         >
//           🔄 Regenerate
//         </button>
//         <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
//       </div>
//     </div>
//   );

//   // ─── renderSeatLayoutTab ───
//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title"><h3>Seat Layout Configuration</h3></div>

//       <div className="section-card">
//         <h4>Bus Configuration</h4>
//         <div className="config-buttons">
//           {availableConfigurations.map(config => (
//             <button key={config}
//               className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//               onClick={() => {
//                 setSelectedConfiguration(config);
//                 // Clear selected template when configuration changes
//                 setSelectedTemplate(null);
//               }}>
//               {config}
//             </button>
//           ))}
//         </div>
//         {selectedConfiguration && (
//           <div className="config-info" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
//             Current configuration: <strong>{selectedConfiguration}</strong>
//             {bus?.seatConfiguration?.busType && (
//               <span style={{ marginLeft: '10px', color: '#2c7da0' }}>
//                 (Original: {bus.seatConfiguration.busType})
//               </span>
//             )}
//           </div>
//         )}
//       </div>

//       <div className="section-card">
//         <h4>Select Template</h4>
//         <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
//           <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
//             {selectedTemplate ? 'Change Template' : 'Select Layout Template'}
//           </button>
//           {selectedTemplate && (
//             <span style={{ color: 'green', fontWeight: '500' }}>
//               ✓ {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
//             </span>
//           )}
//         </div>
//         {!selectedTemplate && layoutTemplates.length > 0 && (
//           <div style={{ marginTop: '10px', fontSize: '13px', color: '#856404', backgroundColor: '#fff3cd', padding: '10px', borderRadius: '4px' }}>
//             ⚠️ Please select a template to configure seats
//           </div>
//         )}
//         {loadingLayouts && (
//           <div style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
//             Loading templates...
//           </div>
//         )}
//         {layoutTemplates.length === 0 && !loadingLayouts && (
//           <div style={{ marginTop: '10px', fontSize: '13px', color: '#dc3545' }}>
//             No templates available for this configuration
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4>Seat Layout</h4>
//           <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
//             View / Edit Seats
//           </button>
//           <div className="seat-summary" style={{ marginTop: '10px' }}>
//             <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
//             {blockedSeats.length > 0 && (
//               <span style={{ marginLeft: '15px', color: '#dc3545' }}>
//                 Blocked: {blockedSeats.length}
//               </span>
//             )}
//             <button 
//               className="auto-number-btn" 
//               onClick={autoRenumberSeats}
//               style={{ marginLeft: '15px', padding: '4px 12px', fontSize: '12px' }}
//             >
//               Auto-Number Seats
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
//         <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
//           {isSubmitting ? 'Updating...' : 'Update Bus'}
//         </button>
//       </div>
//     </div>
//   );

//   // ─── renderLayoutModal ───
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Configure Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // ─── renderTemplateModal ───
//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="templates-grid">
//             {layoutTemplates.map(template => (
//               <button key={template._id} className="template-card"
//                 onClick={() => handleSelectTemplate(template)}>
//                 <h4>{template.name}</h4>
//                 <div>Config: {template.configuration}</div>
//                 <div>Seats: {template.totalSeats}</div>
//                 <div>Type: {template.seatType || 'seat'}</div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // ─── renderSeatEditModal ───
//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" style={{ maxWidth: "500px", maxHeight: "35vh" }} onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g., S1, B1, 1A, etc."
//             autoFocus
//           />
//           <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
//             Current seat number: {editingSeat}
//           </small>
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>
//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               // ========== FIX: Update the label ==========
//               if (tempSeatLabel.trim()) {
//                 setCustomSeatLabels(prev => ({
//                   ...prev,
//                   [editingSeat]: tempSeatLabel.trim()
//                 }));
//               }
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>
//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               // ========== FIX: Update the label ==========
//               if (tempSeatLabel.trim()) {
//                 setCustomSeatLabels(prev => ({
//                   ...prev,
//                   [editingSeat]: tempSeatLabel.trim()
//                 }));
//               }
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
//             <p className="modal-subtitle">Update bus configuration</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body modern">
//           <ProgressSteps />
//           {activeTab === 'basic' && renderBasicInfoTab()}
//           {activeTab === 'route' && renderRouteTab()}
//           {activeTab === 'matrix' && renderMatrixTab()}
//           {activeTab === 'seats' && renderSeatLayoutTab()}
//           {error && <div className="error-message modern">{error}</div>}
//         </div>
//       </div>
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// export default EditBusModal;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { updateBus, getAllCategory, getSeatLayoutsByBustype, getAllBusownerAdminRoutes, getRouteById } from '../../Services/Operations/ProductAPI';
import '../../Styles/BusManagementModal.css';

// Platform Fee Configuration Component
const PlatformFeeConfig = ({ platformFee, onChange }) => {
  return (
    <div className="section-card" style={{ marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '15px' }}>
      <h4 className="card-title" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="title-icon" style={{ fontSize: '20px' }}>💰</span>
        Platform Fee Configuration
      </h4>

      <div className="platform-fee-container">
        <div className="form-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Fee Type</label>
            <select
              value={platformFee.type}
              onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
              className="modern-select"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="fixed">Fixed Amount (₹)</option>
              <option value="percentage">Percentage (%)</option>
            </select>
            <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
              {platformFee.type === 'fixed'
                ? 'Charge a fixed amount per booking'
                : 'Charge a percentage of the fare'}
            </small>
          </div>

          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
              {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
            </label>
            <input
              type="number"
              min="0"
              step={platformFee.type === 'fixed' ? "1" : "0.1"}
              value={platformFee.value === 0 ? '' : platformFee.value}
              onChange={(e) => {
                const rawValue = e.target.value;
                const value = rawValue === '' ? 0 : parseFloat(rawValue);
                onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
              }}
              className="modern-input"
              placeholder="0"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
          </div>

          <div className="form-group">
            <label className="input-label" style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>Applicable On</label>
            <select
              value={platformFee.applicableOn}
              onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
              className="modern-select"
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="per_ticket">Per Ticket</option>
              <option value="per_person">Per Person</option>
            </select>
            {/* <small className="helper-text" style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
              Fee applied on each ticket
            </small> */}
          </div>
        </div>

        {platformFee.value > 0 && (
          <div className="fee-preview" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
            <div className="preview-title" style={{ fontWeight: '500', marginBottom: '5px' }}>Fee Calculation Preview:</div>
            <div className="preview-details">
              <span>
                {platformFee.type === 'fixed'
                  ? `₹${platformFee.value} per ticket`
                  : `${platformFee.value}% of fare per ticket`}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EditBusModal = ({ bus, ownerId, onClose, onUpdate }) => {
  console.log("bus received in EditBusModal:", bus);
  const { token } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('basic');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
  const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
  const [blockedSeats, setBlockedSeats] = useState([]);

  // Platform Fee State
  const [platformFee, setPlatformFee] = useState({
    type: 'fixed',
    value: 0,
    applicableOn: 'per_ticket'
  });

  // Cancellation Time State
  const [cancellationTime, setCancellationTime] = useState({ hours: 1, minutes: 0 });

  // Booking Closed Before State
  const [bookingClosedBefore, setBookingClosedBefore] = useState({ hours: 1, minutes: 0 });

  // Bus Form State
  const [form, setForm] = useState({
    busNumber: '',
    busName: '',
    busType: 'AC',
    busCategory: 'Seater',
    amenities: []
  });

  // Trip Type State
  const [tripType, setTripType] = useState('oneWay');
  const [activeMatrixTab, setActiveMatrixTab] = useState('up');

  // Route States
  const [sourceCity, setSourceCity] = useState('');
  const [destinationCity, setDestinationCity] = useState('');
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [routeSearchTerm, setRouteSearchTerm] = useState('');

  // Seat Layout States
  const [layoutTemplates, setLayoutTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [activeSeats, setActiveSeats] = useState([]);
  const [customSeatLabels, setCustomSeatLabels] = useState({});
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [loadingLayouts, setLoadingLayouts] = useState(false);
  const [editingSeat, setEditingSeat] = useState(null);
  const [tempSeatLabel, setTempSeatLabel] = useState('');

  // Existing Images/Video
  const [existingImages, setExistingImages] = useState([]);
  const [existingVideo, setExistingVideo] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Pricing States
  const [pricing, setPricing] = useState({
    basePrice: '',
    baseDistance: '',
    costPerKm: ''
  });

  // Fare Matrices - THESE SHOULD PRESERVE THE ORIGINAL PRICES
  const [fareMatrixUp, setFareMatrixUp] = useState([]);
  const [fareMatrixDown, setFareMatrixDown] = useState([]);

  // Flag to track if we've loaded the initial data
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Operating Days
  const [operatingDays, setOperatingDays] = useState([
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ]);

  // Store reconstructed route stops with distances (extracted from existing fareMatrix)
  const [reconstructedRouteUp, setReconstructedRouteUp] = useState(null);
  const [reconstructedRouteDown, setReconstructedRouteDown] = useState(null);

  const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
  const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
  const AMENITIES_LIST = [
    'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
    'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
    'GPS Tracking', 'SOS Switch'
  ];
  const DAYS_OF_WEEK = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];

  // ─── Helper function to sync seats with template ───
  const syncSeatsWithTemplate = (template, existingActiveSeats, existingBlockedSeats, existingLabels) => {
    if (!template || !template.seats) return null;
    
    // Get all seat numbers from template
    const templateSeatNumbers = template.seats.map(s => s.seatNumber);
    
    // Keep only active seats that exist in the template
    const validActiveSeats = existingActiveSeats.filter(s => templateSeatNumbers.includes(s));
    
    // Keep only blocked seats that exist in the template
    const validBlockedSeats = existingBlockedSeats.filter(s => templateSeatNumbers.includes(s));
    
    // Update custom seat labels from template
    const newLabels = {};
    template.seats.forEach(seat => {
      // If the seat is active and has a label in the existing data, use it
      if (validActiveSeats.includes(seat.seatNumber) && existingLabels[seat.seatNumber]) {
        newLabels[seat.seatNumber] = existingLabels[seat.seatNumber];
      } else {
        // Otherwise use the template's globalSeatIndex or seatNumber
        newLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
      }
    });
    
    return {
      activeSeats: validActiveSeats.length > 0 ? validActiveSeats : templateSeatNumbers,
      blockedSeats: validBlockedSeats,
      labels: newLabels
    };
  };

  // ─── KEY: Load fareMatrix AND PRESERVE THE ORIGINAL PRICES ───
  useEffect(() => {
    const loadRouteData = async () => {
      if (!bus || !bus.routeSchedules || bus.routeSchedules.length === 0) {
        console.log('No routeSchedules in bus:', bus);
        return;
      }

      console.log('Loading route data from bus:', bus);
      console.log('RouteSchedules:', bus.routeSchedules);

      const upSchedule = bus.routeSchedules.find(s => s.direction === 'UP');
      const downSchedule = bus.routeSchedules.find(s => s.direction === 'DOWN');

      // ========== CRITICAL: PRESERVE THE ORIGINAL FARE MATRIX WITH PRICES ==========
      if (upSchedule?.fareMatrix?.length > 0) {
        // Log the original prices
        const firstRow = upSchedule.fareMatrix[0];
        if (firstRow?.toCells) {
          const prices = firstRow.toCells
            .filter(c => c !== null)
            .map(c => ({ toName: c.toName, price: c.price }));
          console.log('✅ Original UP FareMatrix prices:', prices);
        }

        // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
        setFareMatrixUp(JSON.parse(JSON.stringify(upSchedule.fareMatrix)));

        // Reconstruct route with proper distanceFromOrigin from existing matrix
        const reconstructed = reconstructStopsFromMatrix(upSchedule.fareMatrix);
        setReconstructedRouteUp(reconstructed);

        if (reconstructed) {
          setSourceCity(reconstructed.origin?.city || '');
          setDestinationCity(reconstructed.destination?.city || '');

          // Fetch the full route data to get localRouteName and other details
          let fullRoute = null;
          try {
            const routeId = upSchedule.routeId;
            console.log("Fetching route details for ID:", routeId);

            const response = await getRouteById(routeId, token);
            console.log("Full route response:", response);

            if (response && response.success && response.data) {
              fullRoute = response.data;
            } else if (response && response.data) {
              fullRoute = response.data;
            }
          } catch (err) {
            console.error("Error fetching route details:", err);
          }

          const localRouteName = bus.localRouteName || fullRoute?.localRouteName || null;
          console.log("Setting localRouteName:", localRouteName);

          setSelectedRoute({
            _id: upSchedule.routeId,
            routeName: upSchedule.routeName ||
              `${reconstructed.origin?.city} → ${reconstructed.destination?.city}`,
            localRouteName: localRouteName,
            origin: reconstructed.origin,
            destination: reconstructed.destination,
            intermediateStops: reconstructed.intermediateStops || [],
            routeDetails: reconstructed.routeDetails,
            stops: reconstructed.stops,
            returnJourney: downSchedule ? (() => {
              const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
              setReconstructedRouteDown(downReconstructed);
              return downReconstructed;
            })() : null
          });
        }
      }

      if (downSchedule?.fareMatrix?.length > 0) {
        // Log the original prices
        const firstRow = downSchedule.fareMatrix[0];
        if (firstRow?.toCells) {
          const prices = firstRow.toCells
            .filter(c => c !== null)
            .map(c => ({ toName: c.toName, price: c.price }));
          console.log('✅ Original DOWN FareMatrix prices:', prices);
        }

        // Set the fareMatrix directly from the bus data - PRESERVING ORIGINAL PRICES
        setFareMatrixDown(JSON.parse(JSON.stringify(downSchedule.fareMatrix)));
        if (!upSchedule?.fareMatrix?.length) {
          const downReconstructed = reconstructStopsFromMatrix(downSchedule.fareMatrix);
          setReconstructedRouteDown(downReconstructed);
        }
      }

      setInitialDataLoaded(true);
    };

    loadRouteData();
  }, [bus, token]);

  // ─── KEY FIX: Reconstruct stops with cumulative distances from fareMatrix ───
  // This function ONLY reconstructs stops, it does NOT recalculate prices
  const reconstructStopsFromMatrix = (fareMatrix) => {
    if (!fareMatrix || fareMatrix.length === 0) return null;

    const stops = [];

    // Origin stop
    stops.push({
      id: fareMatrix[0].fromId || 'origin',
      name: fareMatrix[0].fromName,
      distanceFromOrigin: 0,
      type: fareMatrix[0].fromType || 'origin'
    });

    // Read the first row's toCells to get distances from origin to all other stops
    const firstRowCells = fareMatrix[0].toCells || [];
    firstRowCells.forEach((cell) => {
      if (cell) {
        stops.push({
          id: cell.toId || cell.toName,
          name: cell.toName,
          distanceFromOrigin: parseFloat(cell.distanceKm) || 0,
          type: 'stop'
        });
      }
    });

    // Mark the last stop as destination
    if (stops.length > 1) {
      stops[stops.length - 1].type = 'destination';
    }

    return {
      stops,
      origin: { city: stops[0]?.name },
      destination: { city: stops[stops.length - 1]?.name },
      intermediateStops: stops.slice(1, -1).map((s, idx) => ({
        city: s.name,
        distanceFromOrigin: s.distanceFromOrigin,
        sequence: idx + 1
      })),
      routeDetails: {
        totalDistance: stops[stops.length - 1]?.distanceFromOrigin || 0
      }
    };
  };

  // ─── generateMatrixForRoute: This function is called when user clicks "Regenerate" ───
  // It should ONLY be used when generating a NEW matrix, not when editing existing one
  const generateMatrixForRoute = (routeData) => {
    if (!routeData) return [];

    const baseP = parseFloat(pricing.basePrice) || 0;
    const baseD = parseFloat(pricing.baseDistance) || 0;
    const costK = parseFloat(pricing.costPerKm) || 0;
    const multiplier = getCategoryMultiplier();

    let allStops = [];

    if (routeData.stops && routeData.stops.length > 0) {
      allStops = routeData.stops.map(s => ({
        id: s.id || s.name,
        name: s.name,
        distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
        type: s.type
      }));
    } else {
      const sortedStops = [...(routeData.intermediateStops || [])]
        .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

      allStops = [
        {
          id: 'origin',
          name: routeData.origin?.city || 'Origin',
          distanceFromOrigin: 0,
          type: 'origin'
        },
        ...sortedStops.map((s, i) => ({
          id: s._id || `stop_${i}`,
          name: s.city || s.name || `Stop ${i + 1}`,
          distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
          type: 'stop',
          sequence: s.sequence
        })),
        {
          id: 'destination',
          name: routeData.destination?.city || 'Destination',
          distanceFromOrigin:
            parseFloat(routeData.destination?.distanceFromOrigin) ||
            parseFloat(routeData.routeDetails?.totalDistance) || 0,
          type: 'destination'
        }
      ];
    }

    const matrix = allStops.map((fromStop, i) => {
      const toCells = allStops.map((toStop, j) => {
        if (j > i) {
          const distance = parseFloat(
            (toStop.distanceFromOrigin - fromStop.distanceFromOrigin).toFixed(1)
          );
          let price = baseP;
          if (distance > baseD) {
            price += (distance - baseD) * costK;
          }
          price = Math.round(price * multiplier);

          return {
            toId: toStop.id,
            toName: toStop.name,
            distanceKm: distance,
            price: price
          };
        }
        return null;
      });

      return {
        fromId: fromStop.id,
        fromName: fromStop.name,
        fromType: fromStop.type,
        toCells: toCells
      };
    });

    return matrix.filter(row => row.fromType !== 'destination');
  };

  // ─── Update the useEffect that initializes form data with proper platform fee parsing ───
  useEffect(() => {
    if (bus) {
      console.log('Loading bus data for edit:', bus);

      setForm({
        busNumber: bus.busNumber || '',
        busName: bus.busName || '',
        busType: bus.busType || 'AC',
        busCategory: bus.busCategory || 'Seater',
        amenities: bus.amenities || []
      });

      setTripType(bus.tripType || 'oneWay');

      if (bus.bookingClosedBefore) {
        setBookingClosedBefore(bus.bookingClosedBefore);
      }

      if (bus.cancellationTime) {
        setCancellationTime(bus.cancellationTime);
      } else {
        setCancellationTime({ hours: 1, minutes: 0 });
      }

      if (bus.platformFee) {
        setPlatformFee({
          type: bus.platformFee.type || 'fixed',
          value: bus.platformFee.value || 0,
          applicableOn: bus.platformFee.applicableOn || 'per_ticket'
        });
      } else {
        setPlatformFee({
          type: 'fixed',
          value: 0,
          applicableOn: 'per_ticket'
        });
      }

      if (bus.operatingDays && bus.operatingDays.length > 0) {
        setOperatingDays(bus.operatingDays);
      }

      if (bus.fareDetails) {
        setPricing({
          basePrice: bus.fareDetails.basePrice || '',
          baseDistance: bus.fareDetails.baseDistance || '',
          costPerKm: bus.fareDetails.costPerKm || ''
        });
      }

      if (bus.images && bus.images.length > 0) {
        setExistingImages(bus.images);
      }
      if (bus.video && bus.video.length > 0) {
        setExistingVideo(bus.video[0]);
      }

      if (bus.seatConfiguration) {
        const config = bus.seatConfiguration.busType || '2*2';
        setSelectedConfiguration(config);
        console.log('Set configuration from bus:', config);
      }

      // ========== FIX: Load seats with proper labels and blocked status ==========
      if (bus.seats && bus.seats.length > 0) {
        // Get all seat numbers that are available
        const activeSeatNumbers = bus.seats
          .filter(seat => seat.isAvailable !== false)
          .map(seat => seat.seatNumber);
        setActiveSeats(activeSeatNumbers);

        // ========== CRITICAL FIX: Get blocked seats ==========
        const blockedSeatNumbers = bus.seats
          .filter(seat => seat.isBlocked === true)
          .map(seat => seat.seatNumber);
        setBlockedSeats(blockedSeatNumbers);

        console.log('Loaded blocked seats:', blockedSeatNumbers);

        // Set seat labels
        const seatLabels = {};
        bus.seats.forEach(seat => {
          const displayLabel = seat.globalSeatIndex || seat.seatNumber;
          seatLabels[seat.seatNumber] = displayLabel;
        });
        setCustomSeatLabels(seatLabels);

        console.log('Loaded seat labels from database:', seatLabels);
        console.log('Active seats:', activeSeatNumbers);
        console.log('Blocked seats:', blockedSeatNumbers);
      }
    }
  }, [bus]);

  // ─── Fetch layouts and auto-select template when configuration changes ───
  useEffect(() => {
    if (selectedConfiguration && form.busCategory) {
      fetchLayouts(selectedConfiguration);
    }
  }, [selectedConfiguration, form.busCategory]);

  // ─── Fetch available configurations ───
  const fetchAvailableConfigurations = async () => {
    try {
      setLoadingLayouts(true);
      const response = await getAllCategory(token, form.busCategory);
      if (response && response.success && response.data) {
        const configs = [...new Set(response.data.map(cat => cat.configuration))];
        if (configs.length > 0) {
          setAvailableConfigurations(configs);
          if (!selectedConfiguration || !configs.includes(selectedConfiguration)) {
            setSelectedConfiguration(configs[0]);
          }
        } else {
          setAvailableConfigurations([]);
        }
      }
    } catch (error) {
      console.error('Error fetching configurations:', error);
      setAvailableConfigurations([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  // ─── Fetch layouts and auto-select template ───
  const fetchLayouts = async (config) => {
    try {
      if (!config) return;
      setLoadingLayouts(true);
      let bustype = config.replace('x', '*');
      const response = await getSeatLayoutsByBustype(bustype, token);
      
      if (response && response.success && response.data && Array.isArray(response.data)) {
        let filteredLayouts = response.data;
        if (form.busCategory === 'Seater') {
          filteredLayouts = response.data.filter(layout =>
            layout.seatType === 'seat' || layout.seatType === 'seater');
        } else if (form.busCategory === 'Sleeper') {
          filteredLayouts = response.data.filter(layout => layout.seatType === 'sleeper');
        } else if (form.busCategory === 'Seater+Sleeper') {
          filteredLayouts = response.data.filter(layout =>
            layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper');
        }
        setLayoutTemplates(filteredLayouts);
        
        // Check if we have bus data with seats
        if (bus && bus.seats && bus.seats.length > 0 && filteredLayouts.length > 0) {
          const totalSeats = bus.seats.length;
          const existingConfig = bus.seatConfiguration?.busType || config;
          
          let matchingTemplate = filteredLayouts.find(template => {
            if (template.totalSeats === totalSeats) {
              return template.configuration === existingConfig || 
                     template.configuration === existingConfig.replace('*', 'x');
            }
            return false;
          });
          
          if (!matchingTemplate) {
            matchingTemplate = filteredLayouts.find(template => 
              template.configuration === existingConfig || 
              template.configuration === existingConfig.replace('*', 'x')
            );
          }
          
          const autoSelected = matchingTemplate || filteredLayouts[0];
          
          if (autoSelected && !selectedTemplate) {
            setSelectedTemplate(autoSelected);
            console.log('Auto-selected template from fetchLayouts:', autoSelected.name);
            
            if (autoSelected.seats && autoSelected.seats.length > 0) {
              const templateSeatNumbers = autoSelected.seats.map(s => s.seatNumber);
              
              // ========== CRITICAL FIX: Get blocked seats from bus data ==========
              const currentActiveSeats = bus.seats
                .filter(seat => seat.isAvailable !== false)
                .map(seat => seat.seatNumber);
              const currentBlockedSeats = bus.seats
                .filter(seat => seat.isBlocked === true)
                .map(seat => seat.seatNumber);
              
              console.log('📊 Bus data seats:', bus.seats.map(s => ({ 
                seatNumber: s.seatNumber, 
                isAvailable: s.isAvailable, 
                isBlocked: s.isBlocked 
              })));
              console.log('📊 Current active seats from bus:', currentActiveSeats);
              console.log('📊 Current blocked seats from bus:', currentBlockedSeats);
              
              // Only keep seats that exist in the template
              const validActiveSeats = currentActiveSeats.filter(s => templateSeatNumbers.includes(s));
              const validBlockedSeats = currentBlockedSeats.filter(s => templateSeatNumbers.includes(s));
              
              console.log('📊 Valid active seats:', validActiveSeats);
              console.log('📊 Valid blocked seats:', validBlockedSeats);
              
              // Set the states
              if (validActiveSeats.length > 0) {
                setActiveSeats(validActiveSeats);
              } else {
                setActiveSeats(templateSeatNumbers);
              }
              
              // ========== PRESERVE BLOCKED SEATS ==========
              setBlockedSeats(validBlockedSeats);
              
              // Update labels
              const newLabels = {};
              autoSelected.seats.forEach(seat => {
                const existingSeat = bus.seats.find(s => s.seatNumber === seat.seatNumber);
                newLabels[seat.seatNumber] = existingSeat?.globalSeatIndex || seat.globalSeatIndex || seat.seatNumber;
              });
              setCustomSeatLabels(newLabels);
              
              console.log('✅ Final blocked seats set to:', validBlockedSeats);
            }
          }
        } else if (!selectedTemplate && filteredLayouts.length > 0) {
          // No bus data, use first template
          setSelectedTemplate(filteredLayouts[0]);
          if (filteredLayouts[0].seats) {
            const seatNumbers = filteredLayouts[0].seats.map(s => s.seatNumber);
            setActiveSeats(seatNumbers);
            setBlockedSeats([]);
            const labels = {};
            filteredLayouts[0].seats.forEach(s => {
              labels[s.seatNumber] = s.globalSeatIndex || s.seatNumber;
            });
            setCustomSeatLabels(labels);
          }
        }
      } else {
        setLayoutTemplates([]);
      }
    } catch (error) {
      console.error("Layout Fetch Error:", error);
      setLayoutTemplates([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  // ─── Fetch routes ───
  const fetchRoutesBySourceDestination = async () => {
    if (!sourceCity || !destinationCity) {
      setAvailableRoutes([]);
      return;
    }
    setLoadingRoutes(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token, 1, 50, '', '',
        { originCity: sourceCity, destinationCity: destinationCity }
      );
      console.log("Fetched routes response:", response);

      if (response && response.success && response.routes) {
        const routesWithLocalName = response.routes.map(route => ({
          ...route,
          localRouteName: route.localRouteName || null
        }));
        setAvailableRoutes(routesWithLocalName);
      } else {
        setAvailableRoutes([]);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
      setAvailableRoutes([]);
    } finally {
      setLoadingRoutes(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sourceCity && destinationCity && !selectedRoute) {
        fetchRoutesBySourceDestination();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [sourceCity, destinationCity]);

  useEffect(() => {
    if (form.busCategory) {
      fetchAvailableConfigurations();
    }
  }, [form.busCategory, token]);

  const getCategoryMultiplier = () => {
    const multipliers = { 'Seater': 1.0, 'Sleeper': 1.5, 'Seater+Sleeper': 1.3 };
    return multipliers[form.busCategory] || 1.0;
  };

  const getStopColor = (type) => {
    switch (type) {
      case 'origin': return '#4c51bf';
      case 'destination': return '#40c057';
      default: return '#667eea';
    }
  };

  const handleSelectRoute = (route) => {
    setSelectedRoute({
      ...route,
      stops: null,
      localRouteName: route.localRouteName
    });
    setShowRouteDropdown(false);
    setRouteSearchTerm('');
    setSourceCity(route.origin?.city || '');
    setDestinationCity(route.destination?.city || '');
    setFareMatrixUp([]);
    setFareMatrixDown([]);
    setReconstructedRouteUp(null);
    setReconstructedRouteDown(null);

    if (route.localRouteName) {
      toast.info(`Selected: ${route.localRouteName}`);
    }
  };

  const toggleDay = (day) => {
    setOperatingDays(prev =>
      prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
    );
  };

  const handleAmenityToggle = (amenity) => {
    setForm(prev => ({
      ...prev,
      amenities: prev.amenities.includes(amenity)
        ? prev.amenities.filter(a => a !== amenity)
        : [...prev.amenities, amenity]
    }));
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const newImages = [];
    files.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        newImages.push({ file: file, preview: e.target.result, name: file.name });
        if (newImages.length === files.length) {
          setSelectedImages(prev => [...prev, ...newImages]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const removeExistingImage = (index) => {
    setExistingImages(prev => prev.filter((_, i) => i !== index));
  };

  const removeNewImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedVideo({ file: file, preview: e.target.result, name: file.name });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeExistingVideo = () => setExistingVideo(null);
  const removeNewVideo = () => setSelectedVideo(null);

  const handleBookingTimeChange = (field, value) => {
    setBookingClosedBefore(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handleCancellationTimeChange = (field, value) => {
    setCancellationTime(prev => ({ ...prev, [field]: parseInt(value) || 0 }));
  };

  const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];
    const updatedMatrix = currentMatrix.map((row, rIndex) => {
      if (rIndex !== rowIndex) return row;
      const newToCells = [...row.toCells];
      if (newToCells[colIndex]) {
        newToCells[colIndex] = { ...newToCells[colIndex], price: parseInt(newPrice) || 0 };
      }
      return { ...row, toCells: newToCells };
    });
    if (isUp) setFareMatrixUp(updatedMatrix);
    else setFareMatrixDown(updatedMatrix);
  };

  const handleSelectTemplate = (template) => {
    setSelectedTemplate(template);
    setShowTemplateModal(false);
    setShowLayoutModal(true);
    
    // Sync active seats with the new template
    if (template.seats && template.seats.length > 0) {
      const templateSeatNumbers = template.seats.map(s => s.seatNumber);
      // Keep only active seats that exist in the template
      const validActiveSeats = activeSeats.filter(s => templateSeatNumbers.includes(s));
      if (validActiveSeats.length > 0) {
        setActiveSeats(validActiveSeats);
      } else {
        // If no matching active seats, activate all seats in the template
        setActiveSeats(templateSeatNumbers);
      }
      
      // Update seat labels from template
      const newLabels = {};
      template.seats.forEach(seat => {
        // Preserve existing custom labels if they exist
        if (customSeatLabels[seat.seatNumber]) {
          newLabels[seat.seatNumber] = customSeatLabels[seat.seatNumber];
        } else {
          newLabels[seat.seatNumber] = seat.globalSeatIndex || seat.seatNumber;
        }
      });
      setCustomSeatLabels(newLabels);
    }
    
    toast.success(`Selected template: ${template.name}`);
  };

  const handleSeatPress = (seatObj) => {
    setEditingSeat(seatObj.seatNumber);

    // ========== FIX: Use the existing label from customSeatLabels ==========
    const existingLabel = customSeatLabels[seatObj.seatNumber];

    if (activeSeats.includes(seatObj.seatNumber)) {
      // If the seat is active, show its current label
      setTempSeatLabel(String(existingLabel || seatObj.globalSeatIndex || seatObj.seatNumber));
    } else {
      // If the seat is inactive, show the seat number as default
      setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
    }
  };

  const autoRenumberSeats = () => {
    if (!selectedTemplate || !selectedTemplate.seats) return;
    const sortedSeats = [...selectedTemplate.seats].sort((a, b) => {
      if (a.row === b.row) return a.column - b.column;
      return a.row - b.row;
    });
    let counter = 1;
    const newLabels = {};
    sortedSeats.forEach(s => {
      if (activeSeats.includes(s.seatNumber)) {
        newLabels[s.seatNumber] = String(counter++);
      }
    });
    setCustomSeatLabels(newLabels);
  };

  const getSeatPosition = (column) => {
    switch (parseInt(column)) {
      case 1: return 'window';
      case 2: return 'middle';
      case 3: return 'aisle';
      case 4: return 'window';
      default: return 'aisle';
    }
  };

  // ========== UPDATE BUS FUNCTION ==========
  const handleUpdateBus = async () => {
    try {
      setIsSubmitting(true);
      setError(null);

      // Validation checks...
      if (!form.busNumber) throw new Error('Bus Number is required');
      if (!form.busName) throw new Error('Bus Name is required');
      if (!form.busType) throw new Error('Bus Type is required');
      if (!form.busCategory) throw new Error('Bus Category is required');
      if (operatingDays.length === 0) throw new Error('Please select at least one operating day');

      const amenitiesArray = form.amenities || [];

      let finalSeatsPayload = [];
      if (selectedTemplate && selectedTemplate.seats) {
        finalSeatsPayload = selectedTemplate.seats
          .filter(s => activeSeats.includes(s.seatNumber))
          .map(s => {
            // ========== FIX: Use the label from customSeatLabels ==========
            const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
            const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
            const isBlocked = blockedSeats.includes(s.seatNumber);

            return {
              seatNumber: s.seatNumber,
              globalSeatIndex: finalGlobalIndex,
              row: s.row,
              column: s.column,
              seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
              position: s.position || getSeatPosition(s.column),
              isBlocked: isBlocked,
              isAvailable: !isBlocked,
            };
          });
      } else if (bus.seats) {
        // If no template selected, use existing seats but update labels
        finalSeatsPayload = bus.seats.map(seat => {
          const label = customSeatLabels[seat.seatNumber] || seat.globalSeatIndex || seat.seatNumber;
          return {
            ...seat,
            globalSeatIndex: label,
          };
        });
      }

      const seatConfigPayload = {
        busType: selectedTemplate?.configuration || selectedConfiguration || '2*2',
        totalSeats: activeSeats.length || bus.totalSeats
      };

      const formData = new FormData();
      formData.append('busNumber', form.busNumber.toUpperCase().trim());
      formData.append('busName', form.busName.trim());
      formData.append('busType', form.busType);
      formData.append('busCategory', form.busCategory);
      formData.append('totalSeats', String(activeSeats.length || bus.totalSeats || 0));
      formData.append('tripType', tripType);
      formData.append('busClass', 'Economy');
      formData.append('amenities', JSON.stringify(amenitiesArray));
      formData.append('seats', JSON.stringify(finalSeatsPayload));
      formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
      formData.append('operatingDays', JSON.stringify(operatingDays));
      formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
      formData.append('cancellationTime', JSON.stringify(cancellationTime));
      formData.append('isActive', bus.isActive !== undefined ? bus.isActive : true);

      const cleanPlatformFee = {
        type: platformFee.type || 'fixed',
        value: parseFloat(platformFee.value) || 0,
        applicableOn: platformFee.applicableOn || 'per_ticket'
      };
      formData.append('platformFee', JSON.stringify(cleanPlatformFee));

      const fareDetails = {
        basePrice: parseFloat(pricing.basePrice) || 0,
        baseDistance: parseFloat(pricing.baseDistance) || 0,
        costPerKm: parseFloat(pricing.costPerKm) || 0
      };
      formData.append('fareDetails', JSON.stringify(fareDetails));

      // ========== Build routeSchedules with the CORRECT fareMatrix from state ==========
      let routeSchedulesToSend = [];

      if (selectedRoute) {
        // Build UP schedule with fareMatrixUp (which has the original prices)
        const upSchedule = {
          routeId: selectedRoute._id,
          routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
          routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
          direction: 'UP',
          operatingDays: operatingDays,
          fareMatrix: fareMatrixUp,
          origin: {
            city: selectedRoute.origin?.city || sourceCity,
            state: selectedRoute.origin?.state || 'West Bengal',
            address: selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
            terminal: selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
            departureTime: selectedRoute.origin?.departureTime || '08:00',
            timings: selectedRoute.origin?.timings || [
              { timeSlotSequence: 1, departureTime: '08:00', arrivalTime: '' },
              { timeSlotSequence: 2, departureTime: '12:00', arrivalTime: '' }
            ],
            coordinates: selectedRoute.origin?.coordinates || { lat: 0, lng: 0 }
          },
          destination: {
            city: selectedRoute.destination?.city || destinationCity,
            state: selectedRoute.destination?.state || 'West Bengal',
            address: selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
            terminal: selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
            arrivalTime: selectedRoute.destination?.arrivalTime || '10:00',
            timings: selectedRoute.destination?.timings || [
              { timeSlotSequence: 1, arrivalTime: '10:00', departureTime: '' },
              { timeSlotSequence: 2, arrivalTime: '14:00', departureTime: '' }
            ],
            coordinates: selectedRoute.destination?.coordinates || { lat: 0, lng: 0 },
            distanceFromOrigin: selectedRoute.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
          },
          intermediateStops: selectedRoute.intermediateStops || [],
          additionalBoardingPoints: selectedRoute.additionalBoardingPoints || [],
          additionalDroppingPoints: selectedRoute.additionalDroppingPoints || [],
          additionalNullPoints: selectedRoute.additionalNullPoints || [],
          routeDetails: {
            totalDistance: selectedRoute.routeDetails?.totalDistance || 100,
            estimatedDuration: selectedRoute.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
          },
          isActive: true,
          validFrom: new Date()
        };

        routeSchedulesToSend.push(upSchedule);

        // Build DOWN schedule for round trip with fareMatrixDown
        if (tripType === 'roundTrip') {
          const returnJourney = selectedRoute.returnJourney;

          if (returnJourney || fareMatrixDown.length > 0) {
            const downSchedule = {
              routeId: selectedRoute._id,
              routeNumber: selectedRoute.routeNumber || `Route-${selectedRoute.origin?.city}-${selectedRoute.destination?.city}`,
              routeName: selectedRoute.routeName || `${selectedRoute.origin?.city} to ${selectedRoute.destination?.city}`,
              direction: 'DOWN',
              operatingDays: operatingDays,
              fareMatrix: fareMatrixDown,
              origin: {
                city: returnJourney?.origin?.city || selectedRoute.destination?.city || destinationCity,
                state: returnJourney?.origin?.state || selectedRoute.destination?.state || 'West Bengal',
                address: returnJourney?.origin?.address || selectedRoute.destination?.address || `${destinationCity}, West Bengal`,
                terminal: returnJourney?.origin?.terminal || selectedRoute.destination?.terminal || `${destinationCity} Terminal`,
                departureTime: returnJourney?.origin?.departureTime || '14:00',
                timings: returnJourney?.origin?.timings || [
                  { timeSlotSequence: 1, departureTime: '14:00', arrivalTime: '' },
                  { timeSlotSequence: 2, departureTime: '18:00', arrivalTime: '' }
                ],
                coordinates: returnJourney?.origin?.coordinates || selectedRoute.destination?.coordinates || { lat: 0, lng: 0 }
              },
              destination: {
                city: returnJourney?.destination?.city || selectedRoute.origin?.city || sourceCity,
                state: returnJourney?.destination?.state || selectedRoute.origin?.state || 'West Bengal',
                address: returnJourney?.destination?.address || selectedRoute.origin?.address || `${sourceCity}, West Bengal`,
                terminal: returnJourney?.destination?.terminal || selectedRoute.origin?.terminal || `${sourceCity} Terminal`,
                arrivalTime: returnJourney?.destination?.arrivalTime || '16:00',
                timings: returnJourney?.destination?.timings || [
                  { timeSlotSequence: 1, arrivalTime: '16:00', departureTime: '' },
                  { timeSlotSequence: 2, arrivalTime: '20:00', departureTime: '' }
                ],
                coordinates: returnJourney?.destination?.coordinates || selectedRoute.origin?.coordinates || { lat: 0, lng: 0 },
                distanceFromOrigin: returnJourney?.destination?.distanceFromOrigin || selectedRoute.routeDetails?.totalDistance || 100
              },
              intermediateStops: returnJourney?.intermediateStops || [],
              additionalBoardingPoints: returnJourney?.additionalBoardingPoints || [],
              additionalDroppingPoints: returnJourney?.additionalDroppingPoints || [],
              additionalNullPoints: returnJourney?.additionalNullPoints || [],
              routeDetails: {
                totalDistance: returnJourney?.routeDetails?.totalDistance || selectedRoute.routeDetails?.totalDistance || 100,
                estimatedDuration: returnJourney?.routeDetails?.estimatedDuration || { hours: 1, minutes: 0 }
              },
              isActive: true,
              validFrom: new Date()
            };

            routeSchedulesToSend.push(downSchedule);
          }
        }

        console.log('Sending routeSchedules with fareMatrix:', JSON.stringify(routeSchedulesToSend, null, 2));
        formData.append('routeSchedules', JSON.stringify(routeSchedulesToSend));

        if (selectedRoute.localRouteName) {
          formData.append('localRouteName', selectedRoute.localRouteName);
        }

      } else if (bus.routeSchedules) {
        formData.append('routeSchedules', JSON.stringify(bus.routeSchedules));
        if (bus.localRouteName) {
          formData.append('localRouteName', bus.localRouteName);
        }
      }

      // Handle images and videos
      if (existingImages.length > 0) {
        formData.append('existingImages', JSON.stringify(existingImages));
      }
      selectedImages.forEach((img) => {
        if (img.file) formData.append('images', img.file);
      });
      if (existingVideo) {
        formData.append('existingVideo', existingVideo);
      }
      if (selectedVideo && selectedVideo.file) {
        formData.append('videos', selectedVideo.file);
      }

      const response = await updateBus(bus._id, formData, token);

      if (response && response.success) {
        toast.success('Bus updated successfully!');
        if (onUpdate) onUpdate();
        onClose();
      } else {
        throw new Error(response?.message || 'Failed to update bus');
      }
    } catch (err) {
      console.error('Error updating bus:', err);
      setError(err.message || 'Failed to update bus');
      toast.error(err.message || 'Failed to update bus');
    } finally {
      setIsSubmitting(false);
    }
  };

  // ─── renderMatrix: Renders the fare matrix with preserved prices ───
  const renderMatrix = (type) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
    const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

    if (!currentRoute || !currentMatrix || currentMatrix.length === 0) return (
      <div className="matrix-placeholder">
        <p>No fare matrix available. Please go back and generate the matrix.</p>
      </div>
    );

    const allStops = [];
    currentMatrix.forEach(row => {
      if (!allStops.find(s => s.name === row.fromName)) {
        allStops.push({ name: row.fromName, type: row.fromType });
      }
    });
    const firstRowLastCell = currentMatrix[0]?.toCells?.filter(Boolean).pop();
    if (firstRowLastCell && !allStops.find(s => s.name === firstRowLastCell.toName)) {
      allStops.push({ name: firstRowLastCell.toName, type: 'destination' });
    }

    return (
      <div className="matrix-section">
        <h5 className="matrix-title">{isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}</h5>
        <div className="matrix-container">
          <div className="matrix-table-wrapper">
            <table className="fare-matrix-table">
              <thead>
                <tr>
                  <th className="corner-cell">From \ To</th>
                  {allStops.map((stop, i) => (
                    <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
                      <div className="stop-header">
                        <span className="stop-name">{stop.name}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentMatrix.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
                      <div className="from-stop">
                        <span className="stop-name">{row.fromName}</span>
                      </div>
                    </td>
                    {allStops.map((stop, colIndex) => {
                      const matchingCell = row.toCells?.find(cell => cell && cell.toName === stop.name);
                      if (matchingCell) {
                        return (
                          <td key={colIndex} className="price-cell">
                            <div className="fare-cell">
                              <span className="distance">{matchingCell.distanceKm || 0} km</span>
                              <div className="price-input-group">
                                <span className="currency">₹</span>
                                <input
                                  type="text"
                                  className="matrix-input"
                                  value={matchingCell.price}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || /^\d+$/.test(value)) {
                                      const actualColIndex = row.toCells.findIndex(
                                        cell => cell && cell.toName === stop.name
                                      );
                                      handlePriceChange(type, rowIndex, actualColIndex, value);
                                    }
                                  }}
                                  min="0"
                                  step="1"
                                  pattern="\d*"
                                  inputMode="numeric"
                                />
                              </div>
                            </div>
                          </td>
                        );
                      }
                      return <td key={colIndex} className="na-cell">—</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  // ─── renderSeatVisualizer ───
  const renderSeatVisualizer = () => {
    if (!selectedTemplate) return (
      <div className="seat-placeholder">
        <p>Select a template to configure seats</p>
        <button type="button" className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
          Select Template
        </button>
      </div>
    );

    if (!selectedTemplate.seats || selectedTemplate.seats.length === 0) {
      return <div className="seat-placeholder">No seats available in this template</div>;
    }

    const { seats, configuration } = selectedTemplate;
    let leftCount = 2, rightCount = 2;
    if (configuration && configuration.includes('*')) {
      const parts = configuration.split('*');
      leftCount = parseInt(parts[0]) || 2;
      rightCount = parseInt(parts[1]) || 2;
    }

    const seatsByRow = {};
    seats.forEach(seat => {
      if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
      seatsByRow[seat.row].push(seat);
    });

    const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);
    const rows = [];

    const renderSeat = (seatObj) => {
      const isSelected = activeSeats.includes(seatObj.seatNumber);
      const isBlocked = blockedSeats.includes(seatObj.seatNumber);
      const isSleeper = seatObj.seatType === 'sleeper' ||
        seatObj.seatType === 'seat+sleeper' ||
        selectedTemplate.seatType === 'sleeper' ||
        selectedTemplate.seatType === 'seater+sleeper';

      let displayLabel = '';

      if (isSelected) {
        if (customSeatLabels[seatObj.seatNumber]) {
          displayLabel = customSeatLabels[seatObj.seatNumber];
        } else if (seatObj.globalSeatIndex) {
          displayLabel = seatObj.globalSeatIndex;
        } else {
          displayLabel = seatObj.seatNumber;
        }
      }

      let seatClass = '';
      if (isSelected) {
        // ========== BLOCKED SEATS SHOW WITH DIFFERENT COLOR ==========
        seatClass = isBlocked ? 'blocked' : 'selected';
      } else {
        seatClass = 'inactive';
      }

      // If the seat is blocked but not active, make it active
      if (isBlocked && !isSelected) {
        // Auto-add blocked seats to active list if they're not already there
        if (!activeSeats.includes(seatObj.seatNumber)) {
          setActiveSeats(prev => [...prev, seatObj.seatNumber]);
        }
      }

      return (
        <button
          key={seatObj.seatNumber}
          className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
          onClick={() => handleSeatPress(seatObj)}
          type="button"
          style={isBlocked ? { 
            backgroundColor: '#dc3545', 
            color: 'white',
            borderColor: '#bd2130'
          } : {}}
        >
          <span className="seat-number">{displayLabel}</span>
        </button>
      );
    };

    rowNumbers.forEach(rowNum => {
      const seatsInRow = seatsByRow[rowNum];
      const leftSeats = seatsInRow.filter(s => (s.column || 0) <= leftCount)
        .sort((a, b) => (a.column || 0) - (b.column || 0));
      const rightSeats = seatsInRow.filter(s => (s.column || 0) > leftCount)
        .sort((a, b) => (a.column || 0) - (b.column || 0));
      rows.push(
        <div key={`row-${rowNum}`} className="seat-row">
          <div className="left-seats">{leftSeats.map(seat => renderSeat(seat))}</div>
          <div className="aisle">Aisle</div>
          <div className="right-seats">{rightSeats.map(seat => renderSeat(seat))}</div>
        </div>
      );
    });

    return (
      <div className="seat-layout-visualizer">
        <div className="bus-header"><div className="driver-area">Driver</div></div>
        <div className="bus-body">{rows}</div>
        <div className="seat-legend">
          <div className="legend-item"><div className="seat-sample selected"></div><span>Active ({activeSeats.length})</span></div>
          <div className="legend-item"><div className="seat-sample blocked"></div><span>Blocked ({blockedSeats.length})</span></div>
          <div className="legend-item"><div className="seat-sample inactive"></div><span>Inactive</span></div>
        </div>
        <button className="auto-number-btn" onClick={autoRenumberSeats} style={{ marginTop: '10px' }}>
          Auto-Number Seats
        </button>
      </div>
    );
  };

  const ProgressSteps = () => (
    <div className="progress-steps">
      <div className={`step ${activeTab === 'basic' ? 'active' : ''}`}>
        <div className="step-icon">1</div><div className="step-label">Basic Info</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'route' ? 'active' : ''}`}>
        <div className="step-icon">2</div><div className="step-label">Route & Pricing</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'matrix' ? 'active' : ''}`}>
        <div className="step-icon">3</div><div className="step-label">Fare Matrix</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
        <div className="step-icon">4</div><div className="step-label">Seat Layout</div>
      </div>
    </div>
  );

  // ─── renderBasicInfoTab ───
  const renderBasicInfoTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Edit Bus Information</h3></div>

      <div className="form-grid">
        <div className="input-group">
          <label>Bus Number *</label>
          <input type="text" value={form.busNumber}
            onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
            className="modern-input" />
        </div>
        <div className="input-group">
          <label>Bus Name *</label>
          <input type="text" value={form.busName}
            onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
            className="modern-input" />
        </div>
      </div>

      <div className="section-card">
        <h4>Bus Images</h4>
        {existingImages.length > 0 && (
          <div className="existing-images">
            <label>Current Images</label>
            <div className="images-grid">
              {existingImages.map((img, idx) => (
                <div key={idx} className="image-preview-item">
                   <img src={`https://admin.roamjssln.com/uploads/buses/images/${img}`} alt="bus" />
                  <button type="button" onClick={() => removeExistingImage(idx)} className="remove-image-btn">×</button>
                </div>
              ))}
            </div>
          </div>
        )}
        <input type="file" id="edit-bus-images" multiple accept="image/*"
          onChange={handleImageUpload} style={{ display: 'none' }} />
        <label htmlFor="edit-bus-images" className="image-upload-label">+ Add New Images</label>
        {selectedImages.length > 0 && (
          <div className="new-images">
            <div className="images-grid">
              {selectedImages.map((img, idx) => (
                <div key={idx} className="image-preview-item">
                  <img src={img.preview} alt="new" />
                  <button type="button" onClick={() => removeNewImage(idx)} className="remove-image-btn">×</button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Bus Type *</label>
          <select value={form.busType}
            onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
            className="modern-select">
            {BUS_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Bus Category *</label>
          <select value={form.busCategory}
            onChange={(e) => setForm(prev => ({ ...prev, busCategory: e.target.value }))}
            className="modern-select">
            {BUS_CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
          </select>
        </div>
      </div>

      <div className="section-card">
        <h4>Booking Cut-off Time</h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label>Hours before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="24" value={bookingClosedBefore.hours}
                onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label>Minutes before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="59" value={bookingClosedBefore.minutes}
                onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
      </div>

      <div className="section-card">
        <h4>Cancellation Time</h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label>Hours before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="48" value={cancellationTime.hours}
                onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label>Minutes before departure</label>
            <div className="time-input-wrapper">
              <input type="number" min="0" max="59" value={cancellationTime.minutes}
                onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
                className="modern-input time-input" />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
        <small className="helper-text">Cancellation allowed up to this time before departure</small>
      </div>

      <PlatformFeeConfig platformFee={platformFee} onChange={setPlatformFee} />

      <div className="section-card">
        <h4>Amenities</h4>
        <div className="amenities-grid">
          {AMENITIES_LIST.map(amenity => (
            <label key={amenity} className="amenity-checkbox-label">
              <input type="checkbox" checked={form.amenities.includes(amenity)}
                onChange={() => handleAmenityToggle(amenity)} />
              <span>{amenity}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-actions">
        <button className="modern-btn primary" onClick={() => setActiveTab('route')}>Continue →</button>
      </div>
    </div>
  );

  // ─── renderRouteTab ───
  const renderRouteTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Route & Pricing Configuration</h3></div>

      <div className="section-card">
        <h4>Trip Type</h4>
        <div className="trip-type-container">
          <button className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
            onClick={() => setTripType('oneWay')}>One Way</button>
          <button className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
            onClick={() => setTripType('roundTrip')}>Round Trip</button>
        </div>
      </div>

      <div className="section-card">
        <h4>Source & Destination</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Source City</label>
            <input type="text" value={sourceCity}
              onChange={(e) => { setSourceCity(e.target.value); setSelectedRoute(null); }}
              placeholder="Enter source city" className="modern-input" />
          </div>
          <div className="form-group">
            <label>Destination City</label>
            <input type="text" value={destinationCity}
              onChange={(e) => { setDestinationCity(e.target.value); setSelectedRoute(null); }}
              placeholder="Enter destination city" className="modern-input" />
          </div>
        </div>
      </div>

      {sourceCity && destinationCity && (
        <div className="section-card">
          <h4>Select Route</h4>
          <div className="route-selector">
            <label>Available Routes</label>
            <div className="route-dropdown-container">
              <input
                type="text"
                value={
                  selectedRoute
                    ? (selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`)
                    : routeSearchTerm
                }
                onClick={() => setShowRouteDropdown(!showRouteDropdown)}
                onChange={(e) => {
                  setRouteSearchTerm(e.target.value);
                  setShowRouteDropdown(true);
                  setSelectedRoute(null);
                }}
                placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
                className="modern-input"
              />
              {showRouteDropdown && availableRoutes.length > 0 && (
                <div className="route-dropdown">
                  <div className="dropdown-search">
                    <input type="text" value={routeSearchTerm}
                      onChange={(e) => setRouteSearchTerm(e.target.value)}
                      placeholder="Search routes..." className="dropdown-search-input" autoFocus />
                  </div>
                  <div className="dropdown-list">
                    {availableRoutes
                      .filter(route =>
                        (route.localRouteName && route.localRouteName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.routeName && route.routeName.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.origin?.city && route.origin.city.toLowerCase().includes(routeSearchTerm.toLowerCase())) ||
                        (route.destination?.city && route.destination.city.toLowerCase().includes(routeSearchTerm.toLowerCase()))
                      )
                      .map(route => {
                        return (
                          <div key={route._id} className="dropdown-item"
                            onClick={() => handleSelectRoute(route)}>

                            {route.localRouteName ? (
                              <>
                                <div className="route-number" style={{ fontWeight: 'bold', color: '#2c7da0' }}>
                                  📍 {route.localRouteName}
                                </div>
                                <div className="route-details" style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                  {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
                                  {route.isRoundTrip && ' • Round Trip'}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="route-number" style={{ fontWeight: '500' }}>
                                  {route.routeName || `${route.origin?.city} → ${route.destination?.city}`}
                                </div>
                                <div className="route-details" style={{ fontSize: '12px', color: '#6c757d' }}>
                                  {route.origin?.city} → {route.destination?.city} • {route.routeDetails?.totalDistance || 0} km
                                  {route.isRoundTrip && ' • Round Trip'}
                                </div>
                              </>
                            )}

                            {route.creatorType === 'BusOwner' && (
                              <span className="owner-badge" style={{
                                marginLeft: '8px',
                                fontSize: '10px',
                                backgroundColor: '#ffc107',
                                color: '#000',
                                padding: '2px 6px',
                                borderRadius: '4px'
                              }}>
                                Owner
                              </span>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>
            {selectedRoute && (
              <small className="helper-text" style={{ color: 'green', marginTop: '5px', display: 'block' }}>
                ✓ Route selected: {selectedRoute.localRouteName || selectedRoute.routeName || `${selectedRoute.origin?.city} → ${selectedRoute.destination?.city}`}
              </small>
            )}
          </div>
        </div>
      )}

      <div className="section-card">
        <h4>Operating Days</h4>
        <div className="days-grid">
          {DAYS_OF_WEEK.map(day => (
            <button key={day} className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
              onClick={() => toggleDay(day)}>
              {day.substring(0, 3)}
            </button>
          ))}
        </div>
      </div>

      <div className="section-card">
        <h4>Pricing Configuration</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Base Price (₹) *</label>
            <input type="number" value={pricing.basePrice}
              onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
              placeholder="e.g., 100" className="modern-input" min="0" step="1" />
          </div>
          <div className="form-group">
            <label>Base Distance (km) *</label>
            <input type="number" value={pricing.baseDistance}
              onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
              placeholder="e.g., 15" className="modern-input" min="0" step="0.1" />
          </div>
          <div className="form-group">
            <label>Cost per km (₹) *</label>
            <input type="number" value={pricing.costPerKm}
              onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
              placeholder="e.g., 4" className="modern-input" min="0" step="0.1" />
          </div>
        </div>
        <small className="helper-text">These values are used to calculate fares. Changing them will regenerate the matrix.</small>
      </div>

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('basic')}>← Back</button>
        <button
          className="modern-btn primary"
          onClick={() => {
            if (!selectedRoute) {
              toast.error('Please select a route first');
              return;
            }

            if (fareMatrixUp && fareMatrixUp.length > 0) {
              toast.info('Using existing fare matrix from bus data');
              setActiveTab('matrix');
              return;
            }

            if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
              toast.error('Please fill all pricing fields to generate matrix');
              return;
            }

            const newMatrixUp = generateMatrixForRoute(selectedRoute);
            setFareMatrixUp(newMatrixUp);

            if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
              const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
              setFareMatrixDown(newMatrixDown);
            }

            toast.success('Fare matrix generated with updated pricing!');
            setActiveTab('matrix');
          }}
        >
          {fareMatrixUp && fareMatrixUp.length > 0 ? 'View Fare Matrix →' : 'Generate Fare Matrix →'}
        </button>
      </div>
    </div>
  );

  // ─── renderMatrixTab ───
  const renderMatrixTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Fare Matrix Configuration</h3></div>

      <div className="matrix-info" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#e8f4fd', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#2c7da0' }}>
          💡 You can edit individual prices by clicking on the price fields below.
          {fareMatrixUp && fareMatrixUp.length > 0 && ' The current matrix is loaded from the bus data.'}
        </p>
      </div>

      {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
        <div className="matrix-tabs">
          <button className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('up')}>Up Route</button>
          <button className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('down')}>Down Route</button>
        </div>
      )}

      {activeMatrixTab === 'up' && renderMatrix('up')}
      {activeMatrixTab === 'down' && renderMatrix('down')}

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('route')}>← Back</button>
        <button
          className="modern-btn outline"
          onClick={() => {
            if (!selectedRoute) {
              toast.error('No route selected');
              return;
            }
            if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
              toast.error('Please fill all pricing fields in the Route tab');
              return;
            }
            if (window.confirm('This will regenerate the fare matrix with current pricing. Continue?')) {
              const newMatrixUp = generateMatrixForRoute(selectedRoute);
              setFareMatrixUp(newMatrixUp);
              if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
                const newMatrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
                setFareMatrixDown(newMatrixDown);
              }
              toast.success('Fare matrix regenerated!');
            }
          }}
          style={{ marginRight: '10px' }}
        >
          🔄 Regenerate
        </button>
        <button className="modern-btn primary" onClick={() => setActiveTab('seats')}>Continue →</button>
      </div>
    </div>
  );

  // ─── renderSeatLayoutTab ───
  const renderSeatLayoutTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title"><h3>Seat Layout Configuration</h3></div>

      <div className="section-card">
        <h4>Bus Configuration</h4>
        <div className="config-buttons">
          {availableConfigurations.map(config => (
            <button key={config}
              className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
              onClick={() => {
                setSelectedConfiguration(config);
                setSelectedTemplate(null);
              }}>
              {config}
            </button>
          ))}
        </div>
        {selectedConfiguration && (
          <div className="config-info" style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
            Current configuration: <strong>{selectedConfiguration}</strong>
            {bus?.seatConfiguration?.busType && (
              <span style={{ marginLeft: '10px', color: '#2c7da0' }}>
                (Original: {bus.seatConfiguration.busType})
              </span>
            )}
          </div>
        )}
      </div>

      <div className="section-card">
        <h4>Select Template</h4>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <button className="modern-btn outline" onClick={() => setShowTemplateModal(true)}>
            {selectedTemplate ? 'Change Template' : 'Select Layout Template'}
          </button>
          {selectedTemplate && (
            <span style={{ color: 'green', fontWeight: '500' }}>
              ✓ {selectedTemplate.name} ({selectedTemplate.totalSeats} seats)
            </span>
          )}
        </div>
        {!selectedTemplate && layoutTemplates.length > 0 && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#856404', backgroundColor: '#fff3cd', padding: '10px', borderRadius: '4px' }}>
            ⚠️ Please select a template to configure seats
          </div>
        )}
        {loadingLayouts && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
            Loading templates...
          </div>
        )}
        {layoutTemplates.length === 0 && !loadingLayouts && (
          <div style={{ marginTop: '10px', fontSize: '13px', color: '#dc3545' }}>
            No templates available for this configuration
          </div>
        )}
      </div>

      {selectedTemplate && (
        <div className="section-card">
          <h4>Seat Layout</h4>
          <button className="view-layout-btn" onClick={() => setShowLayoutModal(true)}>
            View / Edit Seats
          </button>
          <div className="seat-summary" style={{ marginTop: '10px' }}>
            <strong>Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || 0}</strong>
            {blockedSeats.length > 0 && (
              <span style={{ marginLeft: '15px', color: '#dc3545' }}>
                Blocked: {blockedSeats.length}
              </span>
            )}
            <button 
              className="auto-number-btn" 
              onClick={autoRenumberSeats}
              style={{ marginLeft: '15px', padding: '4px 12px', fontSize: '12px' }}
            >
              Auto-Number Seats
            </button>
          </div>
        </div>
      )}

      <div className="form-actions">
        <button className="modern-btn outline" onClick={() => setActiveTab('matrix')}>← Back</button>
        <button className="modern-btn primary" onClick={handleUpdateBus} disabled={isSubmitting}>
          {isSubmitting ? 'Updating...' : 'Update Bus'}
        </button>
      </div>
    </div>
  );

  // ─── renderLayoutModal ───
  const renderLayoutModal = () => (
    <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
      <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Configure Seats</h3>
          <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
        </div>
        <div className="modal-body">
          {renderSeatVisualizer()}
          <div className="layout-footer">
            <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );

  // ─── renderTemplateModal ───
  const renderTemplateModal = () => (
    <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
      <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Template</h3>
          <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
        </div>
        <div className="modal-body">
          <div className="templates-grid">
            {layoutTemplates.map(template => (
              <button key={template._id} className="template-card"
                onClick={() => handleSelectTemplate(template)}>
                <h4>{template.name}</h4>
                <div>Config: {template.configuration}</div>
                <div>Seats: {template.totalSeats}</div>
                <div>Type: {template.seatType || 'seat'}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // ─── renderSeatEditModal ───
  const renderSeatEditModal = () => (
    <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
      <div className="modal-content seat-edit-modal" style={{ maxWidth: "500px", maxHeight: "35vh" }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Set Seat Label</h3>
        </div>
        <div className="modal-body">
          <input
            type="text"
            value={tempSeatLabel}
            onChange={(e) => setTempSeatLabel(e.target.value)}
            placeholder="e.g., S1, B1, 1A, etc."
            autoFocus
          />
          <small style={{ display: 'block', marginTop: '5px', color: '#666' }}>
            Current seat number: {editingSeat}
          </small>
        </div>
        <div className="modal-footer three-buttons">
          <button
            className="modal-action-btn disable-btn"
            onClick={() => {
              setActiveSeats(activeSeats.filter(s => s !== editingSeat));
              setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
              setEditingSeat(null);
            }}
          >
            Disable
          </button>
          <button
            className="modal-action-btn block-btn"
            onClick={() => {
              if (!activeSeats.includes(editingSeat)) {
                setActiveSeats([...activeSeats, editingSeat]);
              }
              if (!blockedSeats.includes(editingSeat)) {
                setBlockedSeats([...blockedSeats, editingSeat]);
              }
              if (tempSeatLabel.trim()) {
                setCustomSeatLabels(prev => ({
                  ...prev,
                  [editingSeat]: tempSeatLabel.trim()
                }));
              }
              setEditingSeat(null);
            }}
          >
            Block
          </button>
          <button
            className="modal-action-btn active-btn"
            onClick={() => {
              if (!activeSeats.includes(editingSeat)) {
                setActiveSeats([...activeSeats, editingSeat]);
              }
              setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
              if (tempSeatLabel.trim()) {
                setCustomSeatLabels(prev => ({
                  ...prev,
                  [editingSeat]: tempSeatLabel.trim()
                }));
              }
              setEditingSeat(null);
            }}
          >
            Active
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="modal-overlay modern" onClick={onClose}>
      <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header modern">
          <div className="header-content">
            <h2 className="modal-title">✏️ Edit Bus: {bus?.busNumber} ({bus?.busName})</h2>
            <p className="modal-subtitle">Update bus configuration</p>
          </div>
          <button className="modal-close-btn modern" onClick={onClose}>×</button>
        </div>
        <div className="modal-body modern">
          <ProgressSteps />
          {activeTab === 'basic' && renderBasicInfoTab()}
          {activeTab === 'route' && renderRouteTab()}
          {activeTab === 'matrix' && renderMatrixTab()}
          {activeTab === 'seats' && renderSeatLayoutTab()}
          {error && <div className="error-message modern">{error}</div>}
        </div>
      </div>
      {showLayoutModal && renderLayoutModal()}
      {showTemplateModal && renderTemplateModal()}
      {editingSeat && renderSeatEditModal()}
    </div>
  );
};

export default EditBusModal;